/* tslint:disable */
/* eslint-disable */
/**
 * Euler Stream Sign API
 * Sign Server API Documentation
 *
 * The version of the OpenAPI document: dev
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface Account {
    'day': number;
    'hour': number;
    'minute': number;
    'name': string;
    'webhook_secret': string;
    'max_alerts': number;
    'max_websockets': number;
    'expires_at': string | null;
    'purchased_captcha_credits': number;
    'updated_at': string;
    'created_at': string;
    'id': number;
}
export interface AccountConfig {
    'day': number;
    'hour': number;
    'minute': number;
    'name': string;
    'webhook_secret': string;
    'max_alerts': number;
    'max_websockets': number;
    'expires_at': string | null;
}

export const AccountScopes = {
    NUMBER_MINUS_1: -1,
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_3: 3,
    NUMBER_10: 10,
    NUMBER_11: 11,
    NUMBER_8: 8,
    NUMBER_6: 6,
    NUMBER_12: 12,
    NUMBER_13: 13,
    NUMBER_14: 14,
    NUMBER_15: 15,
    NUMBER_16: 16,
    NUMBER_17: 17,
    NUMBER_18: 18,
} as const;

export type AccountScopes = typeof AccountScopes[keyof typeof AccountScopes];


export interface AccountWithPermissionsSafe {
    'day': number;
    'hour': number;
    'minute': number;
    'name': string;
    'webhook_secret': string;
    'max_alerts': number;
    'max_websockets': number;
    'expires_at': string | null;
    'purchased_captcha_credits': number;
    'updated_at': string;
    'created_at': string;
    'id': number;
    'scopes': Array<AccountScopes>;
}
export interface AccountsTableRequestLimits {
    'day': number;
    'hour': number;
    'minute': number;
}
/**
 * Public, snake_case response shape for an alert.  The gRPC {@link LivePushAlert} model is camelCase; the public API has always exposed alerts in snake_case, so we convert before serializing. Only the field casing is changed here — types and field membership are left as-is.
 */
export interface AlertResponseShape {
    'id': number;
    'account_id': number;
    'alert_creator_id': number;
    'read_only': boolean;
    'enabled': boolean;
    'alert_creator_username': string;
    /**
     * The creator\'s TikTok numeric user id. Unset when the alerts service has not yet resolved it (the gRPC layer carries an empty string in that case).
     */
    'alert_creator_user_id'?: string;
    'created_at': string;
    'updated_at': string;
    /**
     * @deprecated
     */
    'alert_creator_avatar_url'?: string;
    /**
     * @deprecated
     */
    'alert_creator_nickname'?: string;
}
/**
 * Public, snake_case response shape for an alert target.  Mirrors the legacy (`old-schema.json`) target shape as closely as the new gRPC {@link LivePushAlertTarget} model allows: field casing is converted, `metadata` is re-hydrated from the stored JSON string, the unix-ms timestamps are threaded back into ISO `created_at` / `updated_at`, and `alert_creator_id` is coerced to a number.
 */
export interface AlertTargetResponseShape {
    'id': number;
    'account_id': number;
    'alert_id': number;
    'alert_creator_id': number;
    'url': string;
    'metadata': object;
    'last_status': LivePushAlertTargetStatus;
    'format': LivePushAlertTargetFormat;
    'created_at': string;
    'updated_at': string;
}


export interface ApiKey {
    'name': string;
    'value': string;
    'account_id': number;
    'updated_at': string;
    'created_at': string;
    'id': number;
}
export interface ApiKeyConfig {
    'name': string;
    'value': string;
    'account_id': number;
}
export interface AvailableDatesResponse {
    'code': number;
    'message'?: string;
    'dates': Array<string>;
}
export interface AvailableRankingsResponse {
    'code': number;
    'message'?: string;
    /**
     * Construct a type with a set of properties K of type T
     */
    'regions': { [key: string]: RegionOverview; };
}

export const AvailableWebcastRankName = {
    DailyRank: 'DAILY_RANK',
    FansTeamRank: 'FANS_TEAM_RANK',
    SaleRank: 'SALE_RANK',
    RankingLeague: 'RANKING_LEAGUE',
} as const;

export type AvailableWebcastRankName = typeof AvailableWebcastRankName[keyof typeof AvailableWebcastRankName];


export interface CaptchaCreditsResponse {
    'code': number;
    'message'?: string;
    'credits': number;
}
/**
 * Configuration for the alert
 */
export interface CreateAlertRequest {
    'unique_id': string;
}
export interface CreateAlertResponse {
    'code': number;
    'message'?: string;
    'alert'?: AlertResponseShape;
}
export interface CreateAlertTargetPayload {
    'url': string;
    /**
     * Construct a type with a set of properties K of type T
     */
    'metadata'?: { [key: string]: any; };
}
export interface CreateAlertTargetResponse {
    'code': number;
    'message'?: string;
    'target'?: AlertTargetResponseShape;
}
/**
 * The configuration for the JWT
 */
export interface CreateJWTRequest {
    'limits'?: AccountsTableRequestLimits | null;
    'websockets'?: PartialEnabledBooleanConfigJWTConfigurationWebSocketData;
    'expireAfter': number;
    'name'?: string;
    'metadata': JWTConfigurationMetadata;
    'api': PartialEnabledBooleanLimitsAccountsTableRequestLimitsOrNull;
    'cdn'?: PartialEnabledBooleanMatchesStringArrayAccessPermittedBooleanUploadPermittedBoolean;
}
export interface CreateJWTResponse {
    'code': number;
    'message'?: string;
    'token'?: string;
    'config'?: SignedJWTConfiguration;
}
export interface CreateKeyPayload {
    'name': string;
}
export interface CreateKeyResponse {
    'code': number;
    'message'?: string;
    'key'?: ApiKey;
}
export interface DeleteAlertResponse {
    'code': number;
    'message'?: string;
}
export interface DeleteAlertTargetResponse {
    'code': number;
    'message'?: string;
}
export interface DeleteKeyResponse {
    'code': number;
    'message'?: string;
}
export interface ExchangeTokenRequest {
    'client_id': string;
    'client_secret': string;
    'grant_type': ExchangeTokenRequestGrantTypeEnum;
    /**
     * Required for authorization_code grant
     */
    'code'?: string;
    /**
     * Required for authorization_code grant
     */
    'redirect_uri'?: string;
    /**
     * Required for refresh_token grant
     */
    'refresh_token'?: string;
}

export const ExchangeTokenRequestGrantTypeEnum = {
    AuthorizationCode: 'authorization_code',
    RefreshToken: 'refresh_token',
} as const;

export type ExchangeTokenRequestGrantTypeEnum = typeof ExchangeTokenRequestGrantTypeEnum[keyof typeof ExchangeTokenRequestGrantTypeEnum];

export interface GetPublicClientResponse {
    'code': number;
    'message'?: string;
    'client'?: PublicOAuthClientInfo;
}
export interface GetRateLimits {
    'code': number;
    'message'?: string;
    'day'?: RateLimitInfo;
    'hour'?: RateLimitInfo;
    'minute'?: RateLimitInfo;
}
/**
 * Friendly catalog sort options, mapped to the gifts-server enum below.
 */

export const GiftCatalogOrderBy = {
    Price: 'price',
    Name: 'name',
} as const;

export type GiftCatalogOrderBy = typeof GiftCatalogOrderBy[keyof typeof GiftCatalogOrderBy];


/**
 * Per-gift sponsorship progress entry (`data.current_user_progress[giftId]`).
 */
export interface GiftGalleryProgressItem {
    'sponsor_id': number;
    'sponsor_count': number;
    'left_count_to_sponsor': number;
    'current_count': number;
    'can_sponsor': boolean;
}
/**
 * Current sponsor of a gallery gift (`normal_gifts[].sponsor_info`).
 */
export interface GiftGallerySponsorInfo {
    'user_has_optout': boolean;
    'sponsor_id': string;
    'sent_count': number;
    'nickname': string;
    'last_send_time_sec': number;
    'became_sponsor_times': number;
    'avatar_image': string;
    'anchor_has_followed': boolean;
}
export interface GiftOverride {
    'is_displayed_on_panel'?: boolean;
    'is_gallery_gift'?: boolean;
    'gift_sponsor_info'?: GiftOverrideGiftSponsorInfo;
}
export interface GiftOverrideGiftSponsorInfo {
    'current_count': number;
    'can_sponsor': boolean;
    'left_count_to_sponsor': number;
    'sponsor_count': number;
    'sponsor_id': number;
}
export interface HashtagListAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastHashtagListRouteOutput;
}
export interface HostsResponse {
    'code': number;
    'message'?: string;
    'hosts'?: Array<PeerPresence>;
}
export interface IconCaptchaResponse {
    'response': IconsResult | null;
    'cached': boolean;
    'code': number;
    'message'?: string;
}
export interface IconsResult {
    'time_ms': number;
    'points': Array<Point>;
    'label': string;
}
export interface IntrospectRequestBody {
    'token': string;
    'token_type_hint'?: IntrospectRequestBodyTokenTypeHintEnum;
    'client_id': string;
    'client_secret': string;
}

export const IntrospectRequestBodyTokenTypeHintEnum = {
    AccessToken: 'access_token',
    RefreshToken: 'refresh_token',
} as const;

export type IntrospectRequestBodyTokenTypeHintEnum = typeof IntrospectRequestBodyTokenTypeHintEnum[keyof typeof IntrospectRequestBodyTokenTypeHintEnum];

/**
 * RFC 7662 Token Introspection response
 */
export interface IntrospectionResponse {
    'active': boolean;
    'scope'?: string;
    'client_id'?: string;
    'token_type'?: IntrospectionResponseTokenTypeEnum;
    'exp'?: number;
    'iat'?: number;
    'sub'?: string;
}

export const IntrospectionResponseTokenTypeEnum = {
    Bearer: 'Bearer',
} as const;

export type IntrospectionResponseTokenTypeEnum = typeof IntrospectionResponseTokenTypeEnum[keyof typeof IntrospectionResponseTokenTypeEnum];

export interface JSONResponse {
    'code': number;
    'message'?: string;
}
export interface JWTConfiguration {
    'metadata': JWTConfigurationMetadata;
    'api': PartialEnabledBooleanLimitsAccountsTableRequestLimitsOrNull;
    'websockets'?: PartialEnabledBooleanConfigJWTConfigurationWebSocketData;
    'cdn'?: PartialEnabledBooleanMatchesStringArrayAccessPermittedBooleanUploadPermittedBoolean;
}
export interface JWTConfigurationMetadata {
    /**
     * Construct a type with a set of properties K of type T
     */
    'extra'?: { [key: string]: RecordStringStringOrNumberValue; };
    'name'?: string;
    'version': JWTConfigurationVersion;
    'expireAfter': number;
}



export const JWTConfigurationVersion = {
    V1: 'v1',
    V2: 'v2',
} as const;

export type JWTConfigurationVersion = typeof JWTConfigurationVersion[keyof typeof JWTConfigurationVersion];


export interface JWTConfigurationWebSocketData {
    'oauthToken'?: string;
    'ttTargetIdc'?: string;
    'sessionId'?: string;
    'allowedCreators': Array<string> | null;
    'maxWebSockets': number;
}
export interface LeaderboardResponse {
    'code': number;
    'message'?: string;
    'ts'?: string;
    'date'?: string;
    'region'?: string;
    'rank_name'?: AvailableWebcastRankName;
    'league'?: RankingLeagueName;
    'resets_at'?: string | null;
    'is_latest'?: boolean;
    'ranks'?: Array<LeaderboardRow>;
}


export interface LeaderboardRow {
    'rank': number;
    'score': number;
    'score_description': string;
    'user': LeaderboardRowUser;
}
export interface LeaderboardRowUser {
    'numeric_id': string;
    'unique_id': string;
    'nickname': string;
    'avatar_url': string;
    'follower_count': number;
    'following_count': number;
    'region': string;
}
export interface LegacyJWTConfiguration {
    'limits'?: AccountsTableRequestLimits | null;
    'websockets'?: JWTConfigurationWebSocketData | null;
    'expireAfter': number;
    'name'?: string;
}
export interface ListAlertTargetsResponse {
    'code': number;
    'message'?: string;
    'targets'?: Array<AlertTargetResponseShape>;
}
export interface ListAlertsResponse {
    'code': number;
    'message'?: string;
    'alerts'?: Array<AlertResponseShape>;
    'hasMore': boolean;
}
export interface ListKeysResponse {
    'code': number;
    'message'?: string;
    'keys'?: Array<ApiKey>;
}
export interface LiveAnalyticsUserInteractionsAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastLiveAnalyticsUserInteractionsRouteOutput;
}
export interface LiveAnalyticsVideoDetailAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastLiveAnalyticsVideoDetailRouteOutput;
}
export interface LiveAnalyticsVideoListAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastLiveAnalyticsVideoListRouteOutput;
}

export const LivePushAlertTargetFormat = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_MINUS_1: -1,
} as const;

export type LivePushAlertTargetFormat = typeof LivePushAlertTargetFormat[keyof typeof LivePushAlertTargetFormat];



export const LivePushAlertTargetStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_4: 4,
    NUMBER_MINUS_1: -1,
} as const;

export type LivePushAlertTargetStatus = typeof LivePushAlertTargetStatus[keyof typeof LivePushAlertTargetStatus];


/**
 * Mute duration in seconds
 */

export const MuteDuration = {
    NUMBER_MINUS_1: -1,
    NUMBER_5: 5,
    NUMBER_30: 30,
    NUMBER_60: 60,
    NUMBER_300: 300,
} as const;

export type MuteDuration = typeof MuteDuration[keyof typeof MuteDuration];


/**
 * An entry of `data.normal_gifts` — a sponsorable gallery gift.
 */
export interface NormalGiftItem {
    'unlighted_image_url': string;
    'swapped': boolean;
    'sponsorship_require_count': number;
    'sponsored': boolean;
    'sponsor_rank': Array<any>;
    'sponsor_info': GiftGallerySponsorInfo;
    'name': string;
    'is_sponsor': boolean;
    'image_url': string;
    'goal_count': number;
    'gift_id': string;
    'gallery_gift_tag_url': string;
    'gallery_gift_tag_type': number;
    'current_sent_count': number;
    'coin_price': number;
    'can_sponsor': boolean;
    /**
     * Construct a type with a set of properties K of type T
     */
    'biz_extra': { [key: string]: any; };
}

export const OAuthClientMode = {
    Dark: 'dark',
    Light: 'light',
    Auto: 'auto',
} as const;

export type OAuthClientMode = typeof OAuthClientMode[keyof typeof OAuthClientMode];


export interface OAuthIntrospectResponse {
    'code': number;
    'message'?: string;
    'data'?: IntrospectionResponse;
    'error'?: TokenErrorResponse;
}
export interface OAuthRevokeResponse {
    'code': number;
    'message'?: string;
    'error'?: TokenErrorResponse;
}

export const OAuthScope = {
    WebcastFetch: 'webcast:fetch',
    WebcastRankings: 'webcast:rankings',
    WebcastBulkLiveCheck: 'webcast:bulk_live_check',
    WebcastUserEarnings: 'webcast:user_earnings',
    WebcastSignUrl: 'webcast:sign_url',
    WebcastChat: 'webcast:chat',
    WebcastMute: 'webcast:mute',
    WebcastBan: 'webcast:ban',
    WebcastComments: 'webcast:comments',
    WebcastModerators: 'webcast:moderators',
    WebcastLiveAnalytics: 'webcast:live_analytics',
    UserConsents: 'user:consents',
    UserInfo: 'user:info',
    WebcastSensitiveWords: 'webcast:sensitive_words',
} as const;

export type OAuthScope = typeof OAuthScope[keyof typeof OAuthScope];


export interface OAuthTokenResponse {
    'code': number;
    'message'?: string;
    'data'?: TokenResponse;
    'error'?: TokenErrorResponse;
}
export interface OAuthUserInfoResponse {
    'code': number;
    'message'?: string;
    'user'?: TikTokOAuthUserInfo;
}
/**
 * Make all properties in T optional
 */
export interface PartialAvatarUrlStringNicknameStringSecUidStringNumericUidStringSignatureStringIsVerifiedBooleanFollowingNumberFollowersNumber {
    'avatar_url'?: string;
    'nickname'?: string;
    'sec_uid'?: string;
    'numeric_uid'?: string;
    'signature'?: string;
    'is_verified'?: boolean;
    'following'?: number;
    'followers'?: number;
}
/**
 * Make all properties in T optional
 */
export interface PartialEnabledBooleanConfigJWTConfigurationWebSocketData {
    'enabled'?: boolean;
    'config'?: JWTConfigurationWebSocketData;
}
/**
 * Make all properties in T optional
 */
export interface PartialEnabledBooleanLimitsAccountsTableRequestLimitsOrNull {
    'enabled'?: boolean;
    'limits'?: AccountsTableRequestLimits;
}
/**
 * Make all properties in T optional
 */
export interface PartialEnabledBooleanMatchesStringArrayAccessPermittedBooleanUploadPermittedBoolean {
    'enabled'?: boolean;
    'matches'?: Array<string>;
    'access_permitted'?: boolean;
    'upload_permitted'?: boolean;
}
/**
 * Make all properties in T optional
 */
export interface PartialSignedUrlStringUserAgentStringBrowserNameStringBrowserVersionStringTokensRecordStringStringRequestHeadersRecordStringStringCookiesRecordStringStringArray {
    'signedUrl'?: string;
    'userAgent'?: string;
    'browserName'?: string;
    'browserVersion'?: string;
    /**
     * Construct a type with a set of properties K of type T
     */
    'tokens'?: { [key: string]: string; };
    /**
     * Construct a type with a set of properties K of type T
     */
    'requestHeaders'?: { [key: string]: string; };
    'cookies'?: Array<{ [key: string]: string; }>;
}
/**
 * Make all properties in T optional
 */
export interface PartialStatusNumberIsLiveBooleanIdStringCoverUrlStringTitleStringStartTimeNumberCurrentViewersNumberTotalViewersNumberHlsPullUrlStringFlvPullUrlStringHlsPullUrlLdStringFlvPullUrlLdString {
    'status'?: number;
    'is_live'?: boolean;
    'id'?: string;
    'cover_url'?: string;
    'title'?: string;
    'start_time'?: number;
    'current_viewers'?: number;
    'total_viewers'?: number;
    'hls_pull_url'?: string;
    'flv_pull_url'?: string;
    'hls_pull_url_ld'?: string;
    'flv_pull_url_ld'?: string;
}
/**
 * Make all properties in T optional
 */
export interface PartialWebcastRegionRankingsOutputRank {
    'rank'?: number;
    'diamonds'?: number;
    'diamonds_description'?: string;
    'room_id'?: string;
    'user'?: PartialWebcastRegionRankingsOutputRankUser;
}
export interface PartialWebcastRegionRankingsOutputRankUser {
    'following_count': number;
    'follower_count': number;
    'nickname': string;
    'numeric_id': string;
    'unique_id': string;
    'avatar_thumb': Array<string>;
}
export interface PeerPresence {
    'lastSeen': number;
    'role': PeerRole;
    'id': string;
    'type': PeerPresenceTypeEnum;
}

export const PeerPresenceTypeEnum = {
    Api: 'api',
    Agent: 'agent',
} as const;

export type PeerPresenceTypeEnum = typeof PeerPresenceTypeEnum[keyof typeof PeerPresenceTypeEnum];


export const PeerRole = {
    Public: 'public',
    Enterprise: 'enterprise',
    Staging: 'staging',
} as const;

export type PeerRole = typeof PeerRole[keyof typeof PeerRole];


export interface PipResponse {
    'code': number;
    'message'?: string;
    'image_url': string;
    'label': string;
    'value': number;
    'unit': string;
}
export interface Pips200Response {
    'code': number;
    'message'?: string;
    'image_url': string;
    'label': string;
    'value': number;
    'unit': string;
}
/**
 * Captcha Server No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)  The version of the OpenAPI document: 0.1   NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech). https://openapi-generator.tech Do not edit the class manually.
 */
export interface Point {
    'x': number;
    'y': number;
}

export const PooledProxyRegion = {
    Us: 'US',
    Gb: 'GB',
    De: 'DE',
    Es: 'ES',
    Be: 'BE',
    Fr: 'FR',
    Ca: 'CA',
    Jp: 'JP',
    Br: 'BR',
    Mx: 'MX',
    Co: 'CO',
    Ar: 'AR',
    Cl: 'CL',
    Au: 'AU',
    Kr: 'KR',
    Pe: 'PE',
    Pl: 'PL',
    Sg: 'SG',
    It: 'IT',
    Id: 'ID',
    Th: 'TH',
    Sa: 'SA',
    Il: 'IL',
    Nl: 'NL',
    Ie: 'IE',
    Pt: 'PT',
    Gr: 'GR',
    At: 'AT',
    Ch: 'CH',
    Hu: 'HU',
    Sk: 'SK',
    Dk: 'DK',
    No: 'NO',
    Se: 'SE',
    Nz: 'NZ',
    Am: 'AM',
    Az: 'AZ',
    Bd: 'BD',
    By: 'BY',
    Bo: 'BO',
    Bg: 'BG',
    Kh: 'KH',
    Cr: 'CR',
    Hr: 'HR',
    Cy: 'CY',
    Cz: 'CZ',
    Do: 'DO',
    Ec: 'EC',
    Eg: 'EG',
    Ee: 'EE',
    Fi: 'FI',
    Ge: 'GE',
    Gt: 'GT',
    Is: 'IS',
    Im: 'IM',
    Jm: 'JM',
    Kz: 'KZ',
    La: 'LA',
    Lv: 'LV',
    Lt: 'LT',
    Lu: 'LU',
    My: 'MY',
    Md: 'MD',
    Ma: 'MA',
    Pk: 'PK',
    Pa: 'PA',
    Ph: 'PH',
    Ro: 'RO',
    Za: 'ZA',
    Lk: 'LK',
    Tw: 'TW',
    Tr: 'TR',
    Ua: 'UA',
    Ae: 'AE',
    Vn: 'VN',
} as const;

export type PooledProxyRegion = typeof PooledProxyRegion[keyof typeof PooledProxyRegion];


export interface PublicOAuthClientInfo {
    'client_id': string;
    'name': string;
    'description': string | null;
    'redirect_uris': Array<string>;
    'supported_scopes': Array<OAuthScope>;
    'theme': string | null;
    'mode': OAuthClientMode | null;
    'logo': string | null;
}


export interface PuzzleCaptchaResponse {
    'response': PuzzleResult | null;
    'cached': boolean;
    'code': number;
    'message'?: string;
}
/**
 * Captcha Server No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)  The version of the OpenAPI document: 0.1   NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech). https://openapi-generator.tech Do not edit the class manually.
 */
export interface PuzzleResult {
    'time_ms': number;
    'x': number;
}

export const RankingLeagueLevel = {
    NUMBER_0: 0,
    NUMBER_100: 100,
    NUMBER_200: 200,
    NUMBER_300: 300,
    NUMBER_400: 400,
    NUMBER_500: 500,
    NUMBER_600: 600,
    NUMBER_700: 700,
    NUMBER_800: 800,
    NUMBER_900: 900,
    NUMBER_1000: 1000,
    NUMBER_1100: 1100,
    NUMBER_1200: 1200,
    NUMBER_1300: 1300,
    NUMBER_1400: 1400,
    NUMBER_1500: 1500,
    NUMBER_1800: 1800,
    NUMBER_1900: 1900,
    NUMBER_2000: 2000,
} as const;

export type RankingLeagueLevel = typeof RankingLeagueLevel[keyof typeof RankingLeagueLevel];



export const RankingLeagueName = {
    None: 'NONE',
    D5: 'D5',
    D4: 'D4',
    D3: 'D3',
    D2: 'D2',
    D1: 'D1',
    C5: 'C5',
    C4: 'C4',
    C3: 'C3',
    C2: 'C2',
    C1: 'C1',
    B5: 'B5',
    B4: 'B4',
    B3: 'B3',
    B2: 'B2',
    B1: 'B1',
    A3: 'A3',
    A2: 'A2',
    A1: 'A1',
} as const;

export type RankingLeagueName = typeof RankingLeagueName[keyof typeof RankingLeagueName];


export interface RateLimitInfo {
    'max': number;
    'remaining': number;
    'reset_at': string | null;
}

export const RateLimitType = {
    Webcast: 'WEBCAST',
    Alerts: 'ALERTS',
    RateLimits: 'RATE_LIMITS',
    Rankings: 'RANKINGS',
} as const;

export type RateLimitType = typeof RateLimitType[keyof typeof RateLimitType];


/**
 * Construct a type with a set of properties K of type T
 */
export interface RecordStreamTypeStringOrUndefined {
    'hls_ld': string;
    'hls_sd': string;
    'flv_ld': string;
    'flv_sd': string;
}
export interface RecordStringBooleanOrNumberValue {
}
export interface RecordStringIsLiveBooleanRoomIdStringOrNullValue {
    'room_id': string;
    'is_live': boolean;
}
export interface RecordStringStringOrNumberValue {
}
export interface RegionOverview {
    'rankings': Array<AvailableWebcastRankName>;
    'leagues': Array<RankingLeagueName>;
}
export interface RetrieveAccountResponse {
    'code': number;
    'message'?: string;
    'account'?: AccountWithPermissionsSafe;
}
export interface RetrieveAgentHostsResponse {
    'code': number;
    'message'?: string;
    'agents': Array<PeerPresence>;
}
export interface RetrieveAlertResponse {
    'code': number;
    'message'?: string;
    'alert'?: AlertResponseShape;
    'creator'?: RetrieveAlertResponseCreator;
}
export interface RetrieveAlertResponseCreator {
    'last_nickname': string | null;
    'last_avatar_url': string | null;
    'room_id': string | null;
    'state_label': string;
    'state': number;
    'unique_id': string;
}
export interface RetrieveBulkLiveCheckPayload {
    'user_numeric_ids': Array<string>;
}
export interface RetrieveBulkLiveCheckPayloadV1 {
    'user_numeric_ids': Array<string>;
    /**
     * @deprecated
     */
    'session_id'?: string;
    /**
     * @deprecated
     */
    'tt_target_idc'?: string;
}
/**
 * The body of the request containing user numeric IDs (e.g. 7602356191083907865).
 */
export interface RetrieveBulkLiveCheckRequest {
    'user_numeric_ids': Array<string>;
    /**
     * @deprecated
     */
    'session_id'?: string;
    /**
     * @deprecated
     */
    'tt_target_idc'?: string;
}
export interface RetrieveBulkLiveCheckResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastIsLiveOutput;
}
export interface RetrieveKeyResponse {
    'code': number;
    'message'?: string;
    'key'?: ApiKey;
}
export interface RetrieveRoomCoverResponse {
    'code': number;
    'message'?: string;
    'cover_url'?: string;
}
export interface RetrieveRoomVideoResponse {
    'code': number;
    'message'?: string;
    'pullMap'?: RecordStreamTypeStringOrUndefined;
}
export interface RetrieveTikTokUserBasicResponse {
    'code': number;
    'message'?: string;
    'user'?: TikTokUserBasicUser;
}
export interface RetrieveTikTokUserInfoResponse {
    'code': number;
    'message'?: string;
    'user'?: TikTokUserInfoById;
}
export interface RetrieveTikTokVideoBasicResponse {
    'code': number;
    'message'?: string;
    'video'?: TikTokVideoBasicVideo;
    'author'?: TikTokVideoBasicAuthor;
}
export interface RetrieveWebSocketRouteResponse {
    'code': number;
    'message'?: string;
    'state'?: WebSocketState;
}
export interface RetrieveWebSocketState429Response {
    'code': number;
    'message': string;
}
export interface RetrieveWebSocketsRouteResponse {
    'code': number;
    'message'?: string;
    'webSocketIds'?: Array<string>;
    'connections'?: number;
}
export interface RetrieveWebcastAnchorEventsResponse {
    'code': number;
    'message'?: string;
    'events'?: Array<WebcastEventListItem>;
    'has_more'?: boolean;
    'page'?: number;
}
export interface RetrieveWebcastEventResponse {
    'code': number;
    'message'?: string;
    'event'?: WebcastEvent;
}
export interface RevokeRequestBody {
    'token': string;
    'token_type_hint'?: RevokeRequestBodyTokenTypeHintEnum;
    'client_id': string;
    'client_secret': string;
}

export const RevokeRequestBodyTokenTypeHintEnum = {
    AccessToken: 'access_token',
    RefreshToken: 'refresh_token',
} as const;

export type RevokeRequestBodyTokenTypeHintEnum = typeof RevokeRequestBodyTokenTypeHintEnum[keyof typeof RevokeRequestBodyTokenTypeHintEnum];

export interface RoomAddSensitiveWordAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastRoomAddSensitiveWordRouteOutput;
}
export interface RoomAdminUpdateAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastRoomAdminUpdateRouteOutput;
}
export interface RoomCommentsToggleAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastRoomCommentsToggleRouteOutput;
}
export interface RoomDelSensitiveWordAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastRoomDelSensitiveWordRouteOutput;
}
export interface RoomGetSensitiveWordsAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastRoomGetSensitiveWordRouteOutput;
}
export interface RoomGiftsResponse {
    'code': number;
    'message'?: string;
    'response'?: RoomGiftsResult;
}
export interface RoomGiftsResult {
    'room_id': string;
    'page_gifts': Array<number>;
    /**
     * Construct a type with a set of properties K of type T
     */
    'gift_overrides': { [key: string]: GiftOverride; };
    /**
     * Construct a type with a set of properties K of type T
     */
    'panel_refresh_data'?: { [key: string]: any; };
}
export interface RoomKickUserAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastRoomKickUserRouteOutput;
}
export interface RoomKickedUsersAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastRoomKickedUsersRouteOutput;
}
export interface RoomModeratorsAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastRoomAdminListRouteOutput;
}
export interface RoomMuteUserAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastRoomMuteUserRouteOutput;
}
export interface RoomMutedUsersAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastRoomMutedUsersRouteOutput;
}
export interface RoomUnkickUserAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastRoomUnkickUserRouteOutput;
}
export interface RoomUnmuteUserAPIResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastRoomUnmuteUserRouteOutput;
}
/**
 * Where a scraped image URL should be served from. Selected per-request via the `x-image-source` header. Defaults to {@link RouteImageSource.ORIGIN}.
 */

export const RouteImageSource = {
    Origin: 'ORIGIN',
    Cdn: 'CDN',
    CdnCname: 'CDN_CNAME',
} as const;

export type RouteImageSource = typeof RouteImageSource[keyof typeof RouteImageSource];


export interface SearchUserResponse {
    'code': number;
    'message'?: string;
    'results': Array<SearchUserResult>;
}
export interface SearchUserResult {
    'user': LeaderboardRowUser;
    'last_seen': string;
}
/**
 * The payload configuration for sending a chat
 */
export interface SendRoomChatRequest {
    /**
     * The chat message content to send
     */
    'content': string;
    /**
     * @deprecated
     */
    'targetRoomId'?: string;
    /**
     * The username of the room to send the chat to (either this or targetRoomId is required). Pass room_id = 0 to parameter for this to work.
     */
    'targetUniqueId'?: string;
    /**
     * @deprecated
     */
    'sessionId'?: string;
    /**
     * @deprecated
     */
    'ttTargetIdc'?: string;
    /**
     * @deprecated
     */
    'roomId'?: string;
}
export interface ShapesCaptchaResponse {
    'response': ShapesResult | null;
    'cached': boolean;
    'code': number;
    'message'?: string;
}
export interface ShapesResult {
    'time_ms': number;
    'point_1': Point;
    'point_2': Point;
}
export interface SignTikTokUrlBody {
    'url': string;
    'userAgent'?: string;
    'method'?: SignTikTokUrlBodyMethodEnum;
    'sessionId'?: string;
    'ttTargetIdc'?: string;
    'ttwid'?: string;
    'payload'?: string;
    'type'?: SignTikTokUrlBodyTypeEnum;
    'includeBrowserParams'?: boolean;
    'includeVerifyFp'?: boolean;
}

export const SignTikTokUrlBodyMethodEnum = {
    Get: 'GET',
    Post: 'POST',
    Options: 'OPTIONS',
    Put: 'PUT',
    Delete: 'DELETE',
    Patch: 'PATCH',
    Head: 'HEAD',
} as const;

export type SignTikTokUrlBodyMethodEnum = typeof SignTikTokUrlBodyMethodEnum[keyof typeof SignTikTokUrlBodyMethodEnum];
export const SignTikTokUrlBodyTypeEnum = {
    Fetch: 'fetch',
    Xhr: 'xhr',
} as const;

export type SignTikTokUrlBodyTypeEnum = typeof SignTikTokUrlBodyTypeEnum[keyof typeof SignTikTokUrlBodyTypeEnum];

export interface SignTikTokUrlResponse {
    'code': number;
    'message'?: string;
    'response'?: PartialSignedUrlStringUserAgentStringBrowserNameStringBrowserVersionStringTokensRecordStringStringRequestHeadersRecordStringStringCookiesRecordStringStringArray;
}
export interface SignedJWTConfiguration {
    'id': string;
    'expiresAt': number;
    'ttl': number;
    'accountId': number;
    'apiKeyId': number;
    'name': string | null;
    /**
     * Construct a type with a set of properties K of type T
     */
    'extra': { [key: string]: RecordStringStringOrNumberValue; };
    'limits'?: AccountsTableRequestLimits;
    'webSocketData'?: SignedJWTConfigurationWebSocketData;
    'cdn'?: PartialEnabledBooleanMatchesStringArrayAccessPermittedBooleanUploadPermittedBoolean;
}
export interface SignedJWTConfigurationWebSocketData {
    'encryptedOAuthToken'?: string;
    'encryptedTtTargetIdc'?: string;
    'encryptedSessionId'?: string;
    'allowedCreators': Array<string> | null;
    'maxWebSockets': number;
}
export interface SolveResponseIconsResult {
    'response': IconsResult | null;
    'cached': boolean;
    'code': number;
}
export interface SolveResponsePuzzleResult {
    'response': PuzzleResult | null;
    'cached': boolean;
    'code': number;
}
export interface SolveResponseShapesResult {
    'response': ShapesResult | null;
    'cached': boolean;
    'code': number;
}
export interface SolveResponseWhirlResult {
    'response': WhirlResult | null;
    'cached': boolean;
    'code': number;
}

export const StreamType = {
    HlsLd: 'hls_ld',
    HlsSd: 'hls_sd',
    FlvLd: 'flv_ld',
    FlvSd: 'flv_sd',
} as const;

export type StreamType = typeof StreamType[keyof typeof StreamType];


export interface TestAlertTargetResponse {
    'code': number;
    'message'?: string;
    'status'?: LivePushAlertTargetStatus;
    'statusLabel'?: string;
}


/**
 * One gift row from the ClickHouse `tiktok_gifts` ReplacingMergeTree. Mirrors the searchable columns + the JSON `raw` blob (shipped as a UTF-8 JSON string here so consumers can decode lazily without re-encoding through protobuf any-types).
 */
export interface TikTokGiftsServerGift {
    'giftId': number;
    'giftName': string;
    'giftType': number;
    'diamondCount': number;
    'combo': boolean;
    'forLinkMic': boolean;
    'describe': string;
    'duration': string;
    'imageUri': string;
    'updatedAt': string;
}
export interface TikTokLiveUser {
    'raw': TikTokLiveUserRaw;
    'room_info'?: PartialStatusNumberIsLiveBooleanIdStringCoverUrlStringTitleStringStartTimeNumberCurrentViewersNumberTotalViewersNumberHlsPullUrlStringFlvPullUrlStringHlsPullUrlLdStringFlvPullUrlLdString;
    'user'?: TikTokLiveUserUser;
    'unique_id': string;
}
export interface TikTokLiveUserRaw {
    '_note': string;
}
export interface TikTokLiveUserUser {
    'avatar_url'?: string;
    'nickname'?: string;
    'sec_uid'?: string;
    'numeric_uid'?: string;
    'signature'?: string;
    'is_verified'?: boolean;
    'following'?: number;
    'followers'?: number;
    'unique_id': string;
}
export interface TikTokOAuthUserInfo {
    'uid'?: string;
    'secUid'?: string;
    'nickName'?: string;
    'uniqueId'?: string;
    'region'?: string;
    'avatarUrl'?: string;
    'roomId'?: string;
    'hasLivePermission'?: boolean;
    'isPrivateAccount'?: boolean;
}
/**
 * Logical \"client name\" recorded against each request — supplied by the caller via the `metadata.client_name` RPC field. Free-form on the wire, but conventionally one of the values below.
 */

export const TikTokSignLiveClient = {
    TtliveJava: 'ttlive-java',
    TtliveNode: 'ttlive-node',
    TtlivePython: 'ttlive-python',
    TtliveNet: 'ttlive-net',
    TtliveRust: 'ttlive-rust',
    GotiktokLive: 'gotiktok_live',
    TtliveCloudflare: 'ttlive-cloudflare',
    TtliveOther: 'ttlive-other',
    Internal: 'internal',
} as const;

export type TikTokSignLiveClient = typeof TikTokSignLiveClient[keyof typeof TikTokSignLiveClient];


export interface TikTokUserBasicUser {
    'avatar_larger': Array<string>;
    'avatar_medium': Array<string>;
    'avatar_thumb': Array<string>;
    'nickname': string;
    'region': string;
    'unique_id': string;
}
/**
 * Cleaned user profile (deprecated/null/empty fields + author_stats removed). The listed fields are the stable, useful ones; the index signature covers the remaining non-empty fields TikTok returns.
 */
export interface TikTokUserInfoById {
    [key: string]: any;

    'id_str': string;
    'display_id': string;
    'nickname': string;
    'sec_uid': string;
    'bio_description': string;
    'avatar_thumb': TikTokUserInfoByIdImage;
    'avatar_medium': TikTokUserInfoByIdImage;
    'avatar_large': TikTokUserInfoByIdImage;
    'follow_info': TikTokUserInfoByIdFollowInfo;
    'verified': boolean;
    'create_time': number;
    'modify_time': number;
    'status': number;
}
export interface TikTokUserInfoByIdFollowInfo {
    [key: string]: any;

    'follower_count': number;
    'following_count': number;
    'follow_status': number;
}
/**
 * Resolve a TikTok LIVE user\'s profile card from their numeric `target_uid` via the SIGNED `/webcast/user/` endpoint on `webcast.tiktokv.com`. Signed like a normal webcast route (ttwid + X-Bogus/X-Gnarly) and routed through the caller-provided proxy, but does NOT require a session id.  The raw response carries a large `data` object riddled with `deprecated*` placeholders, `author_stats`, and null/empty fields; the route strips those out and returns the cleaned user under `user`.
 */
export interface TikTokUserInfoByIdImage {
    [key: string]: any;

    'uri': string;
    'url_list': Array<string>;
}
export interface TikTokVideoBasicAuthor {
    'nickname': string;
    'unique_id': string;
}
export interface TikTokVideoBasicMusic {
    'id': string;
    'author_nickname': string;
}
export interface TikTokVideoBasicVideo {
    'id': string;
    'thumbnail': string;
    'description': string;
    'hashtags': Array<string>;
    'music': TikTokVideoBasicMusic;
}
export interface TokenErrorResponse {
    'error': string;
    'error_description'?: string;
}
export interface TokenResponse {
    'access_token': string;
    'refresh_token': string;
    'token_type': TokenResponseTokenTypeEnum;
    /**
     * Access token lifetime in seconds
     */
    'expires_in': number;
    /**
     * Refresh token lifetime in seconds
     */
    'refresh_expires_in': number;
    'scopes': Array<OAuthScope>;
}

export const TokenResponseTokenTypeEnum = {
    Bearer: 'Bearer',
} as const;

export type TokenResponseTokenTypeEnum = typeof TokenResponseTokenTypeEnum[keyof typeof TokenResponseTokenTypeEnum];

export interface UpdateKeyPayload {
    'name': string;
}
export interface UpdateKeyResponse {
    'code': number;
    'message'?: string;
    'config'?: ApiKey;
}
export interface UserHistoryPoint {
    'date': string;
    'ts': string;
    'rank': number;
    'score': number;
    'score_description': string;
    'class_type': number;
    'rank_title': string;
}
export interface UserHistoryResponse {
    'code': number;
    'message'?: string;
    'user'?: UserHistoryResponseUser;
    'region'?: string;
    'rank_name'?: AvailableWebcastRankName;
    'history'?: Array<UserHistoryPoint>;
}


export interface UserHistoryResponseUser {
    'avatar_url': string;
    'nickname': string;
    'unique_id': string;
    'numeric_id': string;
}
export interface UserLeaderboardsResponse {
    'code': number;
    'message'?: string;
    'user_numeric_id'?: string;
    'from'?: string;
    'to'?: string;
    /**
     * Construct a type with a set of properties K of type T
     */
    'leaderboards'?: { [key: string]: Array<string>; };
}
export interface ValidateRefreshRequest {
    /**
     * The refresh token to validate
     */
    'refresh_token': string;
    /**
     * The OAuth client ID that issued the token
     */
    'client_id': string;
}
export interface ValidateRefreshResponse {
    'code': number;
    'message'?: string;
    'valid': boolean;
    'scopes'?: Array<OAuthScope>;
    'tiktok_user_id'?: string | null;
    'country_code'?: string | null;
}
export interface WebSocketState {
    'deployment': PeerRole;
    'accountId': number;
    'uniqueId': string;
    'createdAt': number;
    'apiKeyId': number;
    'jwtHasSessionId': boolean;
    'jwtName': string | null;
    'jwtId': string | null;
    'heartbeat': number;
    'wsId': string;
}


export interface WebcastEvent {
    'id': string;
    'start_time': number;
    'duration': number;
    'title': string;
    'desc': string;
    'status': number;
    'host': WebcastEventHost;
    'subscriber_count': number;
    'type': number;
    'enable_update': boolean;
    'has_subscribed': boolean;
    'is_paid_event': boolean;
    'ticket_amount': number;
}
export interface WebcastEventHost {
    'uid': string;
    'short_id': string;
    'nickname': string;
    'signature': string;
    'unique_id': string;
    'sec_uid': string;
    'region': string;
    'avatar_larger': WebcastEventImage;
    'avatar_medium': WebcastEventImage;
    'avatar_thumb': WebcastEventImage;
    'custom_verify': string;
    'enterprise_verify_reason': string;
    'verify_info': string;
    'verification_type': number;
    'follow_status': number;
    'follower_status': number;
    'language': string;
}
/**
 * Look up a single TikTok LIVE event (a scheduled/subscription stream) by its `event_id` via the unsigned `/tiktok/event/get/v1` endpoint on `webcast.tiktok.com`. No cookies and no signature are required; every query param is a baked-in constant except `event_id` and a generated `device_id`.  The request is routed through the caller-provided proxy (the route does not self-select one). Success is signalled by a top-level `status_code === 0` with an `event` payload.
 */
export interface WebcastEventImage {
    'uri': string;
    'url_list': Array<string>;
    'width': number;
    'height': number;
    'url_prefix': string | null;
}
/**
 * List the scheduled/live events for a numeric webcast `host_user_id` via the unsigned `/tiktok/event/list/v1` endpoint on `webcast.tiktok.com`. Unsigned but session-bound — a logged-in user\'s cookie bundle (sessionid) is required for the endpoint to return data.  The route is paginated: `count` is fixed at 20 and the zero-based `page` is translated to an `offset` (offset = page * 20). Use `has_more` on the output to decide whether to request the next page.
 */
export interface WebcastEventListItem {
    'id': string;
    'start_time': number;
    'duration': number;
    'title': string;
    'desc': string;
    'status': number;
    'subscriber_count': number;
    'type': number;
    'enable_update': boolean;
    'has_subscribed': boolean;
    'is_paid_event': boolean;
    'ticket_amount': number;
}
export interface WebcastFeedResponse {
    'status_code': number;
    'extra': WebcastFeedResponseExtra;
    'data': Array<WebcastFeedResponseItem>;
}
export interface WebcastFeedResponseExtra {
    'now': number;
    'unread_extra': string;
    /**
     * Construct a type with a set of properties K of type T
     */
    'banner': { [key: string]: any; };
    'total': number;
    'max_time': number;
    'cost': number;
    'is_backup': number;
    'has_more': boolean;
    'log_pb': WebcastFeedResponseExtraLogPb;
}
export interface WebcastFeedResponseExtraLogPb {
    'impr_id': string;
}
export interface WebcastFeedResponseHashtag {
    'id': number;
    'title': string;
    'image': WebcastFeedResponseRoomDataFeedRoomLabel;
}
export interface WebcastFeedResponseImage {
    'url_list': Array<string>;
    'uri': string;
}
export interface WebcastFeedResponseItem {
    'type': number;
    'rid': string;
    'data': WebcastFeedResponseRoomData;
    /**
     * Construct a type with a set of properties K of type T
     */
    'flare_info': { [key: string]: any; };
    'room_event_tracking': string;
}
export interface WebcastFeedResponseRoomData {
    'id': number;
    'id_str': string;
    'status': number;
    'owner_user_id': number;
    'title': string;
    'user_count': number;
    'client_version': number;
    'cover': WebcastFeedResponseImage;
    'stream_url': WebcastFeedResponseStreamUrl;
    'stats': WebcastFeedResponseRoomDataStats;
    'feed_room_label': WebcastFeedResponseRoomDataFeedRoomLabel;
    'owner': WebcastFeedResponseUser;
    'live_type_third_party'?: boolean;
    /**
     * Construct a type with a set of properties K of type T
     */
    'room_auth': { [key: string]: RecordStringBooleanOrNumberValue; };
    'like_count'?: number;
    'anchor_tab_type': number;
    /**
     * Construct a type with a set of properties K of type T
     */
    'commerce_info': { [key: string]: any; };
    'hashtag'?: WebcastFeedResponseHashtag;
    'live_room_mode'?: number;
    /**
     * Construct a type with a set of properties K of type T
     */
    'stream_url_filtered_info': { [key: string]: any; };
    'square_cover_img'?: WebcastFeedResponseRoomDataSquareCoverImg;
    'rectangle_cover_img'?: WebcastFeedResponseRoomDataFeedRoomLabel;
    'blurred_cover': WebcastFeedResponseRoomDataSquareCoverImg;
    /**
     * Construct a type with a set of properties K of type T
     */
    'multi_stream_url': { [key: string]: any; };
    'game_tag_detail'?: WebcastFeedResponseRoomDataGameTagDetail;
    'taxonomy_tag_info'?: WebcastFeedResponseRoomDataTaxonomyTagInfo;
}
export interface WebcastFeedResponseRoomDataFeedRoomLabel {
    'url_list': Array<string>;
    'uri': string;
    'avg_color': string;
}
export interface WebcastFeedResponseRoomDataGameTagDetail {
    'display_name': string;
    'starling_key': string;
    'game_tag_name': string;
    'game_tag_id': number;
}
export interface WebcastFeedResponseRoomDataSquareCoverImg {
    'url_list': Array<string>;
    'uri': string;
    'avg_color': string;
    'width': number;
    'height': number;
}
export interface WebcastFeedResponseRoomDataStats {
    'comment_count': number;
    'share_count'?: number;
    'enter_count': number;
    /**
     * Construct a type with a set of properties K of type T
     */
    'user_count_composition'?: { [key: string]: any; };
    'total_user': number;
}
export interface WebcastFeedResponseRoomDataTaxonomyTagInfo {
    'level2_tag': string;
    'level1_tag'?: Array<string>;
}
export interface WebcastFeedResponseStreamUrl {
    'rtmp_pull_url': string;
    'flv_pull_url': WebcastFeedResponseStreamUrlFlvPullUrl;
    /**
     * Construct a type with a set of properties K of type T
     */
    'flv_pull_url_params'?: { [key: string]: string; };
    'live_core_sdk_data'?: WebcastFeedResponseStreamUrlLiveCoreSdkData;
    'stream_size_width': number;
    'stream_size_height': number;
}
export interface WebcastFeedResponseStreamUrlFlvPullUrl {
    'SD1'?: string;
    'SD2'?: string;
    'HD1'?: string;
}
export interface WebcastFeedResponseStreamUrlLiveCoreSdkData {
    'pull_data': WebcastFeedResponseStreamUrlLiveCoreSdkDataPullData;
}
export interface WebcastFeedResponseStreamUrlLiveCoreSdkDataPullData {
    'options': WebcastFeedResponseStreamUrlLiveCoreSdkDataPullDataOptions;
    'stream_data': string;
}
export interface WebcastFeedResponseStreamUrlLiveCoreSdkDataPullDataOptions {
    'default_quality': WebcastFeedResponseStreamUrlLiveCoreSdkDataPullDataOptionsDefaultQuality;
}
export interface WebcastFeedResponseStreamUrlLiveCoreSdkDataPullDataOptionsDefaultQuality {
    'sdk_key': string;
    'name': string;
}
export interface WebcastFeedResponseUser {
    'id': number;
    'nickname': string;
    'bio_description'?: string;
    'avatar_thumb': WebcastFeedResponseImage;
    'avatar_medium': WebcastFeedResponseImage;
    'avatar_large': WebcastFeedResponseImage;
    'status': number;
    'modify_time': number;
    'follow_info': WebcastFeedResponseUserFollowInfo;
    /**
     * Construct a type with a set of properties K of type T
     */
    'pay_grade': { [key: string]: any; };
    /**
     * Construct a type with a set of properties K of type T
     */
    'user_attr': { [key: string]: any; };
    'own_room'?: WebcastFeedResponseUserOwnRoom;
    'display_id': string;
    'sec_uid': string;
    'id_str': string;
}
export interface WebcastFeedResponseUserFollowInfo {
    'follower_count': number;
    'following_count': number;
}
export interface WebcastFeedResponseUserOwnRoom {
    'room_ids_str': Array<string>;
    'room_ids': Array<number>;
}
export interface WebcastFeedRouteOutput {
    'data': WebcastFeedResponse;
}
export interface WebcastFeedRouteResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastFeedRouteOutput;
    'region': PooledProxyRegion;
}



export const WebcastFetchPlatform = {
    Mobile: 'mobile',
    Web: 'web',
} as const;

export type WebcastFetchPlatform = typeof WebcastFetchPlatform[keyof typeof WebcastFetchPlatform];


/**
 * Gallery entrance payload. Only the fields we model are typed; the rest of the (large) TikTok response rides through as `any`.
 */
export interface WebcastGiftGalleryData {
    [key: string]: any;

    'normal_gifts': Array<NormalGiftItem>;
    /**
     * Construct a type with a set of properties K of type T
     */
    'current_user_progress'?: { [key: string]: GiftGalleryProgressItem; };
    'current_timestamp': number;
    'current_period_starts_at': number;
    'current_period_ends_at': number;
    'class_type': RankingLeagueLevel;
    'anchor_ranking_league': WebcastGiftGalleryDataAnchorRankingLeagueEnum;
}

export const WebcastGiftGalleryDataAnchorRankingLeagueEnum = {
    ToString: 'toString',
    ToFixed: 'toFixed',
    ToExponential: 'toExponential',
    ToPrecision: 'toPrecision',
    ValueOf: 'valueOf',
    ToLocaleString: 'toLocaleString',
} as const;

export type WebcastGiftGalleryDataAnchorRankingLeagueEnum = typeof WebcastGiftGalleryDataAnchorRankingLeagueEnum[keyof typeof WebcastGiftGalleryDataAnchorRankingLeagueEnum];

export interface WebcastGiftGalleryResponse {
    'code': number;
    'message'?: string;
    'data'?: WebcastGiftGalleryData;
}
export interface WebcastGiftResponse {
    'code': number;
    'message'?: string;
    'gift'?: TikTokGiftsServerGift;
}
export interface WebcastGiftSearchResponse {
    'code': number;
    'message'?: string;
    'gifts'?: Array<TikTokGiftsServerGift>;
}
export interface WebcastGiftcatalogResponse {
    'code': number;
    'message'?: string;
    'gifts'?: Array<TikTokGiftsServerGift>;
    'total'?: number;
    'pageSize'?: number;
    'pageNumber'?: number;
    'totalPages'?: number;
}
export interface WebcastGiftsResponse {
    'code': number;
    'message'?: string;
    'url': string;
}
export interface WebcastHashtagListResponse {
    'data': WebcastHashtagListResponseData;
    'extra': WebcastHashtagListResponseExtra;
    'status_code': number;
}
export interface WebcastHashtagListResponseData {
    'game_hashtag': WebcastHashtagListResponseHashtag;
    'game_tag_list': Array<WebcastHashtagListResponseGameTag>;
    'hashtag': Array<WebcastHashtagListResponseHashtag>;
    'live_studio_hashtag': Array<WebcastHashtagListResponseHashtag>;
    'live_voice_hashtag': Array<WebcastHashtagListResponseHashtag>;
    'third_party_hashtag': Array<WebcastHashtagListResponseHashtag>;
}
export interface WebcastHashtagListResponseExtra {
    'now': number;
}
export interface WebcastHashtagListResponseGameCategory {
    'game_type': number;
    'title': string;
}
export interface WebcastHashtagListResponseGameTag {
    'bundle_id': string;
    'full_name': string;
    'game_category': Array<WebcastHashtagListResponseGameCategory>;
    'gar': Array<any>;
    'hashtag_id': Array<any>;
    'hashtag_list': Array<WebcastHashtagListResponseHashtagSimple>;
    'id': number;
    'is_new_game': boolean;
    'landscape': number;
    'package_name': string;
    'short_name': string;
    'show_name': string;
}
export interface WebcastHashtagListResponseHashtag {
    'id': number;
    'image': WebcastHashtagListResponseImage;
    'namespace': number;
    'title': string;
}
export interface WebcastHashtagListResponseHashtagSimple {
    'id': number;
    'namespace': number;
    'title': string;
}
export interface WebcastHashtagListResponseImage {
    'avg_color': string;
    'height': number;
    'image_type': number;
    'is_animated': boolean;
    'open_web_url': string;
    'uri': string;
    'url_list': Array<string>;
    'width': number;
}
export interface WebcastHashtagListRouteOutput {
    'data': WebcastHashtagListResponse;
}
export interface WebcastIsLiveOutput {
    /**
     * Construct a type with a set of properties K of type T
     */
    'data'?: { [key: string]: RecordStringIsLiveBooleanRoomIdStringOrNullValue; };
}

export const WebcastLanguage = {
    Aa: 'aa',
    Ab: 'ab',
    Af: 'af',
    Ak: 'ak',
    Am: 'am',
    An: 'an',
    Ar: 'ar',
    As: 'as',
    Av: 'av',
    Ay: 'ay',
    Az: 'az',
    Ba: 'ba',
    Be: 'be',
    Bg: 'bg',
    Bh: 'bh',
    Bi: 'bi',
    Bm: 'bm',
    Bn: 'bn',
    Bo: 'bo',
    Br: 'br',
    Bs: 'bs',
    Ca: 'ca',
    Ce: 'ce',
    Ch: 'ch',
    Co: 'co',
    Cr: 'cr',
    Cs: 'cs',
    Cu: 'cu',
    Cv: 'cv',
    Cy: 'cy',
    Da: 'da',
    De: 'de',
    Dv: 'dv',
    Dz: 'dz',
    Ee: 'ee',
    El: 'el',
    En: 'en',
    Eo: 'eo',
    Es: 'es',
    Et: 'et',
    Eu: 'eu',
    Fa: 'fa',
    Ff: 'ff',
    Fi: 'fi',
    Fj: 'fj',
    Fo: 'fo',
    Fr: 'fr',
    Fy: 'fy',
    Ga: 'ga',
    Gd: 'gd',
    Gl: 'gl',
    Gn: 'gn',
    Gu: 'gu',
    Gv: 'gv',
    Ha: 'ha',
    He: 'he',
    Hi: 'hi',
    Ho: 'ho',
    Hr: 'hr',
    Ht: 'ht',
    Hu: 'hu',
    Hy: 'hy',
    Hz: 'hz',
    Ia: 'ia',
    Id: 'id',
    Ie: 'ie',
    Ig: 'ig',
    Ii: 'ii',
    Ik: 'ik',
    Io: 'io',
    Is: 'is',
    It: 'it',
    Iu: 'iu',
    Ja: 'ja',
    Jv: 'jv',
    Ka: 'ka',
    Kg: 'kg',
    Ki: 'ki',
    Kj: 'kj',
    Kk: 'kk',
    Kl: 'kl',
    Km: 'km',
    Kn: 'kn',
    Ko: 'ko',
    Kr: 'kr',
    Ks: 'ks',
    Ku: 'ku',
    Kv: 'kv',
    Kw: 'kw',
    Ky: 'ky',
    La: 'la',
    Lb: 'lb',
    Lg: 'lg',
    Li: 'li',
    Ln: 'ln',
    Lo: 'lo',
    Lt: 'lt',
    Lu: 'lu',
    Lv: 'lv',
    Mg: 'mg',
    Mh: 'mh',
    Mi: 'mi',
    Mk: 'mk',
    Ml: 'ml',
    Mn: 'mn',
    Mr: 'mr',
    Ms: 'ms',
    Mt: 'mt',
    My: 'my',
    Na: 'na',
    Nb: 'nb',
    Nd: 'nd',
    Ne: 'ne',
    Ng: 'ng',
    Nl: 'nl',
    Nn: 'nn',
    No: 'no',
    Nr: 'nr',
    Nv: 'nv',
    Ny: 'ny',
    Oc: 'oc',
    Oj: 'oj',
    Om: 'om',
    Or: 'or',
    Os: 'os',
    Pa: 'pa',
    Pi: 'pi',
    Pl: 'pl',
    Ps: 'ps',
    Pt: 'pt',
    Qu: 'qu',
    Rm: 'rm',
    Rn: 'rn',
    Ro: 'ro',
    Ru: 'ru',
    Rw: 'rw',
    Sa: 'sa',
    Sc: 'sc',
    Sd: 'sd',
    Se: 'se',
    Sg: 'sg',
    Si: 'si',
    Sk: 'sk',
    Sl: 'sl',
    Sm: 'sm',
    Sn: 'sn',
    So: 'so',
    Sq: 'sq',
    Sr: 'sr',
    Ss: 'ss',
    St: 'st',
    Su: 'su',
    Sv: 'sv',
    Sw: 'sw',
    Ta: 'ta',
    Te: 'te',
    Tg: 'tg',
    Th: 'th',
    Ti: 'ti',
    Tk: 'tk',
    Tl: 'tl',
    Tn: 'tn',
    To: 'to',
    Tr: 'tr',
    Ts: 'ts',
    Tt: 'tt',
    Tw: 'tw',
    Ty: 'ty',
    Ug: 'ug',
    Uk: 'uk',
    Ur: 'ur',
    Uz: 'uz',
    Ve: 've',
    Vi: 'vi',
    Vo: 'vo',
    Wa: 'wa',
    Wo: 'wo',
    Xh: 'xh',
    Yi: 'yi',
    Yo: 'yo',
    Za: 'za',
    Zh: 'zh',
    Zu: 'zu',
} as const;

export type WebcastLanguage = typeof WebcastLanguage[keyof typeof WebcastLanguage];


export interface WebcastLiveAnalyticsUserInteractionsResponse {
    'data': WebcastLiveAnalyticsUserInteractionsResponseData;
    'extra': WebcastLiveAnalyticsUserInteractionsResponseExtra;
    'status_code': number;
}
export interface WebcastLiveAnalyticsUserInteractionsResponseComment {
    'content': string;
    'emotes': Array<any>;
    'event_time': number;
    'msg_id': number;
}
export interface WebcastLiveAnalyticsUserInteractionsResponseData {
    'anchor': WebcastLiveAnalyticsUserInteractionsResponseUser;
    'comment_count': number;
    'comment_list': Array<WebcastLiveAnalyticsUserInteractionsResponseComment>;
    'follow_time': number;
    'like_count': number;
    'share_count': number;
    'summary': string;
    'summary_type': number;
    'user': WebcastLiveAnalyticsUserInteractionsResponseUser;
    'watch_duration': number;
}
export interface WebcastLiveAnalyticsUserInteractionsResponseEnigmaInfo {
    'is_enigma_mask_on': boolean;
}
export interface WebcastLiveAnalyticsUserInteractionsResponseExtra {
    'now': number;
}
export interface WebcastLiveAnalyticsUserInteractionsResponseImage {
    'avg_color': string;
    'height': number;
    'image_type': number;
    'is_animated': boolean;
    'open_web_url': string;
    'uri': string;
    'url_list': Array<string>;
    'width': number;
}
export interface WebcastLiveAnalyticsUserInteractionsResponsePayGrade {
    'grade_banner': string;
    'grade_describe': string;
    'grade_icon_list': Array<any>;
    'level': number;
    'name': string;
    'next_name': string;
    'next_privileges': string;
    'score': number;
    'screen_chat_type': number;
    'upgrade_need_consume': number;
}
export interface WebcastLiveAnalyticsUserInteractionsResponseUser {
    'allow_find_by_contacts': boolean;
    'allow_others_download_video': boolean;
    'allow_others_download_when_sharing_video': boolean;
    'allow_share_show_profile': boolean;
    'allow_show_in_gossip': boolean;
    'allow_show_my_action': boolean;
    'allow_strange_comment': boolean;
    'allow_unfollower_comment': boolean;
    'allow_use_linkmic': boolean;
    'avatar_thumb': WebcastLiveAnalyticsUserInteractionsResponseImage;
    'badge_image_list': Array<any>;
    'badge_list': Array<any>;
    'bg_img_url': string;
    'bio_description': string;
    'block_status': number;
    'border_list': Array<any>;
    'comment_restrict': number;
    'commerce_webcast_config_ids': Array<any>;
    'constellation': string;
    'create_time': number;
    'disable_ichat': number;
    'display_id': string;
    'enable_ichat_img': number;
    'enigma_info': WebcastLiveAnalyticsUserInteractionsResponseEnigmaInfo;
    'exp': number;
    'fan_ticket_count': number;
    'fold_stranger_chat': boolean;
    'follow_status': number;
    'ichat_restrict_type': number;
    'id': number;
    'id_str': string;
    'is_anchor_marked': boolean;
    'is_block': boolean;
    'is_follower': boolean;
    'is_following': boolean;
    'is_subscribe': boolean;
    'link_mic_stats': number;
    'media_badge_image_list': Array<any>;
    'mint_type_label': Array<any>;
    'modify_time': number;
    'need_profile_guide': boolean;
    'new_real_time_icons': Array<any>;
    'nickname': string;
    'pay_grade': WebcastLiveAnalyticsUserInteractionsResponsePayGrade;
    'pay_score': number;
    'pay_scores': number;
    'push_comment_status': boolean;
    'push_digg': boolean;
    'push_follow': boolean;
    'push_friend_action': boolean;
    'push_ichat': boolean;
    'push_status': boolean;
    'push_video_post': boolean;
    'push_video_recommend': boolean;
    'real_time_icons': Array<any>;
    'scm_label': string;
    'sec_uid': string;
    'secret': number;
    'share_qrcode_uri': string;
    'special_id': string;
    'status': number;
    'ticket_count': number;
    'top_fans': Array<any>;
    'top_vip_no': number;
    'upcoming_event_list': Array<any>;
    'user_attr': WebcastLiveAnalyticsUserInteractionsResponseUserAttr;
    'user_role': number;
    'verified': boolean;
    'verified_content': string;
    'verified_reason': string;
    'with_car_management_permission': boolean;
    'with_commerce_permission': boolean;
    'with_fusion_shop_entry': boolean;
}
export interface WebcastLiveAnalyticsUserInteractionsResponseUserAttr {
    /**
     * Construct a type with a set of properties K of type T
     */
    'admin_permissions': { [key: string]: any; };
    'has_voting_function': boolean;
    'is_admin': boolean;
    'is_channel_admin': boolean;
    'is_muted': boolean;
    'is_super_admin': boolean;
    'mute_duration': number;
}
export interface WebcastLiveAnalyticsUserInteractionsRouteOutput {
    'data': WebcastLiveAnalyticsUserInteractionsResponse;
}
export interface WebcastLiveAnalyticsVideoDetailResponse {
    'data': WebcastLiveAnalyticsVideoDetailResponseData;
    'extra': WebcastLiveAnalyticsVideoDetailResponseExtra;
    'status_code': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseAnalytics {
    'earnings': WebcastLiveAnalyticsVideoDetailResponseEarnings;
    'interaction': WebcastLiveAnalyticsVideoDetailResponseInteraction;
    'views': WebcastLiveAnalyticsVideoDetailResponseViews;
}
export interface WebcastLiveAnalyticsVideoDetailResponseAverageWatchTime {
    'follower': number;
    'non_follower': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseBehaviorSummary {
    'cohost_summary': WebcastLiveAnalyticsVideoDetailResponseCohostSummary;
    'multi_guest_summary': WebcastLiveAnalyticsVideoDetailResponseMultiGuestSummary;
}
export interface WebcastLiveAnalyticsVideoDetailResponseCohostSummary {
    'cohost_rank': Array<any>;
    'total_anchor': number;
    'total_diamonds': number;
    'total_views': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseCommentsInfo {
    'comment_cnt': number;
    'entry_location': string;
    'show_entry': boolean;
    'sub_title': string;
    'top_users': Array<any>;
}
export interface WebcastLiveAnalyticsVideoDetailResponseData {
    'analytics': WebcastLiveAnalyticsVideoDetailResponseAnalytics;
    'average_watch_time': WebcastLiveAnalyticsVideoDetailResponseAverageWatchTime;
    'behavior_summary': WebcastLiveAnalyticsVideoDetailResponseBehaviorSummary;
    'comments_info': WebcastLiveAnalyticsVideoDetailResponseCommentsInfo;
    'cover_image_url': string;
    'detailed_metrics': WebcastLiveAnalyticsVideoDetailResponseDetailedMetrics;
    'duration': number;
    'end_time': number;
    'is_first_live': boolean;
    'new_analytics': WebcastLiveAnalyticsVideoDetailResponseNewAnalytics;
    'pause_duration': number;
    'start_time': number;
    'title': string;
    'traffic_info': WebcastLiveAnalyticsVideoDetailResponseTrafficInfo;
    'viewer_info': WebcastLiveAnalyticsVideoDetailResponseViewerInfo;
    'views_by_setion': WebcastLiveAnalyticsVideoDetailResponseViewsBySection;
}
export interface WebcastLiveAnalyticsVideoDetailResponseDetailedMetrics {
    'commenter': WebcastLiveAnalyticsVideoDetailResponseFollowerMetric;
    'gifters': WebcastLiveAnalyticsVideoDetailResponseFollowerMetric;
    'viewers': WebcastLiveAnalyticsVideoDetailResponseFollowerMetric;
}
export interface WebcastLiveAnalyticsVideoDetailResponseDiamondsDetails {
    'gift_fan_tickets_percentage': number;
    'multi_guest_fan_tickets_percentage': number;
    'star_comment_fan_tickets_percentage': number;
    'star_comment_qualification': boolean;
}
export interface WebcastLiveAnalyticsVideoDetailResponseEarnings {
    'diamonds': number;
    'diamonds_details': WebcastLiveAnalyticsVideoDetailResponseDiamondsDetails;
    'gifters': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseExtra {
    'now': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseFollowerMetric {
    'follower': number;
    'non_follower': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseInteraction {
    'comment': number;
    'likes': number;
    'new_followers': number;
    'shares': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseMultiGuestSummary {
    'multi_guest_rank': Array<any>;
    'multi_guest_show_type': number;
    'total_diamonds': number;
    'total_duration': number;
    'total_guest': number;
    'total_points': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseNewAnalytics {
    'earnings': WebcastLiveAnalyticsVideoDetailResponseNewEarnings;
    'interaction': WebcastLiveAnalyticsVideoDetailResponseNewInteraction;
    'views': WebcastLiveAnalyticsVideoDetailResponseNewViews;
}
export interface WebcastLiveAnalyticsVideoDetailResponseNewEarnings {
    'diamonds': number;
    'diamonds_details': WebcastLiveAnalyticsVideoDetailResponseDiamondsDetails;
    'last_diamonds': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseNewInteraction {
    'comment': number;
    'gifters': number;
    'last_comment': number;
    'last_gifters': number;
    'last_likes': number;
    'last_new_followers': number;
    'last_shares': number;
    'likes': number;
    'new_followers': number;
    'shares': number;
    'top_interaction': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseNewViews {
    'anchor_live_acu': number;
    'average_watch_time': number;
    'last_anchor_live_acu': number;
    'last_average_watch_time': number;
    'last_three_min_total_views': number;
    'last_top_viewer_count': number;
    'last_total_views': number;
    'last_unique_viewers': number;
    'three_min_total_views': number;
    'top_viewer_count': number;
    'total_views': number;
    'unique_viewers': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseRegionEntry {
    'percent': number;
    'region_name': string;
}
export interface WebcastLiveAnalyticsVideoDetailResponseTrafficConversion {
    'gifters': number;
    'impression_viewers': number;
    'unique_viewers': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseTrafficInfo {
    'total': WebcastLiveAnalyticsVideoDetailResponseTrafficTotal;
    'traffic_conversion': WebcastLiveAnalyticsVideoDetailResponseTrafficConversion;
}
export interface WebcastLiveAnalyticsVideoDetailResponseTrafficTotal {
    'following': number;
    'live_recomm': number;
    'others': number;
    'share': number;
    'video_recomm': number;
    'video_recomm_info': WebcastLiveAnalyticsVideoDetailResponseVideoRecommInfo;
}
export interface WebcastLiveAnalyticsVideoDetailResponseVideoRecommInfo {
    'total_views': number;
    'video_info': Array<any>;
}
export interface WebcastLiveAnalyticsVideoDetailResponseViewerInfo {
    'gift_rank': Array<any>;
    'viewer_portrait': WebcastLiveAnalyticsVideoDetailResponseViewerPortrait;
    'watcher_rank': Array<WebcastLiveAnalyticsVideoDetailResponseWatcherRank>;
}
export interface WebcastLiveAnalyticsVideoDetailResponseViewerPortrait {
    'viewers_age': Array<WebcastLiveAnalyticsVideoDetailResponseViewersAge>;
    'viewers_gender': WebcastLiveAnalyticsVideoDetailResponseViewersGender;
    'viewers_region': WebcastLiveAnalyticsVideoDetailResponseViewersRegion;
}
export interface WebcastLiveAnalyticsVideoDetailResponseViewersAge {
    'age_section': string;
    'percent': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseViewersGender {
    'female_percent': number;
    'male_percent': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseViewersRegion {
    'others': number;
    'top_viewers_region_list': Array<WebcastLiveAnalyticsVideoDetailResponseRegionEntry>;
}
export interface WebcastLiveAnalyticsVideoDetailResponseViews {
    'anchor_live_acu': number;
    'average_watch_time': number;
    'top_viewer_count': number;
    'total_views': number;
    'unique_viewers': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseViewsBySection {
    'following': number;
    'live_recomm': number;
    'others': number;
    'share': number;
    'video_recomm': number;
}
export interface WebcastLiveAnalyticsVideoDetailResponseWatcherRank {
    /**
     * Construct a type with a set of properties K of type T
     */
    'user': { [key: string]: any; };
    'value': number;
}
export interface WebcastLiveAnalyticsVideoDetailRouteOutput {
    'data': WebcastLiveAnalyticsVideoDetailResponse;
}
export interface WebcastLiveAnalyticsVideoListResponse {
    'data': WebcastLiveAnalyticsVideoListResponseData;
    'extra': WebcastLiveAnalyticsVideoListResponseExtra;
    'status_code': number;
}
export interface WebcastLiveAnalyticsVideoListResponseData {
    'total': number;
    'video_list': Array<WebcastLiveAnalyticsVideoListResponseVideo>;
}
export interface WebcastLiveAnalyticsVideoListResponseExtra {
    'now': number;
}
export interface WebcastLiveAnalyticsVideoListResponseVideo {
    'cover': string;
    'diamonds': number;
    'duration': number;
    'end_time': number;
    'new_followers': number;
    'room_id': string;
    'start_time': number;
    'title': string;
    'views': number;
}
export interface WebcastLiveAnalyticsVideoListRouteOutput {
    'data': WebcastLiveAnalyticsVideoListResponse;
}
export interface WebcastRegionRankingsOutput {
    'attempts': number;
    'ranks': Array<PartialWebcastRegionRankingsOutputRank>;
    'rank_title': string | null;
    'rank_type': string | null;
    'resets_at': string | null;
    'resets_in': number | null;
}
export interface WebcastRegionRankingsResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastRegionRankingsOutput;
    'region': PooledProxyRegion;
}


export interface WebcastRoomAddSensitiveWordResponse {
    'data': WebcastRoomAddSensitiveWordResponseData;
    'extra': WebcastRoomAddSensitiveWordResponseExtra;
    'status_code': number;
}
export interface WebcastRoomAddSensitiveWordResponseData {
    'words': Array<{ [key: string]: any; }>;
}
export interface WebcastRoomAddSensitiveWordResponseExtra {
    'now': number;
}
export interface WebcastRoomAddSensitiveWordRouteOutput {
    'data': WebcastRoomAddSensitiveWordResponse;
}
export interface WebcastRoomAdminListResponse {
    'data': Array<WebcastRoomAdminListResponseAdmin>;
    'extra': WebcastRoomAdminListResponseExtra;
    'status_code': number;
}
export interface WebcastRoomAdminListResponseAdmin {
    /**
     * Construct a type with a set of properties K of type T
     */
    'admin_permissions': { [key: string]: number; };
    'avatar_large': WebcastRoomAdminListResponseImage;
    'avatar_thumb': WebcastRoomAdminListResponseImage;
    'display_id': string;
    'id': number;
    'id_str': string;
    'nickname': string;
    'sec_uid': string;
}
export interface WebcastRoomAdminListResponseExtra {
    'now': number;
}
export interface WebcastRoomAdminListResponseImage {
    'avg_color': string;
    'height': number;
    'image_type': number;
    'is_animated': boolean;
    'open_web_url': string;
    'uri': string;
    'url_list': Array<string>;
    'width': number;
}
export interface WebcastRoomAdminListRouteOutput {
    'data': WebcastRoomAdminListResponse;
}
export interface WebcastRoomAdminUpdateResponse {
    /**
     * Construct a type with a set of properties K of type T
     */
    'data': { [key: string]: any; };
    'extra': WebcastRoomAdminUpdateResponseExtra;
    'status_code': number;
}
export interface WebcastRoomAdminUpdateResponseExtra {
    'now': number;
}
export interface WebcastRoomAdminUpdateRouteOutput {
    'data': WebcastRoomAdminUpdateResponse;
}
export interface WebcastRoomChatPayload {
    /**
     * The chat message content to send
     */
    'content': string;
    /**
     * @deprecated
     */
    'targetRoomId'?: string;
    /**
     * The username of the room to send the chat to (either this or targetRoomId is required). Pass room_id = 0 to parameter for this to work.
     */
    'targetUniqueId'?: string;
}
export interface WebcastRoomChatPayloadV1 {
    /**
     * The chat message content to send
     */
    'content': string;
    /**
     * @deprecated
     */
    'targetRoomId'?: string;
    /**
     * The username of the room to send the chat to (either this or targetRoomId is required). Pass room_id = 0 to parameter for this to work.
     */
    'targetUniqueId'?: string;
    /**
     * @deprecated
     */
    'sessionId'?: string;
    /**
     * @deprecated
     */
    'ttTargetIdc'?: string;
    /**
     * @deprecated
     */
    'roomId'?: string;
}
export interface WebcastRoomChatRouteResponse {
    'code': number;
    'message'?: string;
    'data'?: WebcastRoomSendChatResponse;
}
export interface WebcastRoomCommentsToggleResponse {
    /**
     * Construct a type with a set of properties K of type T
     */
    'data': { [key: string]: any; };
    'extra': WebcastRoomCommentsToggleResponseExtra;
    'status_code': number;
}
export interface WebcastRoomCommentsToggleResponseExtra {
    'now': number;
}
export interface WebcastRoomCommentsToggleRouteOutput {
    'data': WebcastRoomCommentsToggleResponse;
}
export interface WebcastRoomDelSensitiveWordResponse {
    /**
     * Construct a type with a set of properties K of type T
     */
    'data': { [key: string]: any; };
    'extra': WebcastRoomAddSensitiveWordResponseExtra;
    'status_code': number;
}
export interface WebcastRoomDelSensitiveWordRouteOutput {
    'data': WebcastRoomDelSensitiveWordResponse;
}
export interface WebcastRoomGetSensitiveWordResponse {
    'data': WebcastRoomAddSensitiveWordResponseData;
    'extra': WebcastRoomAddSensitiveWordResponseExtra;
    'status_code': number;
}
export interface WebcastRoomGetSensitiveWordRouteOutput {
    'data': WebcastRoomGetSensitiveWordResponse;
}
export interface WebcastRoomIdRouteResponse {
    'code': number;
    'message'?: string;
    'ok': boolean;
    'routes_attempted': Array<string>;
    'is_live'?: boolean;
    'room_id'?: string;
    /**
     * Where the room id came from: \"alerts_server\" or the room-info route used.
     */
    'source'?: string;
}
export interface WebcastRoomInfoRouteResponse {
    'code': number;
    'message'?: string;
    'ok': boolean;
    'routes_attempted': Array<string>;
    'data': TikTokLiveUser | null;
}
export interface WebcastRoomKickUserResponse {
    /**
     * Construct a type with a set of properties K of type T
     */
    'data': { [key: string]: any; };
    'extra': WebcastRoomKickUserResponseExtra;
    'status_code': number;
}
export interface WebcastRoomKickUserResponseExtra {
    'now': number;
}
export interface WebcastRoomKickUserRouteOutput {
    'data': WebcastRoomKickUserResponse;
}
export interface WebcastRoomKickedUsersResponse {
    'data': Array<{ [key: string]: any; }>;
    'extra': WebcastRoomKickedUsersResponseExtra;
    'status_code': number;
}
export interface WebcastRoomKickedUsersResponseExtra {
    'has_more': boolean;
    'next_cursor': number;
    'now': number;
    'total': number;
}
export interface WebcastRoomKickedUsersRouteOutput {
    'data': WebcastRoomKickedUsersResponse;
}
export interface WebcastRoomMuteUserResponse {
    'data': WebcastRoomMuteUserResponseData;
    'extra': WebcastRoomMuteUserResponseExtra;
    'status_code': number;
}
export interface WebcastRoomMuteUserResponseData {
    'actual_duration': number;
    'max_count': number;
    'room_id': number;
    'total': number;
    'user_id': number;
}
export interface WebcastRoomMuteUserResponseExtra {
    'now': number;
}
export interface WebcastRoomMuteUserRouteOutput {
    'data': WebcastRoomMuteUserResponse;
}
export interface WebcastRoomMutedUsersResponse {
    'data': Array<WebcastRoomMutedUsersResponseUser>;
    'extra': WebcastRoomMutedUsersResponseExtra;
    'status_code': number;
}
export interface WebcastRoomMutedUsersResponseBadge {
    'OpenWebURL'?: string;
    'combine'?: WebcastRoomMutedUsersResponseBadgeCombine;
    'display': boolean;
    'display_status': number;
    'display_type': number;
    'exhibition_type': number;
    'greyed_by_client': number;
    'is_customized': boolean;
    'position': number;
    'priority_type': number;
    'privilege_log_extra': WebcastRoomMutedUsersResponsePrivilegeLogExtra;
    'scene_type': number;
    'text'?: WebcastRoomMutedUsersResponseBadgeText;
}
export interface WebcastRoomMutedUsersResponseBadgeBackground {
    'background_color_code': string;
    'border_color_code': string;
    'image': WebcastRoomMutedUsersResponseImage;
    'left_side_image': WebcastRoomMutedUsersResponseImage;
}
export interface WebcastRoomMutedUsersResponseBadgeCombine {
    'background': WebcastRoomMutedUsersResponseBadgeBackground;
    'background_auto_mirrored': boolean;
    'background_dark_mode': WebcastRoomMutedUsersResponseBadgeBackground;
    'display_type': number;
    'icon': WebcastRoomMutedUsersResponseImage;
    'icon_auto_mirrored': boolean;
    'multi_guest_show_style': number;
    'personal_card_show_style': number;
    'public_screen_show_style': number;
    'ranklist_online_audience_show_style': number;
    'str': string;
    'text': WebcastRoomMutedUsersResponseBadgeText;
}
export interface WebcastRoomMutedUsersResponseBadgeText {
    'default_pattern': string;
    'display_type'?: number;
    'key': string;
    'pieces': Array<any>;
}
export interface WebcastRoomMutedUsersResponseEnigmaInfo {
    'is_enigma_mask_on': boolean;
}
export interface WebcastRoomMutedUsersResponseExtra {
    'datas': Array<any>;
    'has_more': boolean;
    'max_count': number;
    'next_cursor': number;
    'now': number;
    'total': number;
}
export interface WebcastRoomMutedUsersResponseFollowInfo {
    'follow_status': number;
    'follower_count': number;
    'following_count': number;
    'push_status': number;
}
export interface WebcastRoomMutedUsersResponseImage {
    'avg_color': string;
    'height': number;
    'image_type': number;
    'is_animated': boolean;
    'open_web_url': string;
    'uri': string;
    'url_list': Array<string>;
    'width': number;
}
export interface WebcastRoomMutedUsersResponsePayGrade {
    'deprecated20': number;
    'deprecated22': number;
    'deprecated23': number;
    'deprecated24': number;
    'deprecated25': number;
    'deprecated26': number;
    'grade_banner': string;
    'grade_describe': string;
    'grade_icon_list': Array<any>;
    'level': number;
    'name': string;
    'next_name': string;
    'next_privileges': string;
    'score': number;
    'screen_chat_type': number;
    'upgrade_need_consume': number;
}
export interface WebcastRoomMutedUsersResponsePrivilegeLogExtra {
    'data_version': string;
    'end_time': number;
    'level': string;
    'privilege_id': string;
    'privilege_order_id': string;
    'privilege_version': string;
    'start_time': number;
}
export interface WebcastRoomMutedUsersResponseUser {
    'allow_find_by_contacts': boolean;
    'allow_others_download_video': boolean;
    'allow_others_download_when_sharing_video': boolean;
    'allow_share_show_profile': boolean;
    'allow_show_in_gossip': boolean;
    'allow_show_my_action': boolean;
    'allow_strange_comment': boolean;
    'allow_unfollower_comment': boolean;
    'allow_use_linkmic': boolean;
    'avatar_large': WebcastRoomMutedUsersResponseImage;
    'avatar_thumb': WebcastRoomMutedUsersResponseImage;
    'badge_image_list': Array<WebcastRoomMutedUsersResponseImage>;
    'badge_list': Array<WebcastRoomMutedUsersResponseBadge>;
    'bg_img_url': string;
    'bio_description': string;
    'block_status': number;
    'border_list': Array<any>;
    'comment_restrict': number;
    'commerce_webcast_config_ids': Array<any>;
    'constellation': string;
    'create_time': number;
    'disable_ichat': number;
    'display_id': string;
    'enable_ichat_img': number;
    'enigma_info': WebcastRoomMutedUsersResponseEnigmaInfo;
    'exp': number;
    'fan_ticket_count': number;
    'fold_stranger_chat': boolean;
    'follow_info': WebcastRoomMutedUsersResponseFollowInfo;
    'follow_status': number;
    'ichat_restrict_type': number;
    'id': number;
    'id_str': string;
    'is_anchor_marked': boolean;
    'is_block': boolean;
    'is_follower': boolean;
    'is_following': boolean;
    'is_subscribe': boolean;
    'link_mic_stats': number;
    'media_badge_image_list': Array<any>;
    'mint_type_label': Array<any>;
    'modify_time': number;
    'need_profile_guide': boolean;
    'new_real_time_icons': Array<any>;
    'nickname': string;
    'pay_grade': WebcastRoomMutedUsersResponsePayGrade;
    'pay_score': number;
    'pay_scores': number;
    'push_comment_status': boolean;
    'push_digg': boolean;
    'push_follow': boolean;
    'push_friend_action': boolean;
    'push_ichat': boolean;
    'push_status': boolean;
    'push_video_post': boolean;
    'push_video_recommend': boolean;
    'real_time_icons': Array<any>;
    'scm_label': string;
    'sec_uid': string;
    'secret': number;
    'share_qrcode_uri': string;
    'special_id': string;
    'status': number;
    'ticket_count': number;
    'top_fans': Array<any>;
    'top_vip_no': number;
    'upcoming_event_list': Array<any>;
    'user_attr': WebcastRoomMutedUsersResponseUserAttr;
    'user_role': number;
    'verified': boolean;
    'verified_content': string;
    'verified_reason': string;
    'with_car_management_permission': boolean;
    'with_commerce_permission': boolean;
    'with_fusion_shop_entry': boolean;
}
export interface WebcastRoomMutedUsersResponseUserAttr {
    /**
     * Construct a type with a set of properties K of type T
     */
    'admin_permissions': { [key: string]: number; };
    'has_voting_function': boolean;
    'is_admin': boolean;
    'is_channel_admin': boolean;
    'is_muted': boolean;
    'is_super_admin': boolean;
    'mute_duration': number;
}
export interface WebcastRoomMutedUsersRouteOutput {
    'data': WebcastRoomMutedUsersResponse;
}
export interface WebcastRoomSendChatResponse {
    /**
     * Construct a type with a set of properties K of type T
     */
    'data': { [key: string]: any; };
    'extra': WebcastRoomSendChatResponseExtra;
    'status_code': number;
}
export interface WebcastRoomSendChatResponseExtra {
    'now': number;
}
export interface WebcastRoomUnkickUserResponse {
    /**
     * Construct a type with a set of properties K of type T
     */
    'data': { [key: string]: any; };
    'extra': WebcastRoomUnkickUserResponseExtra;
    'status_code': number;
}
export interface WebcastRoomUnkickUserResponseExtra {
    'now': number;
}
export interface WebcastRoomUnkickUserRouteOutput {
    'data': WebcastRoomUnkickUserResponse;
}
export interface WebcastRoomUnmuteUserResponse {
    /**
     * Construct a type with a set of properties K of type T
     */
    'data': { [key: string]: any; };
    'extra': WebcastRoomUnmuteUserResponseExtra;
    'status_code': number;
}
export interface WebcastRoomUnmuteUserResponseExtra {
    'now': number;
}
export interface WebcastRoomUnmuteUserRouteOutput {
    'data': WebcastRoomUnmuteUserResponse;
}
export interface WebcastUserEarningsOutput {
    'user': TikTokLiveUser;
    'earnings_estimate_currency': WebcastUserEarningsOutputEarningsEstimateCurrencyEnum | null;
    'earnings_estimate': number | null;
    'diamonds': number | null;
    'period': WebcastUserEarningsOutputPeriod;
    'resets_at': string | null;
    'resets_in': number | null;
}

export const WebcastUserEarningsOutputEarningsEstimateCurrencyEnum = {
    Usd: 'USD',
} as const;

export type WebcastUserEarningsOutputEarningsEstimateCurrencyEnum = typeof WebcastUserEarningsOutputEarningsEstimateCurrencyEnum[keyof typeof WebcastUserEarningsOutputEarningsEstimateCurrencyEnum];


export const WebcastUserEarningsOutputPeriod = {
    Daily: 'daily',
} as const;

export type WebcastUserEarningsOutputPeriod = typeof WebcastUserEarningsOutputPeriod[keyof typeof WebcastUserEarningsOutputPeriod];


export interface WebcastUserEarningsResponse {
    'code': number;
    'message'?: string;
    'response'?: WebcastUserEarningsOutput;
}
export interface WebcastUserIdResponse {
    'code': number;
    'message'?: string;
    'numeric_user_id'?: string;
}
export interface WhirlCaptchaResponse {
    'response': WhirlResult | null;
    'cached': boolean;
    'code': number;
    'message'?: string;
}
/**
 * Captcha Server No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)  The version of the OpenAPI document: 0.1   NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech). https://openapi-generator.tech Do not edit the class manually.
 */
export interface WhirlResult {
    'time_ms': number;
    'angle': number;
}

/**
 * AccountsApi - axios parameter creator
 */
export const AccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the rate limits for the provided API key (or the unauthenticated limits if no key is provided)
         * @param {RateLimitType} [type] Which set of rate limits to retrieve. Defaults to the webcast (account) limits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateLimits: async (type?: RateLimitType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/accounts/me/rate_limits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve an account from the Sign API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAccountSelf: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/accounts/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountsApi - functional programming interface
 */
export const AccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the rate limits for the provided API key (or the unauthenticated limits if no key is provided)
         * @param {RateLimitType} [type] Which set of rate limits to retrieve. Defaults to the webcast (account) limits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRateLimits(type?: RateLimitType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRateLimits>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRateLimits(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.getRateLimits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve an account from the Sign API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveAccountSelf(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveAccountSelf(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.retrieveAccountSelf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountsApi - factory interface
 */
export const AccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountsApiFp(configuration)
    return {
        /**
         * Retrieve the rate limits for the provided API key (or the unauthenticated limits if no key is provided)
         * @param {RateLimitType} [type] Which set of rate limits to retrieve. Defaults to the webcast (account) limits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateLimits(type?: RateLimitType, options?: RawAxiosRequestConfig): AxiosPromise<GetRateLimits> {
            return localVarFp.getRateLimits(type, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve an account from the Sign API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAccountSelf(options?: RawAxiosRequestConfig): AxiosPromise<RetrieveAccountResponse> {
            return localVarFp.retrieveAccountSelf(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountsApi - object-oriented interface
 */
export class AccountsApi extends BaseAPI {
    /**
     * Retrieve the rate limits for the provided API key (or the unauthenticated limits if no key is provided)
     * @param {RateLimitType} [type] Which set of rate limits to retrieve. Defaults to the webcast (account) limits.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRateLimits(type?: RateLimitType, options?: RawAxiosRequestConfig) {
        return AccountsApiFp(this.configuration).getRateLimits(type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve an account from the Sign API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveAccountSelf(options?: RawAxiosRequestConfig) {
        return AccountsApiFp(this.configuration).retrieveAccountSelf(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnalyticsApi - axios parameter creator
 */
export const AnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the currently connected agents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAgents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the list of API hosts (used for horizontal scaling)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHosts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/hosts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve stats as an SVG
         * @param {string} [labelColour] Specify label colour in SVG
         * @param {string} [valueColour] Specify value colour in SVG
         * @param {number} [hours] The number of hours to retrieve the stat for
         * @param {TikTokSignLiveClient} [client] The client to filter for
         * @param {boolean} [json] Add the ability to retrieve the pip as JSON
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pips: async (labelColour?: string, valueColour?: string, hours?: number, client?: TikTokSignLiveClient, json?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/pips`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (labelColour !== undefined) {
                localVarQueryParameter['labelColour'] = labelColour;
            }

            if (valueColour !== undefined) {
                localVarQueryParameter['valueColour'] = valueColour;
            }

            if (hours !== undefined) {
                localVarQueryParameter['hours'] = hours;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (json !== undefined) {
                localVarQueryParameter['json'] = json;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsApi - functional programming interface
 */
export const AnalyticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the currently connected agents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAgents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveAgentHostsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAgents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.fetchAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the list of API hosts (used for horizontal scaling)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHosts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HostsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHosts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.getHosts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve stats as an SVG
         * @param {string} [labelColour] Specify label colour in SVG
         * @param {string} [valueColour] Specify value colour in SVG
         * @param {number} [hours] The number of hours to retrieve the stat for
         * @param {TikTokSignLiveClient} [client] The client to filter for
         * @param {boolean} [json] Add the ability to retrieve the pip as JSON
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pips(labelColour?: string, valueColour?: string, hours?: number, client?: TikTokSignLiveClient, json?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pips200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pips(labelColour, valueColour, hours, client, json, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.pips']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalyticsApi - factory interface
 */
export const AnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsApiFp(configuration)
    return {
        /**
         * Retrieve the currently connected agents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAgents(options?: RawAxiosRequestConfig): AxiosPromise<RetrieveAgentHostsResponse> {
            return localVarFp.fetchAgents(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the list of API hosts (used for horizontal scaling)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHosts(options?: RawAxiosRequestConfig): AxiosPromise<HostsResponse> {
            return localVarFp.getHosts(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve stats as an SVG
         * @param {string} [labelColour] Specify label colour in SVG
         * @param {string} [valueColour] Specify value colour in SVG
         * @param {number} [hours] The number of hours to retrieve the stat for
         * @param {TikTokSignLiveClient} [client] The client to filter for
         * @param {boolean} [json] Add the ability to retrieve the pip as JSON
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pips(labelColour?: string, valueColour?: string, hours?: number, client?: TikTokSignLiveClient, json?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Pips200Response> {
            return localVarFp.pips(labelColour, valueColour, hours, client, json, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsApi - object-oriented interface
 */
export class AnalyticsApi extends BaseAPI {
    /**
     * Retrieve the currently connected agents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchAgents(options?: RawAxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).fetchAgents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the list of API hosts (used for horizontal scaling)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getHosts(options?: RawAxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).getHosts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve stats as an SVG
     * @param {string} [labelColour] Specify label colour in SVG
     * @param {string} [valueColour] Specify value colour in SVG
     * @param {number} [hours] The number of hours to retrieve the stat for
     * @param {TikTokSignLiveClient} [client] The client to filter for
     * @param {boolean} [json] Add the ability to retrieve the pip as JSON
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pips(labelColour?: string, valueColour?: string, hours?: number, client?: TikTokSignLiveClient, json?: boolean, options?: RawAxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).pips(labelColour, valueColour, hours, client, json, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationApi - axios parameter creator
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a JWT for a given API key. Note that these JWT keys are only valid for the non-authenticated Webcast endpoints. They function to attach the rate limits of the API key to the request for client-sided applications.
         * @param {number} accountId The ID of the account to create the JWT for
         * @param {CreateJWTRequest} createJWTRequest The configuration for the JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJWT: async (accountId: number, createJWTRequest: CreateJWTRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createJWT', 'accountId', accountId)
            // verify required parameter 'createJWTRequest' is not null or undefined
            assertParamExists('createJWT', 'createJWTRequest', createJWTRequest)
            const localVarPath = `/accounts/{account_id}/jwt/create`
                .replace('{account_id}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createJWTRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new API key
         * @param {number} accountId The ID of the account to create the key for
         * @param {CreateKeyPayload} createKeyPayload The configuration for the new key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKey: async (accountId: number, createKeyPayload: CreateKeyPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createKey', 'accountId', accountId)
            // verify required parameter 'createKeyPayload' is not null or undefined
            assertParamExists('createKey', 'createKeyPayload', createKeyPayload)
            const localVarPath = `/accounts/{account_id}/api_keys/create`
                .replace('{account_id}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createKeyPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an API key by its key value, name, or ID
         * @param {number} accountId The ID of the account to delete the key for
         * @param {DeleteKeyDeleteByEnum} deleteBy The API key field to delete by
         * @param {string} deleteParam The API key field value to delete by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteKey: async (accountId: number, deleteBy: DeleteKeyDeleteByEnum, deleteParam: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteKey', 'accountId', accountId)
            // verify required parameter 'deleteBy' is not null or undefined
            assertParamExists('deleteKey', 'deleteBy', deleteBy)
            // verify required parameter 'deleteParam' is not null or undefined
            assertParamExists('deleteKey', 'deleteParam', deleteParam)
            const localVarPath = `/accounts/{account_id}/api_keys/delete`
                .replace('{account_id}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (deleteBy !== undefined) {
                localVarQueryParameter['delete_by'] = deleteBy;
            }

            if (deleteParam !== undefined) {
                localVarQueryParameter['delete_param'] = deleteParam;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve an API key by its key value, name, or ID
         * @param {number} accountId The ID of the account to retrieve the key for
         * @param {string} retrieveParam The API key field value to retrieve by
         * @param {GetKeyRetrieveByEnum} [retrieveBy] The API key field to retrieve by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKey: async (accountId: number, retrieveParam: string, retrieveBy?: GetKeyRetrieveByEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getKey', 'accountId', accountId)
            // verify required parameter 'retrieveParam' is not null or undefined
            assertParamExists('getKey', 'retrieveParam', retrieveParam)
            const localVarPath = `/accounts/{account_id}/api_keys/retrieve`
                .replace('{account_id}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (retrieveBy !== undefined) {
                localVarQueryParameter['retrieve_by'] = retrieveBy;
            }

            if (retrieveParam !== undefined) {
                localVarQueryParameter['retrieve_param'] = retrieveParam;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve an API key by its key value, name, or ID
         * @param {number} accountId The ID of the account to retrieve the key for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKeys: async (accountId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listKeys', 'accountId', accountId)
            const localVarPath = `/accounts/{account_id}/api_keys/list`
                .replace('{account_id}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing API key
         * @param {number} accountId The account to update the key for
         * @param {UpdateKeyUpdateByEnum} updateBy The API key field to update by
         * @param {string} updateParam The API key field value to update by
         * @param {UpdateKeyPayload} updateKeyPayload The new configuration for the key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKey: async (accountId: number, updateBy: UpdateKeyUpdateByEnum, updateParam: string, updateKeyPayload: UpdateKeyPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('updateKey', 'accountId', accountId)
            // verify required parameter 'updateBy' is not null or undefined
            assertParamExists('updateKey', 'updateBy', updateBy)
            // verify required parameter 'updateParam' is not null or undefined
            assertParamExists('updateKey', 'updateParam', updateParam)
            // verify required parameter 'updateKeyPayload' is not null or undefined
            assertParamExists('updateKey', 'updateKeyPayload', updateKeyPayload)
            const localVarPath = `/accounts/{account_id}/api_keys/update`
                .replace('{account_id}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (updateBy !== undefined) {
                localVarQueryParameter['update_by'] = updateBy;
            }

            if (updateParam !== undefined) {
                localVarQueryParameter['update_param'] = updateParam;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateKeyPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a JWT for a given API key. Note that these JWT keys are only valid for the non-authenticated Webcast endpoints. They function to attach the rate limits of the API key to the request for client-sided applications.
         * @param {number} accountId The ID of the account to create the JWT for
         * @param {CreateJWTRequest} createJWTRequest The configuration for the JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJWT(accountId: number, createJWTRequest: CreateJWTRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateJWTResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJWT(accountId, createJWTRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.createJWT']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new API key
         * @param {number} accountId The ID of the account to create the key for
         * @param {CreateKeyPayload} createKeyPayload The configuration for the new key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createKey(accountId: number, createKeyPayload: CreateKeyPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createKey(accountId, createKeyPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.createKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an API key by its key value, name, or ID
         * @param {number} accountId The ID of the account to delete the key for
         * @param {DeleteKeyDeleteByEnum} deleteBy The API key field to delete by
         * @param {string} deleteParam The API key field value to delete by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteKey(accountId: number, deleteBy: DeleteKeyDeleteByEnum, deleteParam: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteKey(accountId, deleteBy, deleteParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.deleteKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve an API key by its key value, name, or ID
         * @param {number} accountId The ID of the account to retrieve the key for
         * @param {string} retrieveParam The API key field value to retrieve by
         * @param {GetKeyRetrieveByEnum} [retrieveBy] The API key field to retrieve by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKey(accountId: number, retrieveParam: string, retrieveBy?: GetKeyRetrieveByEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKey(accountId, retrieveParam, retrieveBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve an API key by its key value, name, or ID
         * @param {number} accountId The ID of the account to retrieve the key for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listKeys(accountId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListKeysResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listKeys(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.listKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing API key
         * @param {number} accountId The account to update the key for
         * @param {UpdateKeyUpdateByEnum} updateBy The API key field to update by
         * @param {string} updateParam The API key field value to update by
         * @param {UpdateKeyPayload} updateKeyPayload The new configuration for the key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateKey(accountId: number, updateBy: UpdateKeyUpdateByEnum, updateParam: string, updateKeyPayload: UpdateKeyPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateKey(accountId, updateBy, updateParam, updateKeyPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.updateKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * Create a JWT for a given API key. Note that these JWT keys are only valid for the non-authenticated Webcast endpoints. They function to attach the rate limits of the API key to the request for client-sided applications.
         * @param {number} accountId The ID of the account to create the JWT for
         * @param {CreateJWTRequest} createJWTRequest The configuration for the JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJWT(accountId: number, createJWTRequest: CreateJWTRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateJWTResponse> {
            return localVarFp.createJWT(accountId, createJWTRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new API key
         * @param {number} accountId The ID of the account to create the key for
         * @param {CreateKeyPayload} createKeyPayload The configuration for the new key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKey(accountId: number, createKeyPayload: CreateKeyPayload, options?: RawAxiosRequestConfig): AxiosPromise<CreateKeyResponse> {
            return localVarFp.createKey(accountId, createKeyPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an API key by its key value, name, or ID
         * @param {number} accountId The ID of the account to delete the key for
         * @param {DeleteKeyDeleteByEnum} deleteBy The API key field to delete by
         * @param {string} deleteParam The API key field value to delete by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteKey(accountId: number, deleteBy: DeleteKeyDeleteByEnum, deleteParam: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteKeyResponse> {
            return localVarFp.deleteKey(accountId, deleteBy, deleteParam, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve an API key by its key value, name, or ID
         * @param {number} accountId The ID of the account to retrieve the key for
         * @param {string} retrieveParam The API key field value to retrieve by
         * @param {GetKeyRetrieveByEnum} [retrieveBy] The API key field to retrieve by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKey(accountId: number, retrieveParam: string, retrieveBy?: GetKeyRetrieveByEnum, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveKeyResponse> {
            return localVarFp.getKey(accountId, retrieveParam, retrieveBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve an API key by its key value, name, or ID
         * @param {number} accountId The ID of the account to retrieve the key for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKeys(accountId: number, options?: RawAxiosRequestConfig): AxiosPromise<ListKeysResponse> {
            return localVarFp.listKeys(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing API key
         * @param {number} accountId The account to update the key for
         * @param {UpdateKeyUpdateByEnum} updateBy The API key field to update by
         * @param {string} updateParam The API key field value to update by
         * @param {UpdateKeyPayload} updateKeyPayload The new configuration for the key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKey(accountId: number, updateBy: UpdateKeyUpdateByEnum, updateParam: string, updateKeyPayload: UpdateKeyPayload, options?: RawAxiosRequestConfig): AxiosPromise<UpdateKeyResponse> {
            return localVarFp.updateKey(accountId, updateBy, updateParam, updateKeyPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * Create a JWT for a given API key. Note that these JWT keys are only valid for the non-authenticated Webcast endpoints. They function to attach the rate limits of the API key to the request for client-sided applications.
     * @param {number} accountId The ID of the account to create the JWT for
     * @param {CreateJWTRequest} createJWTRequest The configuration for the JWT
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createJWT(accountId: number, createJWTRequest: CreateJWTRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).createJWT(accountId, createJWTRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new API key
     * @param {number} accountId The ID of the account to create the key for
     * @param {CreateKeyPayload} createKeyPayload The configuration for the new key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createKey(accountId: number, createKeyPayload: CreateKeyPayload, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).createKey(accountId, createKeyPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an API key by its key value, name, or ID
     * @param {number} accountId The ID of the account to delete the key for
     * @param {DeleteKeyDeleteByEnum} deleteBy The API key field to delete by
     * @param {string} deleteParam The API key field value to delete by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteKey(accountId: number, deleteBy: DeleteKeyDeleteByEnum, deleteParam: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).deleteKey(accountId, deleteBy, deleteParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve an API key by its key value, name, or ID
     * @param {number} accountId The ID of the account to retrieve the key for
     * @param {string} retrieveParam The API key field value to retrieve by
     * @param {GetKeyRetrieveByEnum} [retrieveBy] The API key field to retrieve by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getKey(accountId: number, retrieveParam: string, retrieveBy?: GetKeyRetrieveByEnum, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getKey(accountId, retrieveParam, retrieveBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve an API key by its key value, name, or ID
     * @param {number} accountId The ID of the account to retrieve the key for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listKeys(accountId: number, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).listKeys(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing API key
     * @param {number} accountId The account to update the key for
     * @param {UpdateKeyUpdateByEnum} updateBy The API key field to update by
     * @param {string} updateParam The API key field value to update by
     * @param {UpdateKeyPayload} updateKeyPayload The new configuration for the key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateKey(accountId: number, updateBy: UpdateKeyUpdateByEnum, updateParam: string, updateKeyPayload: UpdateKeyPayload, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).updateKey(accountId, updateBy, updateParam, updateKeyPayload, options).then((request) => request(this.axios, this.basePath));
    }
}

export const DeleteKeyDeleteByEnum = {
    Value: 'value',
    Id: 'id',
} as const;
export type DeleteKeyDeleteByEnum = typeof DeleteKeyDeleteByEnum[keyof typeof DeleteKeyDeleteByEnum];
export const GetKeyRetrieveByEnum = {
    Value: 'value',
    Id: 'id',
} as const;
export type GetKeyRetrieveByEnum = typeof GetKeyRetrieveByEnum[keyof typeof GetKeyRetrieveByEnum];
export const UpdateKeyUpdateByEnum = {
    Value: 'value',
    Id: 'id',
} as const;
export type UpdateKeyUpdateByEnum = typeof UpdateKeyUpdateByEnum[keyof typeof UpdateKeyUpdateByEnum];


/**
 * TikTokCaptchasApi - axios parameter creator
 */
export const TikTokCaptchasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  The icons captcha requires just one image & a prompt string.  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/icon.png\" alt=\"Icons Captcha Example\" width=\"480\" />  ## Usage  The `prompt` is the text prompt provided by TikTok. The Icon captcha solution is provided as a list of points, where each point marks a location on the image that needs to be clicked. These points are expressed as ratios relative to the image\'s width and height. A point of (0.0, 0.0) corresponds to the image’s upper-left corner, while (1.0, 1.0) represents the lower-right corner. For reference, (0.5, 0.5) sits at the exact center.  The captcha image selector is `.captcha-verify-image`
         * @param {string} prompt The prompt string provided by TikTok
         * @param {File} captchaImage The uploaded image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeIconCaptcha: async (prompt: string, captchaImage: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prompt' is not null or undefined
            assertParamExists('completeIconCaptcha', 'prompt', prompt)
            // verify required parameter 'captchaImage' is not null or undefined
            assertParamExists('completeIconCaptcha', 'captchaImage', captchaImage)
            const localVarPath = `/tiktok/captchas/icons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (prompt !== undefined) {
                localVarQueryParameter['prompt'] = prompt;
            }


            if (captchaImage !== undefined) { 
                localVarFormParams.append('captchaImage', captchaImage as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The puzzle captcha requires two images  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/puzzle.png\" alt=\"Puzzle Piece Example\" width=\"480\" />  ## Usage  The solution to the puzzle captcha is the distance to move the slider to fit the puzzle piece into the background.  The `backgroundImage` is the full background image with the missing piece. The `pieceImage` is the small puzzle piece that needs to be fit into the background.  The captcha image selectors are: - Background: `.captcha-verify-image` - Piece: `#captcha-verify-image ~ div.cap-absolute > img`  The solution is the `x` proportion (0-1) of the width of the background image where the piece fits. It is 1:1 with the slider distance proportion.
         * @param {File} backgroundImage The uploaded background image file
         * @param {File} pieceImage The uploaded puzzle piece image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePuzzleCaptcha: async (backgroundImage: File, pieceImage: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'backgroundImage' is not null or undefined
            assertParamExists('completePuzzleCaptcha', 'backgroundImage', backgroundImage)
            // verify required parameter 'pieceImage' is not null or undefined
            assertParamExists('completePuzzleCaptcha', 'pieceImage', pieceImage)
            const localVarPath = `/tiktok/captchas/puzzle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)


            if (backgroundImage !== undefined) { 
                localVarFormParams.append('backgroundImage', backgroundImage as any);
            }

            if (pieceImage !== undefined) { 
                localVarFormParams.append('pieceImage', pieceImage as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The shapes captcha requires just one image.  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/threed.png\" alt=\"Shapes Captcha Example\" width=\"480\" />  ## Usage  The solution to the shapes captcha are two points that need to be clicked. To use it in the GUI, convert the proportions to pixel values based on the image size.  The `points` are returned as `x` and `y` proportions (0-1) of the width and height of the source image. The captcha image selector is `.captcha-verify-image`
         * @param {File} shapesCaptchaImage The uploaded image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeShapesCaptcha: async (shapesCaptchaImage: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shapesCaptchaImage' is not null or undefined
            assertParamExists('completeShapesCaptcha', 'shapesCaptchaImage', shapesCaptchaImage)
            const localVarPath = `/tiktok/captchas/shapes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)


            if (shapesCaptchaImage !== undefined) { 
                localVarFormParams.append('shapesCaptchaImage', shapesCaptchaImage as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The whirl captcha requires two images: the outer image and the inner image.  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/rotate.png\" alt=\"Whirl Captcha Example\" width=\"480\" />  ## Usage  The solution to the whirl captcha is an angle from 0-360. To use it in the GUI, it must be converted to a slider distance:  `px = ((sidebar_length - icon_length) * angle) / 360`  - `sidebar_length` is the width of `.captcha_verify_slide--slidebar` - `icon_length` is the width of `.secsdk-captcha-drag-icon`
         * @param {File} outerImage The outer image file
         * @param {File} innerImage The inner image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeWhirlCaptcha: async (outerImage: File, innerImage: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'outerImage' is not null or undefined
            assertParamExists('completeWhirlCaptcha', 'outerImage', outerImage)
            // verify required parameter 'innerImage' is not null or undefined
            assertParamExists('completeWhirlCaptcha', 'innerImage', innerImage)
            const localVarPath = `/tiktok/captchas/whirl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)


            if (outerImage !== undefined) { 
                localVarFormParams.append('outerImage', outerImage as any);
            }

            if (innerImage !== undefined) { 
                localVarFormParams.append('innerImage', innerImage as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the rate limits for the provided API key.  This route is deprecated as CAPTCHAs are no longer billed for usage.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        retrieveCaptchaCredits: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tiktok/captchas/credits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokCaptchasApi - functional programming interface
 */
export const TikTokCaptchasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokCaptchasApiAxiosParamCreator(configuration)
    return {
        /**
         *  The icons captcha requires just one image & a prompt string.  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/icon.png\" alt=\"Icons Captcha Example\" width=\"480\" />  ## Usage  The `prompt` is the text prompt provided by TikTok. The Icon captcha solution is provided as a list of points, where each point marks a location on the image that needs to be clicked. These points are expressed as ratios relative to the image\'s width and height. A point of (0.0, 0.0) corresponds to the image’s upper-left corner, while (1.0, 1.0) represents the lower-right corner. For reference, (0.5, 0.5) sits at the exact center.  The captcha image selector is `.captcha-verify-image`
         * @param {string} prompt The prompt string provided by TikTok
         * @param {File} captchaImage The uploaded image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeIconCaptcha(prompt: string, captchaImage: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IconCaptchaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeIconCaptcha(prompt, captchaImage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokCaptchasApi.completeIconCaptcha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The puzzle captcha requires two images  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/puzzle.png\" alt=\"Puzzle Piece Example\" width=\"480\" />  ## Usage  The solution to the puzzle captcha is the distance to move the slider to fit the puzzle piece into the background.  The `backgroundImage` is the full background image with the missing piece. The `pieceImage` is the small puzzle piece that needs to be fit into the background.  The captcha image selectors are: - Background: `.captcha-verify-image` - Piece: `#captcha-verify-image ~ div.cap-absolute > img`  The solution is the `x` proportion (0-1) of the width of the background image where the piece fits. It is 1:1 with the slider distance proportion.
         * @param {File} backgroundImage The uploaded background image file
         * @param {File} pieceImage The uploaded puzzle piece image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completePuzzleCaptcha(backgroundImage: File, pieceImage: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PuzzleCaptchaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completePuzzleCaptcha(backgroundImage, pieceImage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokCaptchasApi.completePuzzleCaptcha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The shapes captcha requires just one image.  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/threed.png\" alt=\"Shapes Captcha Example\" width=\"480\" />  ## Usage  The solution to the shapes captcha are two points that need to be clicked. To use it in the GUI, convert the proportions to pixel values based on the image size.  The `points` are returned as `x` and `y` proportions (0-1) of the width and height of the source image. The captcha image selector is `.captcha-verify-image`
         * @param {File} shapesCaptchaImage The uploaded image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeShapesCaptcha(shapesCaptchaImage: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShapesCaptchaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeShapesCaptcha(shapesCaptchaImage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokCaptchasApi.completeShapesCaptcha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The whirl captcha requires two images: the outer image and the inner image.  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/rotate.png\" alt=\"Whirl Captcha Example\" width=\"480\" />  ## Usage  The solution to the whirl captcha is an angle from 0-360. To use it in the GUI, it must be converted to a slider distance:  `px = ((sidebar_length - icon_length) * angle) / 360`  - `sidebar_length` is the width of `.captcha_verify_slide--slidebar` - `icon_length` is the width of `.secsdk-captcha-drag-icon`
         * @param {File} outerImage The outer image file
         * @param {File} innerImage The inner image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeWhirlCaptcha(outerImage: File, innerImage: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhirlCaptchaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeWhirlCaptcha(outerImage, innerImage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokCaptchasApi.completeWhirlCaptcha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the rate limits for the provided API key.  This route is deprecated as CAPTCHAs are no longer billed for usage.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async retrieveCaptchaCredits(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaptchaCreditsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveCaptchaCredits(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokCaptchasApi.retrieveCaptchaCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokCaptchasApi - factory interface
 */
export const TikTokCaptchasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokCaptchasApiFp(configuration)
    return {
        /**
         *  The icons captcha requires just one image & a prompt string.  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/icon.png\" alt=\"Icons Captcha Example\" width=\"480\" />  ## Usage  The `prompt` is the text prompt provided by TikTok. The Icon captcha solution is provided as a list of points, where each point marks a location on the image that needs to be clicked. These points are expressed as ratios relative to the image\'s width and height. A point of (0.0, 0.0) corresponds to the image’s upper-left corner, while (1.0, 1.0) represents the lower-right corner. For reference, (0.5, 0.5) sits at the exact center.  The captcha image selector is `.captcha-verify-image`
         * @param {string} prompt The prompt string provided by TikTok
         * @param {File} captchaImage The uploaded image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeIconCaptcha(prompt: string, captchaImage: File, options?: RawAxiosRequestConfig): AxiosPromise<IconCaptchaResponse> {
            return localVarFp.completeIconCaptcha(prompt, captchaImage, options).then((request) => request(axios, basePath));
        },
        /**
         * The puzzle captcha requires two images  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/puzzle.png\" alt=\"Puzzle Piece Example\" width=\"480\" />  ## Usage  The solution to the puzzle captcha is the distance to move the slider to fit the puzzle piece into the background.  The `backgroundImage` is the full background image with the missing piece. The `pieceImage` is the small puzzle piece that needs to be fit into the background.  The captcha image selectors are: - Background: `.captcha-verify-image` - Piece: `#captcha-verify-image ~ div.cap-absolute > img`  The solution is the `x` proportion (0-1) of the width of the background image where the piece fits. It is 1:1 with the slider distance proportion.
         * @param {File} backgroundImage The uploaded background image file
         * @param {File} pieceImage The uploaded puzzle piece image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePuzzleCaptcha(backgroundImage: File, pieceImage: File, options?: RawAxiosRequestConfig): AxiosPromise<PuzzleCaptchaResponse> {
            return localVarFp.completePuzzleCaptcha(backgroundImage, pieceImage, options).then((request) => request(axios, basePath));
        },
        /**
         * The shapes captcha requires just one image.  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/threed.png\" alt=\"Shapes Captcha Example\" width=\"480\" />  ## Usage  The solution to the shapes captcha are two points that need to be clicked. To use it in the GUI, convert the proportions to pixel values based on the image size.  The `points` are returned as `x` and `y` proportions (0-1) of the width and height of the source image. The captcha image selector is `.captcha-verify-image`
         * @param {File} shapesCaptchaImage The uploaded image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeShapesCaptcha(shapesCaptchaImage: File, options?: RawAxiosRequestConfig): AxiosPromise<ShapesCaptchaResponse> {
            return localVarFp.completeShapesCaptcha(shapesCaptchaImage, options).then((request) => request(axios, basePath));
        },
        /**
         * The whirl captcha requires two images: the outer image and the inner image.  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/rotate.png\" alt=\"Whirl Captcha Example\" width=\"480\" />  ## Usage  The solution to the whirl captcha is an angle from 0-360. To use it in the GUI, it must be converted to a slider distance:  `px = ((sidebar_length - icon_length) * angle) / 360`  - `sidebar_length` is the width of `.captcha_verify_slide--slidebar` - `icon_length` is the width of `.secsdk-captcha-drag-icon`
         * @param {File} outerImage The outer image file
         * @param {File} innerImage The inner image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeWhirlCaptcha(outerImage: File, innerImage: File, options?: RawAxiosRequestConfig): AxiosPromise<WhirlCaptchaResponse> {
            return localVarFp.completeWhirlCaptcha(outerImage, innerImage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the rate limits for the provided API key.  This route is deprecated as CAPTCHAs are no longer billed for usage.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        retrieveCaptchaCredits(options?: RawAxiosRequestConfig): AxiosPromise<CaptchaCreditsResponse> {
            return localVarFp.retrieveCaptchaCredits(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokCaptchasApi - object-oriented interface
 */
export class TikTokCaptchasApi extends BaseAPI {
    /**
     *  The icons captcha requires just one image & a prompt string.  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/icon.png\" alt=\"Icons Captcha Example\" width=\"480\" />  ## Usage  The `prompt` is the text prompt provided by TikTok. The Icon captcha solution is provided as a list of points, where each point marks a location on the image that needs to be clicked. These points are expressed as ratios relative to the image\'s width and height. A point of (0.0, 0.0) corresponds to the image’s upper-left corner, while (1.0, 1.0) represents the lower-right corner. For reference, (0.5, 0.5) sits at the exact center.  The captcha image selector is `.captcha-verify-image`
     * @param {string} prompt The prompt string provided by TikTok
     * @param {File} captchaImage The uploaded image file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completeIconCaptcha(prompt: string, captchaImage: File, options?: RawAxiosRequestConfig) {
        return TikTokCaptchasApiFp(this.configuration).completeIconCaptcha(prompt, captchaImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The puzzle captcha requires two images  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/puzzle.png\" alt=\"Puzzle Piece Example\" width=\"480\" />  ## Usage  The solution to the puzzle captcha is the distance to move the slider to fit the puzzle piece into the background.  The `backgroundImage` is the full background image with the missing piece. The `pieceImage` is the small puzzle piece that needs to be fit into the background.  The captcha image selectors are: - Background: `.captcha-verify-image` - Piece: `#captcha-verify-image ~ div.cap-absolute > img`  The solution is the `x` proportion (0-1) of the width of the background image where the piece fits. It is 1:1 with the slider distance proportion.
     * @param {File} backgroundImage The uploaded background image file
     * @param {File} pieceImage The uploaded puzzle piece image file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completePuzzleCaptcha(backgroundImage: File, pieceImage: File, options?: RawAxiosRequestConfig) {
        return TikTokCaptchasApiFp(this.configuration).completePuzzleCaptcha(backgroundImage, pieceImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The shapes captcha requires just one image.  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/threed.png\" alt=\"Shapes Captcha Example\" width=\"480\" />  ## Usage  The solution to the shapes captcha are two points that need to be clicked. To use it in the GUI, convert the proportions to pixel values based on the image size.  The `points` are returned as `x` and `y` proportions (0-1) of the width and height of the source image. The captcha image selector is `.captcha-verify-image`
     * @param {File} shapesCaptchaImage The uploaded image file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completeShapesCaptcha(shapesCaptchaImage: File, options?: RawAxiosRequestConfig) {
        return TikTokCaptchasApiFp(this.configuration).completeShapesCaptcha(shapesCaptchaImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The whirl captcha requires two images: the outer image and the inner image.  ## Example Image <img src=\"https://www.eulerstream.com/_static/captchas/rotate.png\" alt=\"Whirl Captcha Example\" width=\"480\" />  ## Usage  The solution to the whirl captcha is an angle from 0-360. To use it in the GUI, it must be converted to a slider distance:  `px = ((sidebar_length - icon_length) * angle) / 360`  - `sidebar_length` is the width of `.captcha_verify_slide--slidebar` - `icon_length` is the width of `.secsdk-captcha-drag-icon`
     * @param {File} outerImage The outer image file
     * @param {File} innerImage The inner image file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public completeWhirlCaptcha(outerImage: File, innerImage: File, options?: RawAxiosRequestConfig) {
        return TikTokCaptchasApiFp(this.configuration).completeWhirlCaptcha(outerImage, innerImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the rate limits for the provided API key.  This route is deprecated as CAPTCHAs are no longer billed for usage.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public retrieveCaptchaCredits(options?: RawAxiosRequestConfig) {
        return TikTokCaptchasApiFp(this.configuration).retrieveCaptchaCredits(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TikTokGeneralApi - axios parameter creator
 */
export const TikTokGeneralApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Exchange an authorization code or refresh token for access tokens.  For authorization_code grant: - code: The authorization code from /oauth/complete - redirect_uri: Must match the original redirect_uri  For refresh_token grant: - refresh_token: A valid refresh token
         * @param {ExchangeTokenRequest} exchangeTokenRequest Token request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeToken: async (exchangeTokenRequest: ExchangeTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeTokenRequest' is not null or undefined
            assertParamExists('exchangeToken', 'exchangeTokenRequest', exchangeTokenRequest)
            const localVarPath = `/tiktok/oauth/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get public information about an OAuth client by client_id. This endpoint is used during the authorization flow to display client information to the user before they authorize.  Does not require authentication. Does not expose sensitive information like client_secret_hash.
         * @param {string} clientId The OAuth client ID to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicClient: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getPublicClient', 'clientId', clientId)
            const localVarPath = `/tiktok/oauth/clients/{client_id}`
                .replace('{client_id}', encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get information about the currently authenticated TikTok user. Requires a valid OAuth token with an active TikTok session.  **Authentication:** Provide the following header: - `x-oauth-token`: An OAuth access token. [Read More](https://www.eulerstream.com/docs/oauth)
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo: async (xOauthToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tiktok/oauth/userinfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Introspect a token to determine its state (RFC 7662). Returns active: true/false along with token metadata. Works for both access tokens and refresh tokens.
         * @param {IntrospectRequestBody} introspectRequestBody Introspection request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introspectToken: async (introspectRequestBody: IntrospectRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'introspectRequestBody' is not null or undefined
            assertParamExists('introspectToken', 'introspectRequestBody', introspectRequestBody)
            const localVarPath = `/tiktok/oauth/introspect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(introspectRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke an access token or refresh token (RFC 7009). This endpoint always returns success for valid client credentials, even if the token was already revoked or invalid.
         * @param {RevokeRequestBody} revokeRequestBody Revoke request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeToken: async (revokeRequestBody: RevokeRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revokeRequestBody' is not null or undefined
            assertParamExists('revokeToken', 'revokeRequestBody', revokeRequestBody)
            const localVarPath = `/tiktok/oauth/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revokeRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign a non-LIVE TikTok URL. This is NOT available to customers in any public package, and access is approved on a case-by-case basis.
         * @param {SignTikTokUrlBody} signTikTokUrlBody Config for the signature generation
         * @param {string} [client] The TikTokLive client making the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signTikTokUrl: async (signTikTokUrlBody: SignTikTokUrlBody, client?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signTikTokUrlBody' is not null or undefined
            assertParamExists('signTikTokUrl', 'signTikTokUrlBody', signTikTokUrlBody)
            const localVarPath = `/tiktok/sign_url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signTikTokUrlBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if a stored refresh token is still valid without consuming it. Returns metadata about the session if valid.  This is a public endpoint — no authentication required.
         * @param {ValidateRefreshRequest} validateRefreshRequest The refresh token and client ID to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateRefreshToken: async (validateRefreshRequest: ValidateRefreshRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateRefreshRequest' is not null or undefined
            assertParamExists('validateRefreshToken', 'validateRefreshRequest', validateRefreshRequest)
            const localVarPath = `/tiktok/oauth/validate-refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateRefreshRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokGeneralApi - functional programming interface
 */
export const TikTokGeneralApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokGeneralApiAxiosParamCreator(configuration)
    return {
        /**
         * Exchange an authorization code or refresh token for access tokens.  For authorization_code grant: - code: The authorization code from /oauth/complete - redirect_uri: Must match the original redirect_uri  For refresh_token grant: - refresh_token: A valid refresh token
         * @param {ExchangeTokenRequest} exchangeTokenRequest Token request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeToken(exchangeTokenRequest: ExchangeTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeToken(exchangeTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokGeneralApi.exchangeToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get public information about an OAuth client by client_id. This endpoint is used during the authorization flow to display client information to the user before they authorize.  Does not require authentication. Does not expose sensitive information like client_secret_hash.
         * @param {string} clientId The OAuth client ID to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicClient(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPublicClientResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicClient(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokGeneralApi.getPublicClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get information about the currently authenticated TikTok user. Requires a valid OAuth token with an active TikTok session.  **Authentication:** Provide the following header: - `x-oauth-token`: An OAuth access token. [Read More](https://www.eulerstream.com/docs/oauth)
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInfo(xOauthToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthUserInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInfo(xOauthToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokGeneralApi.getUserInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Introspect a token to determine its state (RFC 7662). Returns active: true/false along with token metadata. Works for both access tokens and refresh tokens.
         * @param {IntrospectRequestBody} introspectRequestBody Introspection request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async introspectToken(introspectRequestBody: IntrospectRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthIntrospectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.introspectToken(introspectRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokGeneralApi.introspectToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke an access token or refresh token (RFC 7009). This endpoint always returns success for valid client credentials, even if the token was already revoked or invalid.
         * @param {RevokeRequestBody} revokeRequestBody Revoke request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeToken(revokeRequestBody: RevokeRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OAuthRevokeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeToken(revokeRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokGeneralApi.revokeToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sign a non-LIVE TikTok URL. This is NOT available to customers in any public package, and access is approved on a case-by-case basis.
         * @param {SignTikTokUrlBody} signTikTokUrlBody Config for the signature generation
         * @param {string} [client] The TikTokLive client making the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signTikTokUrl(signTikTokUrlBody: SignTikTokUrlBody, client?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignTikTokUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signTikTokUrl(signTikTokUrlBody, client, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokGeneralApi.signTikTokUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check if a stored refresh token is still valid without consuming it. Returns metadata about the session if valid.  This is a public endpoint — no authentication required.
         * @param {ValidateRefreshRequest} validateRefreshRequest The refresh token and client ID to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateRefreshToken(validateRefreshRequest: ValidateRefreshRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateRefreshResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateRefreshToken(validateRefreshRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokGeneralApi.validateRefreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokGeneralApi - factory interface
 */
export const TikTokGeneralApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokGeneralApiFp(configuration)
    return {
        /**
         * Exchange an authorization code or refresh token for access tokens.  For authorization_code grant: - code: The authorization code from /oauth/complete - redirect_uri: Must match the original redirect_uri  For refresh_token grant: - refresh_token: A valid refresh token
         * @param {ExchangeTokenRequest} exchangeTokenRequest Token request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeToken(exchangeTokenRequest: ExchangeTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<OAuthTokenResponse> {
            return localVarFp.exchangeToken(exchangeTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get public information about an OAuth client by client_id. This endpoint is used during the authorization flow to display client information to the user before they authorize.  Does not require authentication. Does not expose sensitive information like client_secret_hash.
         * @param {string} clientId The OAuth client ID to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicClient(clientId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPublicClientResponse> {
            return localVarFp.getPublicClient(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get information about the currently authenticated TikTok user. Requires a valid OAuth token with an active TikTok session.  **Authentication:** Provide the following header: - `x-oauth-token`: An OAuth access token. [Read More](https://www.eulerstream.com/docs/oauth)
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo(xOauthToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<OAuthUserInfoResponse> {
            return localVarFp.getUserInfo(xOauthToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Introspect a token to determine its state (RFC 7662). Returns active: true/false along with token metadata. Works for both access tokens and refresh tokens.
         * @param {IntrospectRequestBody} introspectRequestBody Introspection request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        introspectToken(introspectRequestBody: IntrospectRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OAuthIntrospectResponse> {
            return localVarFp.introspectToken(introspectRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke an access token or refresh token (RFC 7009). This endpoint always returns success for valid client credentials, even if the token was already revoked or invalid.
         * @param {RevokeRequestBody} revokeRequestBody Revoke request parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeToken(revokeRequestBody: RevokeRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<OAuthRevokeResponse> {
            return localVarFp.revokeToken(revokeRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Sign a non-LIVE TikTok URL. This is NOT available to customers in any public package, and access is approved on a case-by-case basis.
         * @param {SignTikTokUrlBody} signTikTokUrlBody Config for the signature generation
         * @param {string} [client] The TikTokLive client making the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signTikTokUrl(signTikTokUrlBody: SignTikTokUrlBody, client?: string, options?: RawAxiosRequestConfig): AxiosPromise<SignTikTokUrlResponse> {
            return localVarFp.signTikTokUrl(signTikTokUrlBody, client, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if a stored refresh token is still valid without consuming it. Returns metadata about the session if valid.  This is a public endpoint — no authentication required.
         * @param {ValidateRefreshRequest} validateRefreshRequest The refresh token and client ID to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateRefreshToken(validateRefreshRequest: ValidateRefreshRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateRefreshResponse> {
            return localVarFp.validateRefreshToken(validateRefreshRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokGeneralApi - object-oriented interface
 */
export class TikTokGeneralApi extends BaseAPI {
    /**
     * Exchange an authorization code or refresh token for access tokens.  For authorization_code grant: - code: The authorization code from /oauth/complete - redirect_uri: Must match the original redirect_uri  For refresh_token grant: - refresh_token: A valid refresh token
     * @param {ExchangeTokenRequest} exchangeTokenRequest Token request parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exchangeToken(exchangeTokenRequest: ExchangeTokenRequest, options?: RawAxiosRequestConfig) {
        return TikTokGeneralApiFp(this.configuration).exchangeToken(exchangeTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get public information about an OAuth client by client_id. This endpoint is used during the authorization flow to display client information to the user before they authorize.  Does not require authentication. Does not expose sensitive information like client_secret_hash.
     * @param {string} clientId The OAuth client ID to look up
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPublicClient(clientId: string, options?: RawAxiosRequestConfig) {
        return TikTokGeneralApiFp(this.configuration).getPublicClient(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get information about the currently authenticated TikTok user. Requires a valid OAuth token with an active TikTok session.  **Authentication:** Provide the following header: - `x-oauth-token`: An OAuth access token. [Read More](https://www.eulerstream.com/docs/oauth)
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserInfo(xOauthToken?: string, options?: RawAxiosRequestConfig) {
        return TikTokGeneralApiFp(this.configuration).getUserInfo(xOauthToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Introspect a token to determine its state (RFC 7662). Returns active: true/false along with token metadata. Works for both access tokens and refresh tokens.
     * @param {IntrospectRequestBody} introspectRequestBody Introspection request parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public introspectToken(introspectRequestBody: IntrospectRequestBody, options?: RawAxiosRequestConfig) {
        return TikTokGeneralApiFp(this.configuration).introspectToken(introspectRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke an access token or refresh token (RFC 7009). This endpoint always returns success for valid client credentials, even if the token was already revoked or invalid.
     * @param {RevokeRequestBody} revokeRequestBody Revoke request parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revokeToken(revokeRequestBody: RevokeRequestBody, options?: RawAxiosRequestConfig) {
        return TikTokGeneralApiFp(this.configuration).revokeToken(revokeRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign a non-LIVE TikTok URL. This is NOT available to customers in any public package, and access is approved on a case-by-case basis.
     * @param {SignTikTokUrlBody} signTikTokUrlBody Config for the signature generation
     * @param {string} [client] The TikTokLive client making the request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public signTikTokUrl(signTikTokUrlBody: SignTikTokUrlBody, client?: string, options?: RawAxiosRequestConfig) {
        return TikTokGeneralApiFp(this.configuration).signTikTokUrl(signTikTokUrlBody, client, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if a stored refresh token is still valid without consuming it. Returns metadata about the session if valid.  This is a public endpoint — no authentication required.
     * @param {ValidateRefreshRequest} validateRefreshRequest The refresh token and client ID to validate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateRefreshToken(validateRefreshRequest: ValidateRefreshRequest, options?: RawAxiosRequestConfig) {
        return TikTokGeneralApiFp(this.configuration).validateRefreshToken(validateRefreshRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TikTokLIVEApi - axios parameter creator
 */
export const TikTokLIVEApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * A bulk-check endpoint to determine if a group of TikTok users (up to 50 at once) are live. It uses a highly optimized job-based system for checking large numbers of users quickly.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {RetrieveBulkLiveCheckRequest} retrieveBulkLiveCheckRequest The body of the request containing user numeric IDs (e.g. 7602356191083907865).
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBulkLiveCheck: async (retrieveBulkLiveCheckRequest: RetrieveBulkLiveCheckRequest, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retrieveBulkLiveCheckRequest' is not null or undefined
            assertParamExists('retrieveBulkLiveCheck', 'retrieveBulkLiveCheckRequest', retrieveBulkLiveCheckRequest)
            const localVarPath = `/webcast/bulk_live_check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retrieveBulkLiveCheckRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the list of available hashtags for TikTok LIVE streams.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveHashtagList: async (xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/webcast/hashtags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the TikTok LIVE webcast feed for a specific region. Gets a random sampling of creators for a region.
         * @param {PooledProxyRegion} region The region (country) with which to fetch a feed from.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastFeed: async (region: PooledProxyRegion, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'region' is not null or undefined
            assertParamExists('retrieveWebcastFeed', 'region', region)
            const localVarPath = `/webcast/feed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve TikTok LIVE rankings for a specific region. This is NOT a catalogue endpoint, and is available with any paid plan.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {PooledProxyRegion} region The region (country) with which to fetch a feed from.
         * @param {RetrieveWebcastRankingsRankTypeEnum} rankType The type of ranking to fetch. See documentation for more details.
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {string} [sessionId] Use x-oauth-token or x-cookie-header instead
         * @param {string} [ttTargetIdc] Use x-oauth-token or x-cookie-header instead
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastRankings: async (region: PooledProxyRegion, rankType: RetrieveWebcastRankingsRankTypeEnum, xOauthToken?: string, xCookieHeader?: string, sessionId?: string, ttTargetIdc?: string, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'region' is not null or undefined
            assertParamExists('retrieveWebcastRankings', 'region', region)
            // verify required parameter 'rankType' is not null or undefined
            assertParamExists('retrieveWebcastRankings', 'rankType', rankType)
            const localVarPath = `/webcast/rankings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            if (rankType !== undefined) {
                localVarQueryParameter['rank_type'] = rankType;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (ttTargetIdc !== undefined) {
                localVarQueryParameter['tt_target_idc'] = ttTargetIdc;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokLIVEApi - functional programming interface
 */
export const TikTokLIVEApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokLIVEApiAxiosParamCreator(configuration)
    return {
        /**
         * A bulk-check endpoint to determine if a group of TikTok users (up to 50 at once) are live. It uses a highly optimized job-based system for checking large numbers of users quickly.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {RetrieveBulkLiveCheckRequest} retrieveBulkLiveCheckRequest The body of the request containing user numeric IDs (e.g. 7602356191083907865).
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveBulkLiveCheck(retrieveBulkLiveCheckRequest: RetrieveBulkLiveCheckRequest, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveBulkLiveCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveBulkLiveCheck(retrieveBulkLiveCheckRequest, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEApi.retrieveBulkLiveCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the list of available hashtags for TikTok LIVE streams.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveHashtagList(xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HashtagListAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveHashtagList(xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEApi.retrieveHashtagList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch the TikTok LIVE webcast feed for a specific region. Gets a random sampling of creators for a region.
         * @param {PooledProxyRegion} region The region (country) with which to fetch a feed from.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveWebcastFeed(region: PooledProxyRegion, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebcastFeedRouteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveWebcastFeed(region, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEApi.retrieveWebcastFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve TikTok LIVE rankings for a specific region. This is NOT a catalogue endpoint, and is available with any paid plan.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {PooledProxyRegion} region The region (country) with which to fetch a feed from.
         * @param {RetrieveWebcastRankingsRankTypeEnum} rankType The type of ranking to fetch. See documentation for more details.
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {string} [sessionId] Use x-oauth-token or x-cookie-header instead
         * @param {string} [ttTargetIdc] Use x-oauth-token or x-cookie-header instead
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveWebcastRankings(region: PooledProxyRegion, rankType: RetrieveWebcastRankingsRankTypeEnum, xOauthToken?: string, xCookieHeader?: string, sessionId?: string, ttTargetIdc?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebcastRegionRankingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveWebcastRankings(region, rankType, xOauthToken, xCookieHeader, sessionId, ttTargetIdc, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEApi.retrieveWebcastRankings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokLIVEApi - factory interface
 */
export const TikTokLIVEApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokLIVEApiFp(configuration)
    return {
        /**
         * A bulk-check endpoint to determine if a group of TikTok users (up to 50 at once) are live. It uses a highly optimized job-based system for checking large numbers of users quickly.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {RetrieveBulkLiveCheckRequest} retrieveBulkLiveCheckRequest The body of the request containing user numeric IDs (e.g. 7602356191083907865).
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBulkLiveCheck(retrieveBulkLiveCheckRequest: RetrieveBulkLiveCheckRequest, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveBulkLiveCheckResponse> {
            return localVarFp.retrieveBulkLiveCheck(retrieveBulkLiveCheckRequest, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the list of available hashtags for TikTok LIVE streams.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveHashtagList(xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<HashtagListAPIResponse> {
            return localVarFp.retrieveHashtagList(xImageSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch the TikTok LIVE webcast feed for a specific region. Gets a random sampling of creators for a region.
         * @param {PooledProxyRegion} region The region (country) with which to fetch a feed from.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastFeed(region: PooledProxyRegion, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<WebcastFeedRouteResponse> {
            return localVarFp.retrieveWebcastFeed(region, xImageSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve TikTok LIVE rankings for a specific region. This is NOT a catalogue endpoint, and is available with any paid plan.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {PooledProxyRegion} region The region (country) with which to fetch a feed from.
         * @param {RetrieveWebcastRankingsRankTypeEnum} rankType The type of ranking to fetch. See documentation for more details.
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {string} [sessionId] Use x-oauth-token or x-cookie-header instead
         * @param {string} [ttTargetIdc] Use x-oauth-token or x-cookie-header instead
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastRankings(region: PooledProxyRegion, rankType: RetrieveWebcastRankingsRankTypeEnum, xOauthToken?: string, xCookieHeader?: string, sessionId?: string, ttTargetIdc?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<WebcastRegionRankingsResponse> {
            return localVarFp.retrieveWebcastRankings(region, rankType, xOauthToken, xCookieHeader, sessionId, ttTargetIdc, xImageSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokLIVEApi - object-oriented interface
 */
export class TikTokLIVEApi extends BaseAPI {
    /**
     * A bulk-check endpoint to determine if a group of TikTok users (up to 50 at once) are live. It uses a highly optimized job-based system for checking large numbers of users quickly.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {RetrieveBulkLiveCheckRequest} retrieveBulkLiveCheckRequest The body of the request containing user numeric IDs (e.g. 7602356191083907865).
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveBulkLiveCheck(retrieveBulkLiveCheckRequest: RetrieveBulkLiveCheckRequest, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEApiFp(this.configuration).retrieveBulkLiveCheck(retrieveBulkLiveCheckRequest, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the list of available hashtags for TikTok LIVE streams.
     * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveHashtagList(xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokLIVEApiFp(this.configuration).retrieveHashtagList(xImageSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch the TikTok LIVE webcast feed for a specific region. Gets a random sampling of creators for a region.
     * @param {PooledProxyRegion} region The region (country) with which to fetch a feed from.
     * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveWebcastFeed(region: PooledProxyRegion, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokLIVEApiFp(this.configuration).retrieveWebcastFeed(region, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve TikTok LIVE rankings for a specific region. This is NOT a catalogue endpoint, and is available with any paid plan.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {PooledProxyRegion} region The region (country) with which to fetch a feed from.
     * @param {RetrieveWebcastRankingsRankTypeEnum} rankType The type of ranking to fetch. See documentation for more details.
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {string} [sessionId] Use x-oauth-token or x-cookie-header instead
     * @param {string} [ttTargetIdc] Use x-oauth-token or x-cookie-header instead
     * @param {RouteImageSource} [xImageSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveWebcastRankings(region: PooledProxyRegion, rankType: RetrieveWebcastRankingsRankTypeEnum, xOauthToken?: string, xCookieHeader?: string, sessionId?: string, ttTargetIdc?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokLIVEApiFp(this.configuration).retrieveWebcastRankings(region, rankType, xOauthToken, xCookieHeader, sessionId, ttTargetIdc, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }
}

export const RetrieveWebcastRankingsRankTypeEnum = {
    DailyRank: 'DAILY_RANK',
    FansTeamRank: 'FANS_TEAM_RANK',
} as const;
export type RetrieveWebcastRankingsRankTypeEnum = typeof RetrieveWebcastRankingsRankTypeEnum[keyof typeof RetrieveWebcastRankingsRankTypeEnum];


/**
 * TikTokLIVEAlertTargetsApi - axios parameter creator
 */
export const TikTokLIVEAlertTargetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a target for an alert. This is the HTTP endpoint that will be called when an alert is triggered.
         * @param {number} accountId The ID of the account to create the alert target for
         * @param {number} alertId The ID of the alert to create the target for
         * @param {CreateAlertTargetPayload} createAlertTargetPayload Configuration for the alert target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlertTarget: async (accountId: number, alertId: number, createAlertTargetPayload: CreateAlertTargetPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createAlertTarget', 'accountId', accountId)
            // verify required parameter 'alertId' is not null or undefined
            assertParamExists('createAlertTarget', 'alertId', alertId)
            // verify required parameter 'createAlertTargetPayload' is not null or undefined
            assertParamExists('createAlertTarget', 'createAlertTargetPayload', createAlertTargetPayload)
            const localVarPath = `/accounts/{account_id}/alerts/{alert_id}/targets/create`
                .replace('{account_id}', encodeURIComponent(String(accountId)))
                .replace('{alert_id}', encodeURIComponent(String(alertId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAlertTargetPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an alert target from the Sign API
         * @param {number} accountId The ID of the account to delete the alert target from
         * @param {number} alertId The ID of the alert to delete the target from
         * @param {number} targetId The ID of the target to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlertTarget: async (accountId: number, alertId: number, targetId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteAlertTarget', 'accountId', accountId)
            // verify required parameter 'alertId' is not null or undefined
            assertParamExists('deleteAlertTarget', 'alertId', alertId)
            // verify required parameter 'targetId' is not null or undefined
            assertParamExists('deleteAlertTarget', 'targetId', targetId)
            const localVarPath = `/accounts/{account_id}/alerts/{alert_id}/targets/{target_id}/delete`
                .replace('{account_id}', encodeURIComponent(String(accountId)))
                .replace('{alert_id}', encodeURIComponent(String(alertId)))
                .replace('{target_id}', encodeURIComponent(String(targetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all alert targets for a specific alert
         * @param {number} accountId The account that the alert belongs to
         * @param {number} alertId The alert to list targets for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAlertTargets: async (accountId: number, alertId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listAlertTargets', 'accountId', accountId)
            // verify required parameter 'alertId' is not null or undefined
            assertParamExists('listAlertTargets', 'alertId', alertId)
            const localVarPath = `/accounts/{account_id}/alerts/{alert_id}/targets/list`
                .replace('{account_id}', encodeURIComponent(String(accountId)))
                .replace('{alert_id}', encodeURIComponent(String(alertId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Test an alert target
         * @param {number} accountId The account that the alert belongs to
         * @param {number} alertId The alert that the target belongs to
         * @param {number} targetId The target to test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAlertTarget: async (accountId: number, alertId: number, targetId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('testAlertTarget', 'accountId', accountId)
            // verify required parameter 'alertId' is not null or undefined
            assertParamExists('testAlertTarget', 'alertId', alertId)
            // verify required parameter 'targetId' is not null or undefined
            assertParamExists('testAlertTarget', 'targetId', targetId)
            const localVarPath = `/accounts/{account_id}/alerts/{alert_id}/targets/{target_id}/test`
                .replace('{account_id}', encodeURIComponent(String(accountId)))
                .replace('{alert_id}', encodeURIComponent(String(alertId)))
                .replace('{target_id}', encodeURIComponent(String(targetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokLIVEAlertTargetsApi - functional programming interface
 */
export const TikTokLIVEAlertTargetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokLIVEAlertTargetsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a target for an alert. This is the HTTP endpoint that will be called when an alert is triggered.
         * @param {number} accountId The ID of the account to create the alert target for
         * @param {number} alertId The ID of the alert to create the target for
         * @param {CreateAlertTargetPayload} createAlertTargetPayload Configuration for the alert target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAlertTarget(accountId: number, alertId: number, createAlertTargetPayload: CreateAlertTargetPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateAlertTargetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAlertTarget(accountId, alertId, createAlertTargetPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAlertTargetsApi.createAlertTarget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an alert target from the Sign API
         * @param {number} accountId The ID of the account to delete the alert target from
         * @param {number} alertId The ID of the alert to delete the target from
         * @param {number} targetId The ID of the target to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAlertTarget(accountId: number, alertId: number, targetId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteAlertTargetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAlertTarget(accountId, alertId, targetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAlertTargetsApi.deleteAlertTarget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all alert targets for a specific alert
         * @param {number} accountId The account that the alert belongs to
         * @param {number} alertId The alert to list targets for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAlertTargets(accountId: number, alertId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAlertTargetsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAlertTargets(accountId, alertId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAlertTargetsApi.listAlertTargets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Test an alert target
         * @param {number} accountId The account that the alert belongs to
         * @param {number} alertId The alert that the target belongs to
         * @param {number} targetId The target to test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testAlertTarget(accountId: number, alertId: number, targetId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestAlertTargetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testAlertTarget(accountId, alertId, targetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAlertTargetsApi.testAlertTarget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokLIVEAlertTargetsApi - factory interface
 */
export const TikTokLIVEAlertTargetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokLIVEAlertTargetsApiFp(configuration)
    return {
        /**
         * Create a target for an alert. This is the HTTP endpoint that will be called when an alert is triggered.
         * @param {number} accountId The ID of the account to create the alert target for
         * @param {number} alertId The ID of the alert to create the target for
         * @param {CreateAlertTargetPayload} createAlertTargetPayload Configuration for the alert target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlertTarget(accountId: number, alertId: number, createAlertTargetPayload: CreateAlertTargetPayload, options?: RawAxiosRequestConfig): AxiosPromise<CreateAlertTargetResponse> {
            return localVarFp.createAlertTarget(accountId, alertId, createAlertTargetPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an alert target from the Sign API
         * @param {number} accountId The ID of the account to delete the alert target from
         * @param {number} alertId The ID of the alert to delete the target from
         * @param {number} targetId The ID of the target to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlertTarget(accountId: number, alertId: number, targetId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteAlertTargetResponse> {
            return localVarFp.deleteAlertTarget(accountId, alertId, targetId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all alert targets for a specific alert
         * @param {number} accountId The account that the alert belongs to
         * @param {number} alertId The alert to list targets for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAlertTargets(accountId: number, alertId: number, options?: RawAxiosRequestConfig): AxiosPromise<ListAlertTargetsResponse> {
            return localVarFp.listAlertTargets(accountId, alertId, options).then((request) => request(axios, basePath));
        },
        /**
         * Test an alert target
         * @param {number} accountId The account that the alert belongs to
         * @param {number} alertId The alert that the target belongs to
         * @param {number} targetId The target to test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAlertTarget(accountId: number, alertId: number, targetId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestAlertTargetResponse> {
            return localVarFp.testAlertTarget(accountId, alertId, targetId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokLIVEAlertTargetsApi - object-oriented interface
 */
export class TikTokLIVEAlertTargetsApi extends BaseAPI {
    /**
     * Create a target for an alert. This is the HTTP endpoint that will be called when an alert is triggered.
     * @param {number} accountId The ID of the account to create the alert target for
     * @param {number} alertId The ID of the alert to create the target for
     * @param {CreateAlertTargetPayload} createAlertTargetPayload Configuration for the alert target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAlertTarget(accountId: number, alertId: number, createAlertTargetPayload: CreateAlertTargetPayload, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAlertTargetsApiFp(this.configuration).createAlertTarget(accountId, alertId, createAlertTargetPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an alert target from the Sign API
     * @param {number} accountId The ID of the account to delete the alert target from
     * @param {number} alertId The ID of the alert to delete the target from
     * @param {number} targetId The ID of the target to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAlertTarget(accountId: number, alertId: number, targetId: number, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAlertTargetsApiFp(this.configuration).deleteAlertTarget(accountId, alertId, targetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all alert targets for a specific alert
     * @param {number} accountId The account that the alert belongs to
     * @param {number} alertId The alert to list targets for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAlertTargets(accountId: number, alertId: number, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAlertTargetsApiFp(this.configuration).listAlertTargets(accountId, alertId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Test an alert target
     * @param {number} accountId The account that the alert belongs to
     * @param {number} alertId The alert that the target belongs to
     * @param {number} targetId The target to test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public testAlertTarget(accountId: number, alertId: number, targetId: number, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAlertTargetsApiFp(this.configuration).testAlertTarget(accountId, alertId, targetId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TikTokLIVEAlertsApi - axios parameter creator
 */
export const TikTokLIVEAlertsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a creator alert. These Alerts are used to notify users of a new livestream.
         * @param {number} accountId The ID of the account to create the alert for
         * @param {CreateAlertRequest} createAlertRequest Configuration for the alert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlert: async (accountId: number, createAlertRequest: CreateAlertRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createAlert', 'accountId', accountId)
            // verify required parameter 'createAlertRequest' is not null or undefined
            assertParamExists('createAlert', 'createAlertRequest', createAlertRequest)
            const localVarPath = `/accounts/{account_id}/alerts/create`
                .replace('{account_id}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAlertRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an alert from the Sign API
         * @param {number} accountId The ID of the account to delete the alert from
         * @param {number} alertId The ID of the alert to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlert: async (accountId: number, alertId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteAlert', 'accountId', accountId)
            // verify required parameter 'alertId' is not null or undefined
            assertParamExists('deleteAlert', 'alertId', alertId)
            const localVarPath = `/accounts/{account_id}/alerts/{alert_id}/delete`
                .replace('{account_id}', encodeURIComponent(String(accountId)))
                .replace('{alert_id}', encodeURIComponent(String(alertId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} accountId 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAlerts: async (accountId: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listAlerts', 'accountId', accountId)
            const localVarPath = `/accounts/{account_id}/alerts/list`
                .replace('{account_id}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a specific alert by its ID
         * @param {number} accountId The account that the alert belongs to
         * @param {number} alertId The ID of the alert to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAlert: async (accountId: number, alertId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('retrieveAlert', 'accountId', accountId)
            // verify required parameter 'alertId' is not null or undefined
            assertParamExists('retrieveAlert', 'alertId', alertId)
            const localVarPath = `/accounts/{account_id}/alerts/{alert_id}/retrieve`
                .replace('{account_id}', encodeURIComponent(String(accountId)))
                .replace('{alert_id}', encodeURIComponent(String(alertId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokLIVEAlertsApi - functional programming interface
 */
export const TikTokLIVEAlertsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokLIVEAlertsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a creator alert. These Alerts are used to notify users of a new livestream.
         * @param {number} accountId The ID of the account to create the alert for
         * @param {CreateAlertRequest} createAlertRequest Configuration for the alert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAlert(accountId: number, createAlertRequest: CreateAlertRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateAlertResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAlert(accountId, createAlertRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAlertsApi.createAlert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an alert from the Sign API
         * @param {number} accountId The ID of the account to delete the alert from
         * @param {number} alertId The ID of the alert to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAlert(accountId: number, alertId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteAlertResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAlert(accountId, alertId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAlertsApi.deleteAlert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} accountId 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAlerts(accountId: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAlertsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAlerts(accountId, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAlertsApi.listAlerts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a specific alert by its ID
         * @param {number} accountId The account that the alert belongs to
         * @param {number} alertId The ID of the alert to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveAlert(accountId: number, alertId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveAlertResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveAlert(accountId, alertId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAlertsApi.retrieveAlert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokLIVEAlertsApi - factory interface
 */
export const TikTokLIVEAlertsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokLIVEAlertsApiFp(configuration)
    return {
        /**
         * Create a creator alert. These Alerts are used to notify users of a new livestream.
         * @param {number} accountId The ID of the account to create the alert for
         * @param {CreateAlertRequest} createAlertRequest Configuration for the alert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlert(accountId: number, createAlertRequest: CreateAlertRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateAlertResponse> {
            return localVarFp.createAlert(accountId, createAlertRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an alert from the Sign API
         * @param {number} accountId The ID of the account to delete the alert from
         * @param {number} alertId The ID of the alert to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlert(accountId: number, alertId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteAlertResponse> {
            return localVarFp.deleteAlert(accountId, alertId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} accountId 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAlerts(accountId: number, page?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListAlertsResponse> {
            return localVarFp.listAlerts(accountId, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a specific alert by its ID
         * @param {number} accountId The account that the alert belongs to
         * @param {number} alertId The ID of the alert to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAlert(accountId: number, alertId: number, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveAlertResponse> {
            return localVarFp.retrieveAlert(accountId, alertId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokLIVEAlertsApi - object-oriented interface
 */
export class TikTokLIVEAlertsApi extends BaseAPI {
    /**
     * Create a creator alert. These Alerts are used to notify users of a new livestream.
     * @param {number} accountId The ID of the account to create the alert for
     * @param {CreateAlertRequest} createAlertRequest Configuration for the alert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAlert(accountId: number, createAlertRequest: CreateAlertRequest, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAlertsApiFp(this.configuration).createAlert(accountId, createAlertRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an alert from the Sign API
     * @param {number} accountId The ID of the account to delete the alert from
     * @param {number} alertId The ID of the alert to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAlert(accountId: number, alertId: number, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAlertsApiFp(this.configuration).deleteAlert(accountId, alertId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} accountId 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAlerts(accountId: number, page?: number, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAlertsApiFp(this.configuration).listAlerts(accountId, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a specific alert by its ID
     * @param {number} accountId The account that the alert belongs to
     * @param {number} alertId The ID of the alert to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveAlert(accountId: number, alertId: number, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAlertsApiFp(this.configuration).retrieveAlert(accountId, alertId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TikTokLIVEAnchorsApi - axios parameter creator
 */
export const TikTokLIVEAnchorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a moderator in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} toUserId The user ID to add as moderator
         * @param {string} anchorId The streamer\&#39;s user ID
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoomModerator: async (toUserId: string, anchorId: string, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toUserId' is not null or undefined
            assertParamExists('addRoomModerator', 'toUserId', toUserId)
            // verify required parameter 'anchorId' is not null or undefined
            assertParamExists('addRoomModerator', 'anchorId', anchorId)
            const localVarPath = `/webcast/anchors/{anchor_id}/moderation/moderators`
                .replace('{anchor_id}', encodeURIComponent(String(anchorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (toUserId !== undefined) {
                localVarQueryParameter['to_user_id'] = toUserId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a moderator from a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} toUserId The user ID to remove as moderator
         * @param {string} anchorId The streamer\&#39;s user ID
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoomModerator: async (toUserId: string, anchorId: string, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toUserId' is not null or undefined
            assertParamExists('removeRoomModerator', 'toUserId', toUserId)
            // verify required parameter 'anchorId' is not null or undefined
            assertParamExists('removeRoomModerator', 'anchorId', anchorId)
            const localVarPath = `/webcast/anchors/{anchor_id}/moderation/moderators`
                .replace('{anchor_id}', encodeURIComponent(String(anchorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (toUserId !== undefined) {
                localVarQueryParameter['to_user_id'] = toUserId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find out how long a user watched your stream, the # of comments sent, likes, the comments themselves, and more analytics data.  **Note:** The session you attach must own the livestream to check analytics for a given `room_id`.  Returns details about a user\'s activity in a room including comments, likes, shares, and watch duration.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} userId The numeric user ID to get interactions for
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveLiveAnalyticsUserInteractions: async (roomId: string, userId: string, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('retrieveLiveAnalyticsUserInteractions', 'roomId', roomId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('retrieveLiveAnalyticsUserInteractions', 'userId', userId)
            const localVarPath = `/webcast/anchors/me/rooms/{room_id}/interactions`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed analytics for a specific past livestream.  **Note:** The session you attach must own the livestream to check analytics for a given `room_id`.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream to get analytics for
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveLiveAnalyticsVideoDetail: async (roomId: string, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('retrieveLiveAnalyticsVideoDetail', 'roomId', roomId)
            const localVarPath = `/webcast/anchors/me/rooms/{room_id}/details`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the list of past livestreams with analytics for the authenticated user.  **Note:** The session you attach must own the livestream to check analytics for a given `room_id`.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {number} [count] Number of videos to retrieve (default: 10)
         * @param {number} [offset] Pagination offset (default: 0)
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveLiveAnalyticsVideoList: async (count?: number, offset?: number, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/webcast/anchors/me/rooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch TikTok LIVE Stream Cover URL given a uniqueId.
         * @param {string} uniqueId The unique ID of the TikTok to fetch the cover for.
         * @param {boolean} [redirect] Whether to redirect to the URL directly
         * @param {RouteImageSource} [xImageSource] Where the returned cover URL is served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomCover: async (uniqueId: string, redirect?: boolean, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uniqueId' is not null or undefined
            assertParamExists('retrieveRoomCover', 'uniqueId', uniqueId)
            const localVarPath = `/webcast/anchors/{unique_id}/room_cover`
                .replace('{unique_id}', encodeURIComponent(String(uniqueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (redirect !== undefined) {
                localVarQueryParameter['redirect'] = redirect;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch Room ID for a given uniqueId & whether that user is live.
         * @param {string} uniqueId The unique ID of the TikTok user to fetch the data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomId: async (uniqueId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uniqueId' is not null or undefined
            assertParamExists('retrieveRoomId', 'uniqueId', uniqueId)
            const localVarPath = `/webcast/anchors/{unique_id}/room_id`
                .replace('{unique_id}', encodeURIComponent(String(uniqueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve TikTok Live Room Information
         * @param {string} uniqueId The unique identifier for the TikTok user or room
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomInfo: async (uniqueId: string, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uniqueId' is not null or undefined
            assertParamExists('retrieveRoomInfo', 'uniqueId', uniqueId)
            const localVarPath = `/webcast/anchors/{unique_id}/room_info`
                .replace('{unique_id}', encodeURIComponent(String(uniqueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the list of moderators in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} anchorId The streamer\&#39;s numeric user ID
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomModerators: async (anchorId: string, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anchorId' is not null or undefined
            assertParamExists('retrieveRoomModerators', 'anchorId', anchorId)
            const localVarPath = `/webcast/anchors/{anchor_id}/moderation/moderators`
                .replace('{anchor_id}', encodeURIComponent(String(anchorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch TikTok LIVE Stream video given a uniqueId.
         * @param {string} uniqueId The unique ID of the TikTok to fetch the data for.
         * @param {StreamType} [streamType] The type of video stream to fetch. Default is HLS_SD.
         * @param {boolean} [redirect] Whether to redirect or return as JSON
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomVideo: async (uniqueId: string, streamType?: StreamType, redirect?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uniqueId' is not null or undefined
            assertParamExists('retrieveRoomVideo', 'uniqueId', uniqueId)
            const localVarPath = `/webcast/anchors/{unique_id}/room_video`
                .replace('{unique_id}', encodeURIComponent(String(uniqueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (streamType !== undefined) {
                localVarQueryParameter['streamType'] = streamType;
            }

            if (redirect !== undefined) {
                localVarQueryParameter['redirect'] = redirect;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the TikTok LIVE gift gallery (sponsorable gifts + sponsorship progress) for a creator.  The gallery is rendered per-viewer, so a session is required.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} uniqueId The creator\&#39;s unique ID (handle).
         * @param {WebcastLanguage} [webcastLanguage] Webcast language for locale-based fields
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastGiftGallery: async (uniqueId: string, webcastLanguage?: WebcastLanguage, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uniqueId' is not null or undefined
            assertParamExists('retrieveWebcastGiftGallery', 'uniqueId', uniqueId)
            const localVarPath = `/webcast/anchors/{unique_id}/gift_gallery`
                .replace('{unique_id}', encodeURIComponent(String(uniqueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (webcastLanguage !== undefined) {
                localVarQueryParameter['webcast_language'] = webcastLanguage;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve TikTok LIVE earnings for a specific user.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} uniqueId The unique ID (username) of the user to fetch earnings for.
         * @param {WebcastUserEarningsOutputPeriod} [period] Earnings period
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {string} [sessionId] Use x-oauth-token or x-cookie-header instead
         * @param {string} [ttTargetIdc] Use x-oauth-token or x-cookie-header instead
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastUserEarnings: async (uniqueId: string, period?: WebcastUserEarningsOutputPeriod, xOauthToken?: string, xCookieHeader?: string, sessionId?: string, ttTargetIdc?: string, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uniqueId' is not null or undefined
            assertParamExists('retrieveWebcastUserEarnings', 'uniqueId', uniqueId)
            const localVarPath = `/webcast/anchors/{unique_id}/earnings`
                .replace('{unique_id}', encodeURIComponent(String(uniqueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (ttTargetIdc !== undefined) {
                localVarQueryParameter['tt_target_idc'] = ttTargetIdc;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve a TikTok
         * @param {string} uniqueId The unique ID (handle) of the TikTok user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastUserId: async (uniqueId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uniqueId' is not null or undefined
            assertParamExists('retrieveWebcastUserId', 'uniqueId', uniqueId)
            const localVarPath = `/webcast/anchors/{unique_id}/user_id`
                .replace('{unique_id}', encodeURIComponent(String(uniqueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokLIVEAnchorsApi - functional programming interface
 */
export const TikTokLIVEAnchorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokLIVEAnchorsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a moderator in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} toUserId The user ID to add as moderator
         * @param {string} anchorId The streamer\&#39;s user ID
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRoomModerator(toUserId: string, anchorId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomAdminUpdateAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRoomModerator(toUserId, anchorId, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAnchorsApi.addRoomModerator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a moderator from a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} toUserId The user ID to remove as moderator
         * @param {string} anchorId The streamer\&#39;s user ID
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeRoomModerator(toUserId: string, anchorId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomAdminUpdateAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeRoomModerator(toUserId, anchorId, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAnchorsApi.removeRoomModerator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find out how long a user watched your stream, the # of comments sent, likes, the comments themselves, and more analytics data.  **Note:** The session you attach must own the livestream to check analytics for a given `room_id`.  Returns details about a user\'s activity in a room including comments, likes, shares, and watch duration.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} userId The numeric user ID to get interactions for
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveLiveAnalyticsUserInteractions(roomId: string, userId: string, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveAnalyticsUserInteractionsAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveLiveAnalyticsUserInteractions(roomId, userId, xOauthToken, xCookieHeader, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAnchorsApi.retrieveLiveAnalyticsUserInteractions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed analytics for a specific past livestream.  **Note:** The session you attach must own the livestream to check analytics for a given `room_id`.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream to get analytics for
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveLiveAnalyticsVideoDetail(roomId: string, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveAnalyticsVideoDetailAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveLiveAnalyticsVideoDetail(roomId, xOauthToken, xCookieHeader, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAnchorsApi.retrieveLiveAnalyticsVideoDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the list of past livestreams with analytics for the authenticated user.  **Note:** The session you attach must own the livestream to check analytics for a given `room_id`.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {number} [count] Number of videos to retrieve (default: 10)
         * @param {number} [offset] Pagination offset (default: 0)
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveLiveAnalyticsVideoList(count?: number, offset?: number, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveAnalyticsVideoListAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveLiveAnalyticsVideoList(count, offset, xOauthToken, xCookieHeader, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAnchorsApi.retrieveLiveAnalyticsVideoList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch TikTok LIVE Stream Cover URL given a uniqueId.
         * @param {string} uniqueId The unique ID of the TikTok to fetch the cover for.
         * @param {boolean} [redirect] Whether to redirect to the URL directly
         * @param {RouteImageSource} [xImageSource] Where the returned cover URL is served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveRoomCover(uniqueId: string, redirect?: boolean, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveRoomCoverResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveRoomCover(uniqueId, redirect, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAnchorsApi.retrieveRoomCover']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch Room ID for a given uniqueId & whether that user is live.
         * @param {string} uniqueId The unique ID of the TikTok user to fetch the data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveRoomId(uniqueId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebcastRoomIdRouteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveRoomId(uniqueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAnchorsApi.retrieveRoomId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve TikTok Live Room Information
         * @param {string} uniqueId The unique identifier for the TikTok user or room
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveRoomInfo(uniqueId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebcastRoomInfoRouteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveRoomInfo(uniqueId, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAnchorsApi.retrieveRoomInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the list of moderators in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} anchorId The streamer\&#39;s numeric user ID
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveRoomModerators(anchorId: string, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomModeratorsAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveRoomModerators(anchorId, xOauthToken, xCookieHeader, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAnchorsApi.retrieveRoomModerators']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch TikTok LIVE Stream video given a uniqueId.
         * @param {string} uniqueId The unique ID of the TikTok to fetch the data for.
         * @param {StreamType} [streamType] The type of video stream to fetch. Default is HLS_SD.
         * @param {boolean} [redirect] Whether to redirect or return as JSON
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveRoomVideo(uniqueId: string, streamType?: StreamType, redirect?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveRoomVideoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveRoomVideo(uniqueId, streamType, redirect, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAnchorsApi.retrieveRoomVideo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the TikTok LIVE gift gallery (sponsorable gifts + sponsorship progress) for a creator.  The gallery is rendered per-viewer, so a session is required.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} uniqueId The creator\&#39;s unique ID (handle).
         * @param {WebcastLanguage} [webcastLanguage] Webcast language for locale-based fields
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveWebcastGiftGallery(uniqueId: string, webcastLanguage?: WebcastLanguage, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebcastGiftGalleryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveWebcastGiftGallery(uniqueId, webcastLanguage, xOauthToken, xCookieHeader, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAnchorsApi.retrieveWebcastGiftGallery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve TikTok LIVE earnings for a specific user.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} uniqueId The unique ID (username) of the user to fetch earnings for.
         * @param {WebcastUserEarningsOutputPeriod} [period] Earnings period
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {string} [sessionId] Use x-oauth-token or x-cookie-header instead
         * @param {string} [ttTargetIdc] Use x-oauth-token or x-cookie-header instead
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveWebcastUserEarnings(uniqueId: string, period?: WebcastUserEarningsOutputPeriod, xOauthToken?: string, xCookieHeader?: string, sessionId?: string, ttTargetIdc?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebcastUserEarningsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveWebcastUserEarnings(uniqueId, period, xOauthToken, xCookieHeader, sessionId, ttTargetIdc, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAnchorsApi.retrieveWebcastUserEarnings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resolve a TikTok
         * @param {string} uniqueId The unique ID (handle) of the TikTok user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveWebcastUserId(uniqueId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebcastUserIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveWebcastUserId(uniqueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEAnchorsApi.retrieveWebcastUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokLIVEAnchorsApi - factory interface
 */
export const TikTokLIVEAnchorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokLIVEAnchorsApiFp(configuration)
    return {
        /**
         * Add a moderator in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} toUserId The user ID to add as moderator
         * @param {string} anchorId The streamer\&#39;s user ID
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRoomModerator(toUserId: string, anchorId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomAdminUpdateAPIResponse> {
            return localVarFp.addRoomModerator(toUserId, anchorId, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a moderator from a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} toUserId The user ID to remove as moderator
         * @param {string} anchorId The streamer\&#39;s user ID
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoomModerator(toUserId: string, anchorId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomAdminUpdateAPIResponse> {
            return localVarFp.removeRoomModerator(toUserId, anchorId, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
        /**
         * Find out how long a user watched your stream, the # of comments sent, likes, the comments themselves, and more analytics data.  **Note:** The session you attach must own the livestream to check analytics for a given `room_id`.  Returns details about a user\'s activity in a room including comments, likes, shares, and watch duration.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} userId The numeric user ID to get interactions for
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveLiveAnalyticsUserInteractions(roomId: string, userId: string, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<LiveAnalyticsUserInteractionsAPIResponse> {
            return localVarFp.retrieveLiveAnalyticsUserInteractions(roomId, userId, xOauthToken, xCookieHeader, xImageSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed analytics for a specific past livestream.  **Note:** The session you attach must own the livestream to check analytics for a given `room_id`.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream to get analytics for
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveLiveAnalyticsVideoDetail(roomId: string, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<LiveAnalyticsVideoDetailAPIResponse> {
            return localVarFp.retrieveLiveAnalyticsVideoDetail(roomId, xOauthToken, xCookieHeader, xImageSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the list of past livestreams with analytics for the authenticated user.  **Note:** The session you attach must own the livestream to check analytics for a given `room_id`.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {number} [count] Number of videos to retrieve (default: 10)
         * @param {number} [offset] Pagination offset (default: 0)
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveLiveAnalyticsVideoList(count?: number, offset?: number, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<LiveAnalyticsVideoListAPIResponse> {
            return localVarFp.retrieveLiveAnalyticsVideoList(count, offset, xOauthToken, xCookieHeader, xImageSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch TikTok LIVE Stream Cover URL given a uniqueId.
         * @param {string} uniqueId The unique ID of the TikTok to fetch the cover for.
         * @param {boolean} [redirect] Whether to redirect to the URL directly
         * @param {RouteImageSource} [xImageSource] Where the returned cover URL is served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomCover(uniqueId: string, redirect?: boolean, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveRoomCoverResponse> {
            return localVarFp.retrieveRoomCover(uniqueId, redirect, xImageSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch Room ID for a given uniqueId & whether that user is live.
         * @param {string} uniqueId The unique ID of the TikTok user to fetch the data for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomId(uniqueId: string, options?: RawAxiosRequestConfig): AxiosPromise<WebcastRoomIdRouteResponse> {
            return localVarFp.retrieveRoomId(uniqueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve TikTok Live Room Information
         * @param {string} uniqueId The unique identifier for the TikTok user or room
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomInfo(uniqueId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<WebcastRoomInfoRouteResponse> {
            return localVarFp.retrieveRoomInfo(uniqueId, xImageSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the list of moderators in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} anchorId The streamer\&#39;s numeric user ID
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomModerators(anchorId: string, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<RoomModeratorsAPIResponse> {
            return localVarFp.retrieveRoomModerators(anchorId, xOauthToken, xCookieHeader, xImageSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch TikTok LIVE Stream video given a uniqueId.
         * @param {string} uniqueId The unique ID of the TikTok to fetch the data for.
         * @param {StreamType} [streamType] The type of video stream to fetch. Default is HLS_SD.
         * @param {boolean} [redirect] Whether to redirect or return as JSON
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomVideo(uniqueId: string, streamType?: StreamType, redirect?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveRoomVideoResponse> {
            return localVarFp.retrieveRoomVideo(uniqueId, streamType, redirect, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the TikTok LIVE gift gallery (sponsorable gifts + sponsorship progress) for a creator.  The gallery is rendered per-viewer, so a session is required.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} uniqueId The creator\&#39;s unique ID (handle).
         * @param {WebcastLanguage} [webcastLanguage] Webcast language for locale-based fields
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastGiftGallery(uniqueId: string, webcastLanguage?: WebcastLanguage, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<WebcastGiftGalleryResponse> {
            return localVarFp.retrieveWebcastGiftGallery(uniqueId, webcastLanguage, xOauthToken, xCookieHeader, xImageSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve TikTok LIVE earnings for a specific user.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} uniqueId The unique ID (username) of the user to fetch earnings for.
         * @param {WebcastUserEarningsOutputPeriod} [period] Earnings period
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {string} [sessionId] Use x-oauth-token or x-cookie-header instead
         * @param {string} [ttTargetIdc] Use x-oauth-token or x-cookie-header instead
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastUserEarnings(uniqueId: string, period?: WebcastUserEarningsOutputPeriod, xOauthToken?: string, xCookieHeader?: string, sessionId?: string, ttTargetIdc?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<WebcastUserEarningsResponse> {
            return localVarFp.retrieveWebcastUserEarnings(uniqueId, period, xOauthToken, xCookieHeader, sessionId, ttTargetIdc, xImageSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve a TikTok
         * @param {string} uniqueId The unique ID (handle) of the TikTok user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastUserId(uniqueId: string, options?: RawAxiosRequestConfig): AxiosPromise<WebcastUserIdResponse> {
            return localVarFp.retrieveWebcastUserId(uniqueId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokLIVEAnchorsApi - object-oriented interface
 */
export class TikTokLIVEAnchorsApi extends BaseAPI {
    /**
     * Add a moderator in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} toUserId The user ID to add as moderator
     * @param {string} anchorId The streamer\&#39;s user ID
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addRoomModerator(toUserId: string, anchorId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAnchorsApiFp(this.configuration).addRoomModerator(toUserId, anchorId, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a moderator from a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} toUserId The user ID to remove as moderator
     * @param {string} anchorId The streamer\&#39;s user ID
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeRoomModerator(toUserId: string, anchorId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAnchorsApiFp(this.configuration).removeRoomModerator(toUserId, anchorId, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find out how long a user watched your stream, the # of comments sent, likes, the comments themselves, and more analytics data.  **Note:** The session you attach must own the livestream to check analytics for a given `room_id`.  Returns details about a user\'s activity in a room including comments, likes, shares, and watch duration.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} roomId The room ID of the livestream
     * @param {string} userId The numeric user ID to get interactions for
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {RouteImageSource} [xImageSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveLiveAnalyticsUserInteractions(roomId: string, userId: string, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAnchorsApiFp(this.configuration).retrieveLiveAnalyticsUserInteractions(roomId, userId, xOauthToken, xCookieHeader, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed analytics for a specific past livestream.  **Note:** The session you attach must own the livestream to check analytics for a given `room_id`.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} roomId The room ID of the livestream to get analytics for
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {RouteImageSource} [xImageSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveLiveAnalyticsVideoDetail(roomId: string, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAnchorsApiFp(this.configuration).retrieveLiveAnalyticsVideoDetail(roomId, xOauthToken, xCookieHeader, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the list of past livestreams with analytics for the authenticated user.  **Note:** The session you attach must own the livestream to check analytics for a given `room_id`.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {number} [count] Number of videos to retrieve (default: 10)
     * @param {number} [offset] Pagination offset (default: 0)
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {RouteImageSource} [xImageSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveLiveAnalyticsVideoList(count?: number, offset?: number, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAnchorsApiFp(this.configuration).retrieveLiveAnalyticsVideoList(count, offset, xOauthToken, xCookieHeader, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch TikTok LIVE Stream Cover URL given a uniqueId.
     * @param {string} uniqueId The unique ID of the TikTok to fetch the cover for.
     * @param {boolean} [redirect] Whether to redirect to the URL directly
     * @param {RouteImageSource} [xImageSource] Where the returned cover URL is served from (ORIGIN, CDN, CDN_CNAME).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveRoomCover(uniqueId: string, redirect?: boolean, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAnchorsApiFp(this.configuration).retrieveRoomCover(uniqueId, redirect, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch Room ID for a given uniqueId & whether that user is live.
     * @param {string} uniqueId The unique ID of the TikTok user to fetch the data for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveRoomId(uniqueId: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAnchorsApiFp(this.configuration).retrieveRoomId(uniqueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve TikTok Live Room Information
     * @param {string} uniqueId The unique identifier for the TikTok user or room
     * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveRoomInfo(uniqueId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAnchorsApiFp(this.configuration).retrieveRoomInfo(uniqueId, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the list of moderators in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} anchorId The streamer\&#39;s numeric user ID
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {RouteImageSource} [xImageSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveRoomModerators(anchorId: string, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAnchorsApiFp(this.configuration).retrieveRoomModerators(anchorId, xOauthToken, xCookieHeader, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch TikTok LIVE Stream video given a uniqueId.
     * @param {string} uniqueId The unique ID of the TikTok to fetch the data for.
     * @param {StreamType} [streamType] The type of video stream to fetch. Default is HLS_SD.
     * @param {boolean} [redirect] Whether to redirect or return as JSON
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveRoomVideo(uniqueId: string, streamType?: StreamType, redirect?: boolean, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAnchorsApiFp(this.configuration).retrieveRoomVideo(uniqueId, streamType, redirect, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the TikTok LIVE gift gallery (sponsorable gifts + sponsorship progress) for a creator.  The gallery is rendered per-viewer, so a session is required.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} uniqueId The creator\&#39;s unique ID (handle).
     * @param {WebcastLanguage} [webcastLanguage] Webcast language for locale-based fields
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {RouteImageSource} [xImageSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveWebcastGiftGallery(uniqueId: string, webcastLanguage?: WebcastLanguage, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAnchorsApiFp(this.configuration).retrieveWebcastGiftGallery(uniqueId, webcastLanguage, xOauthToken, xCookieHeader, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve TikTok LIVE earnings for a specific user.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} uniqueId The unique ID (username) of the user to fetch earnings for.
     * @param {WebcastUserEarningsOutputPeriod} [period] Earnings period
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {string} [sessionId] Use x-oauth-token or x-cookie-header instead
     * @param {string} [ttTargetIdc] Use x-oauth-token or x-cookie-header instead
     * @param {RouteImageSource} [xImageSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveWebcastUserEarnings(uniqueId: string, period?: WebcastUserEarningsOutputPeriod, xOauthToken?: string, xCookieHeader?: string, sessionId?: string, ttTargetIdc?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAnchorsApiFp(this.configuration).retrieveWebcastUserEarnings(uniqueId, period, xOauthToken, xCookieHeader, sessionId, ttTargetIdc, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolve a TikTok
     * @param {string} uniqueId The unique ID (handle) of the TikTok user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveWebcastUserId(uniqueId: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEAnchorsApiFp(this.configuration).retrieveWebcastUserId(uniqueId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TikTokLIVEEventsApi - axios parameter creator
 */
export const TikTokLIVEEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List the scheduled/live TikTok LIVE events for an anchor (creator).  The upstream endpoint is session-bound, so a session is required.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} anchorId The anchor\&#39;s numeric TikTok user ID.
         * @param {number} [page] Zero-based page of events (20 per page).
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastAnchorEvents: async (anchorId: string, page?: number, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anchorId' is not null or undefined
            assertParamExists('retrieveWebcastAnchorEvents', 'anchorId', anchorId)
            const localVarPath = `/webcast/events/anchors/{anchor_id}`
                .replace('{anchor_id}', encodeURIComponent(String(anchorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single TikTok LIVE event (a scheduled/subscription stream) by its event ID.
         * @param {string} eventId The numeric ID of the LIVE event.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastEvent: async (eventId: string, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('retrieveWebcastEvent', 'eventId', eventId)
            const localVarPath = `/webcast/events/{event_id}`
                .replace('{event_id}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokLIVEEventsApi - functional programming interface
 */
export const TikTokLIVEEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokLIVEEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * List the scheduled/live TikTok LIVE events for an anchor (creator).  The upstream endpoint is session-bound, so a session is required.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} anchorId The anchor\&#39;s numeric TikTok user ID.
         * @param {number} [page] Zero-based page of events (20 per page).
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveWebcastAnchorEvents(anchorId: string, page?: number, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveWebcastAnchorEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveWebcastAnchorEvents(anchorId, page, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEEventsApi.retrieveWebcastAnchorEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single TikTok LIVE event (a scheduled/subscription stream) by its event ID.
         * @param {string} eventId The numeric ID of the LIVE event.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveWebcastEvent(eventId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveWebcastEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveWebcastEvent(eventId, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEEventsApi.retrieveWebcastEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokLIVEEventsApi - factory interface
 */
export const TikTokLIVEEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokLIVEEventsApiFp(configuration)
    return {
        /**
         * List the scheduled/live TikTok LIVE events for an anchor (creator).  The upstream endpoint is session-bound, so a session is required.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} anchorId The anchor\&#39;s numeric TikTok user ID.
         * @param {number} [page] Zero-based page of events (20 per page).
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastAnchorEvents(anchorId: string, page?: number, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveWebcastAnchorEventsResponse> {
            return localVarFp.retrieveWebcastAnchorEvents(anchorId, page, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single TikTok LIVE event (a scheduled/subscription stream) by its event ID.
         * @param {string} eventId The numeric ID of the LIVE event.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastEvent(eventId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveWebcastEventResponse> {
            return localVarFp.retrieveWebcastEvent(eventId, xImageSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokLIVEEventsApi - object-oriented interface
 */
export class TikTokLIVEEventsApi extends BaseAPI {
    /**
     * List the scheduled/live TikTok LIVE events for an anchor (creator).  The upstream endpoint is session-bound, so a session is required.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} anchorId The anchor\&#39;s numeric TikTok user ID.
     * @param {number} [page] Zero-based page of events (20 per page).
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveWebcastAnchorEvents(anchorId: string, page?: number, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEEventsApiFp(this.configuration).retrieveWebcastAnchorEvents(anchorId, page, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a single TikTok LIVE event (a scheduled/subscription stream) by its event ID.
     * @param {string} eventId The numeric ID of the LIVE event.
     * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveWebcastEvent(eventId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokLIVEEventsApiFp(this.configuration).retrieveWebcastEvent(eventId, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TikTokLIVEGiftsApi - axios parameter creator
 */
export const TikTokLIVEGiftsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List the full TikTok LIVE gift catalog, paginated.  This is a special route, it does NOT fetch data live, and therefore does not count to your hourly/daily rate limits.
         * @param {number} [pageSize] Results per page (1–100, server-clamped). Defaults to 50.
         * @param {number} [pageNumber] 1-based page number. Defaults to 1.
         * @param {GiftCatalogOrderBy} [orderBy] Sort order for the catalog. Defaults to price ascending.
         * @param {boolean} [ascending] Whether to sort ascending or descending. Defaults to true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebcastGifts: async (pageSize?: number, pageNumber?: number, orderBy?: GiftCatalogOrderBy, ascending?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/webcast/gifts/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (ascending !== undefined) {
                localVarQueryParameter['ascending'] = ascending;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single TikTok LIVE gift by its numeric gift ID.  This is a special route, it does NOT fetch data live, and therefore does not count to your hourly/daily rate limits.
         * @param {number} giftId The numeric gift ID to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastGift: async (giftId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'giftId' is not null or undefined
            assertParamExists('retrieveWebcastGift', 'giftId', giftId)
            const localVarPath = `/webcast/gifts/catalog/{gift_id}`
                .replace('{gift_id}', encodeURIComponent(String(giftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve Webcast gifts for a given region
         * @param {PooledProxyRegion} [region] The region to fetch gifts for
         * @param {RetrieveWebcastGiftsWebcastLanguageEnum} [webcastLanguage] Webcast language for locale-based fields
         * @param {boolean} [redirect] Whether to redirect directly or return a JSON response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastGifts: async (region?: PooledProxyRegion, webcastLanguage?: RetrieveWebcastGiftsWebcastLanguageEnum, redirect?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/webcast/gifts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            if (webcastLanguage !== undefined) {
                localVarQueryParameter['webcast_language'] = webcastLanguage;
            }

            if (redirect !== undefined) {
                localVarQueryParameter['redirect'] = redirect;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search the TikTok LIVE gift catalogue by gift name.  This is a special route, it does NOT fetch data live, and therefore does not count to your hourly/daily rate limits.
         * @param {string} query The search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWebcastGifts: async (query: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchWebcastGifts', 'query', query)
            const localVarPath = `/webcast/gifts/catalog/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokLIVEGiftsApi - functional programming interface
 */
export const TikTokLIVEGiftsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokLIVEGiftsApiAxiosParamCreator(configuration)
    return {
        /**
         * List the full TikTok LIVE gift catalog, paginated.  This is a special route, it does NOT fetch data live, and therefore does not count to your hourly/daily rate limits.
         * @param {number} [pageSize] Results per page (1–100, server-clamped). Defaults to 50.
         * @param {number} [pageNumber] 1-based page number. Defaults to 1.
         * @param {GiftCatalogOrderBy} [orderBy] Sort order for the catalog. Defaults to price ascending.
         * @param {boolean} [ascending] Whether to sort ascending or descending. Defaults to true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWebcastGifts(pageSize?: number, pageNumber?: number, orderBy?: GiftCatalogOrderBy, ascending?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebcastGiftcatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWebcastGifts(pageSize, pageNumber, orderBy, ascending, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEGiftsApi.listWebcastGifts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a single TikTok LIVE gift by its numeric gift ID.  This is a special route, it does NOT fetch data live, and therefore does not count to your hourly/daily rate limits.
         * @param {number} giftId The numeric gift ID to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveWebcastGift(giftId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebcastGiftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveWebcastGift(giftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEGiftsApi.retrieveWebcastGift']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve Webcast gifts for a given region
         * @param {PooledProxyRegion} [region] The region to fetch gifts for
         * @param {RetrieveWebcastGiftsWebcastLanguageEnum} [webcastLanguage] Webcast language for locale-based fields
         * @param {boolean} [redirect] Whether to redirect directly or return a JSON response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveWebcastGifts(region?: PooledProxyRegion, webcastLanguage?: RetrieveWebcastGiftsWebcastLanguageEnum, redirect?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebcastGiftsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveWebcastGifts(region, webcastLanguage, redirect, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEGiftsApi.retrieveWebcastGifts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search the TikTok LIVE gift catalogue by gift name.  This is a special route, it does NOT fetch data live, and therefore does not count to your hourly/daily rate limits.
         * @param {string} query The search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchWebcastGifts(query: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebcastGiftSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchWebcastGifts(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEGiftsApi.searchWebcastGifts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokLIVEGiftsApi - factory interface
 */
export const TikTokLIVEGiftsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokLIVEGiftsApiFp(configuration)
    return {
        /**
         * List the full TikTok LIVE gift catalog, paginated.  This is a special route, it does NOT fetch data live, and therefore does not count to your hourly/daily rate limits.
         * @param {number} [pageSize] Results per page (1–100, server-clamped). Defaults to 50.
         * @param {number} [pageNumber] 1-based page number. Defaults to 1.
         * @param {GiftCatalogOrderBy} [orderBy] Sort order for the catalog. Defaults to price ascending.
         * @param {boolean} [ascending] Whether to sort ascending or descending. Defaults to true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebcastGifts(pageSize?: number, pageNumber?: number, orderBy?: GiftCatalogOrderBy, ascending?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<WebcastGiftcatalogResponse> {
            return localVarFp.listWebcastGifts(pageSize, pageNumber, orderBy, ascending, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single TikTok LIVE gift by its numeric gift ID.  This is a special route, it does NOT fetch data live, and therefore does not count to your hourly/daily rate limits.
         * @param {number} giftId The numeric gift ID to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastGift(giftId: number, options?: RawAxiosRequestConfig): AxiosPromise<WebcastGiftResponse> {
            return localVarFp.retrieveWebcastGift(giftId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve Webcast gifts for a given region
         * @param {PooledProxyRegion} [region] The region to fetch gifts for
         * @param {RetrieveWebcastGiftsWebcastLanguageEnum} [webcastLanguage] Webcast language for locale-based fields
         * @param {boolean} [redirect] Whether to redirect directly or return a JSON response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebcastGifts(region?: PooledProxyRegion, webcastLanguage?: RetrieveWebcastGiftsWebcastLanguageEnum, redirect?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<WebcastGiftsResponse> {
            return localVarFp.retrieveWebcastGifts(region, webcastLanguage, redirect, options).then((request) => request(axios, basePath));
        },
        /**
         * Search the TikTok LIVE gift catalogue by gift name.  This is a special route, it does NOT fetch data live, and therefore does not count to your hourly/daily rate limits.
         * @param {string} query The search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWebcastGifts(query: string, options?: RawAxiosRequestConfig): AxiosPromise<WebcastGiftSearchResponse> {
            return localVarFp.searchWebcastGifts(query, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokLIVEGiftsApi - object-oriented interface
 */
export class TikTokLIVEGiftsApi extends BaseAPI {
    /**
     * List the full TikTok LIVE gift catalog, paginated.  This is a special route, it does NOT fetch data live, and therefore does not count to your hourly/daily rate limits.
     * @param {number} [pageSize] Results per page (1–100, server-clamped). Defaults to 50.
     * @param {number} [pageNumber] 1-based page number. Defaults to 1.
     * @param {GiftCatalogOrderBy} [orderBy] Sort order for the catalog. Defaults to price ascending.
     * @param {boolean} [ascending] Whether to sort ascending or descending. Defaults to true.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWebcastGifts(pageSize?: number, pageNumber?: number, orderBy?: GiftCatalogOrderBy, ascending?: boolean, options?: RawAxiosRequestConfig) {
        return TikTokLIVEGiftsApiFp(this.configuration).listWebcastGifts(pageSize, pageNumber, orderBy, ascending, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a single TikTok LIVE gift by its numeric gift ID.  This is a special route, it does NOT fetch data live, and therefore does not count to your hourly/daily rate limits.
     * @param {number} giftId The numeric gift ID to look up
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveWebcastGift(giftId: number, options?: RawAxiosRequestConfig) {
        return TikTokLIVEGiftsApiFp(this.configuration).retrieveWebcastGift(giftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve Webcast gifts for a given region
     * @param {PooledProxyRegion} [region] The region to fetch gifts for
     * @param {RetrieveWebcastGiftsWebcastLanguageEnum} [webcastLanguage] Webcast language for locale-based fields
     * @param {boolean} [redirect] Whether to redirect directly or return a JSON response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveWebcastGifts(region?: PooledProxyRegion, webcastLanguage?: RetrieveWebcastGiftsWebcastLanguageEnum, redirect?: boolean, options?: RawAxiosRequestConfig) {
        return TikTokLIVEGiftsApiFp(this.configuration).retrieveWebcastGifts(region, webcastLanguage, redirect, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search the TikTok LIVE gift catalogue by gift name.  This is a special route, it does NOT fetch data live, and therefore does not count to your hourly/daily rate limits.
     * @param {string} query The search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchWebcastGifts(query: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEGiftsApiFp(this.configuration).searchWebcastGifts(query, options).then((request) => request(this.axios, this.basePath));
    }
}

export const RetrieveWebcastGiftsWebcastLanguageEnum = {
    En: 'en',
} as const;
export type RetrieveWebcastGiftsWebcastLanguageEnum = typeof RetrieveWebcastGiftsWebcastLanguageEnum[keyof typeof RetrieveWebcastGiftsWebcastLanguageEnum];


/**
 * TikTokLIVEModerationApi - axios parameter creator
 */
export const TikTokLIVEModerationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a sensitive word to a TikTok LIVE room\'s filter list.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} word The sensitive word to add
         * @param {string} secAnchorId The sec_anchor_id of the room owner
         * @param {string} roomId The room ID of the livestream
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSensitiveWord: async (word: string, secAnchorId: string, roomId: string, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'word' is not null or undefined
            assertParamExists('addSensitiveWord', 'word', word)
            // verify required parameter 'secAnchorId' is not null or undefined
            assertParamExists('addSensitiveWord', 'secAnchorId', secAnchorId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('addSensitiveWord', 'roomId', roomId)
            const localVarPath = `/webcast/rooms/{room_id}/moderation/sensitive-words`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (word !== undefined) {
                localVarQueryParameter['word'] = word;
            }

            if (secAnchorId !== undefined) {
                localVarQueryParameter['sec_anchor_id'] = secAnchorId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a sensitive word from a TikTok LIVE room\'s filter list.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} wordId The ID of the sensitive word to delete
         * @param {string} secAnchorId The sec_anchor_id of the room owner
         * @param {string} roomId The room ID of the livestream
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSensitiveWord: async (wordId: string, secAnchorId: string, roomId: string, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wordId' is not null or undefined
            assertParamExists('deleteSensitiveWord', 'wordId', wordId)
            // verify required parameter 'secAnchorId' is not null or undefined
            assertParamExists('deleteSensitiveWord', 'secAnchorId', secAnchorId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('deleteSensitiveWord', 'roomId', roomId)
            const localVarPath = `/webcast/rooms/{room_id}/moderation/sensitive-words`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (wordId !== undefined) {
                localVarQueryParameter['word_id'] = wordId;
            }

            if (secAnchorId !== undefined) {
                localVarQueryParameter['sec_anchor_id'] = secAnchorId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the list of sensitive words for a TikTok LIVE room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} secAnchorId The sec_anchor_id of the room owner
         * @param {string} roomId The room ID of the livestream
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensitiveWords: async (secAnchorId: string, roomId: string, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'secAnchorId' is not null or undefined
            assertParamExists('getSensitiveWords', 'secAnchorId', secAnchorId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getSensitiveWords', 'roomId', roomId)
            const localVarPath = `/webcast/rooms/{room_id}/moderation/sensitive-words`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (secAnchorId !== undefined) {
                localVarQueryParameter['sec_anchor_id'] = secAnchorId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Kick a user from a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} tiktokUserId The numeric user ID for the individual to kick
         * @param {string} [commentMsgId] Optional comment message ID that triggered the kick
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kickRoomUser: async (roomId: string, tiktokUserId: string, commentMsgId?: string, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('kickRoomUser', 'roomId', roomId)
            // verify required parameter 'tiktokUserId' is not null or undefined
            assertParamExists('kickRoomUser', 'tiktokUserId', tiktokUserId)
            const localVarPath = `/webcast/rooms/{room_id}/moderation/bans`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (tiktokUserId !== undefined) {
                localVarQueryParameter['tiktok_user_id'] = tiktokUserId;
            }

            if (commentMsgId !== undefined) {
                localVarQueryParameter['comment_msg_id'] = commentMsgId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mute a user in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} userId The user ID to mute
         * @param {MuteDuration} [duration] Mute duration in seconds (-1 &#x3D; permanent, 5, 30, 60, 300)
         * @param {number} [commentMsgId] Optional comment message ID that triggered the mute
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        muteRoomUser: async (roomId: string, userId: string, duration?: MuteDuration, commentMsgId?: number, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('muteRoomUser', 'roomId', roomId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('muteRoomUser', 'userId', userId)
            const localVarPath = `/webcast/rooms/{room_id}/moderation/mutes`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (duration !== undefined) {
                localVarQueryParameter['duration'] = duration;
            }

            if (commentMsgId !== undefined) {
                localVarQueryParameter['comment_msg_id'] = commentMsgId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the list of banned users in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {number} [page] Page number for pagination
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomBannedUsers: async (roomId: string, page?: number, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('retrieveRoomBannedUsers', 'roomId', roomId)
            const localVarPath = `/webcast/rooms/{room_id}/moderation/bans`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the list of muted users in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {number} [page] Page number for pagination
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomMutedUsers: async (roomId: string, page?: number, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('retrieveRoomMutedUsers', 'roomId', roomId)
            const localVarPath = `/webcast/rooms/{room_id}/moderation/mutes`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle comments on/off in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {boolean} enabled Whether comments should be enabled (true) or disabled (false)
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleRoomComments: async (roomId: string, enabled: boolean, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('toggleRoomComments', 'roomId', roomId)
            // verify required parameter 'enabled' is not null or undefined
            assertParamExists('toggleRoomComments', 'enabled', enabled)
            const localVarPath = `/webcast/rooms/{room_id}/moderation/toggle_comments`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unkick a user from a livestream room (allow them back).  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} tiktokUserId The numeric user ID of the person to unkick
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unbanRoomUser: async (roomId: string, tiktokUserId: string, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('unbanRoomUser', 'roomId', roomId)
            // verify required parameter 'tiktokUserId' is not null or undefined
            assertParamExists('unbanRoomUser', 'tiktokUserId', tiktokUserId)
            const localVarPath = `/webcast/rooms/{room_id}/moderation/bans`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (tiktokUserId !== undefined) {
                localVarQueryParameter['tiktok_user_id'] = tiktokUserId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unmute a user in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} userId The user ID to unmute
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmuteRoomUser: async (roomId: string, userId: string, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('unmuteRoomUser', 'roomId', roomId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('unmuteRoomUser', 'userId', userId)
            const localVarPath = `/webcast/rooms/{room_id}/moderation/mutes`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokLIVEModerationApi - functional programming interface
 */
export const TikTokLIVEModerationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokLIVEModerationApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a sensitive word to a TikTok LIVE room\'s filter list.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} word The sensitive word to add
         * @param {string} secAnchorId The sec_anchor_id of the room owner
         * @param {string} roomId The room ID of the livestream
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSensitiveWord(word: string, secAnchorId: string, roomId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomAddSensitiveWordAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSensitiveWord(word, secAnchorId, roomId, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEModerationApi.addSensitiveWord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a sensitive word from a TikTok LIVE room\'s filter list.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} wordId The ID of the sensitive word to delete
         * @param {string} secAnchorId The sec_anchor_id of the room owner
         * @param {string} roomId The room ID of the livestream
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSensitiveWord(wordId: string, secAnchorId: string, roomId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomDelSensitiveWordAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSensitiveWord(wordId, secAnchorId, roomId, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEModerationApi.deleteSensitiveWord']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the list of sensitive words for a TikTok LIVE room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} secAnchorId The sec_anchor_id of the room owner
         * @param {string} roomId The room ID of the livestream
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSensitiveWords(secAnchorId: string, roomId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomGetSensitiveWordsAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSensitiveWords(secAnchorId, roomId, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEModerationApi.getSensitiveWords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Kick a user from a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} tiktokUserId The numeric user ID for the individual to kick
         * @param {string} [commentMsgId] Optional comment message ID that triggered the kick
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kickRoomUser(roomId: string, tiktokUserId: string, commentMsgId?: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomKickUserAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kickRoomUser(roomId, tiktokUserId, commentMsgId, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEModerationApi.kickRoomUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mute a user in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} userId The user ID to mute
         * @param {MuteDuration} [duration] Mute duration in seconds (-1 &#x3D; permanent, 5, 30, 60, 300)
         * @param {number} [commentMsgId] Optional comment message ID that triggered the mute
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async muteRoomUser(roomId: string, userId: string, duration?: MuteDuration, commentMsgId?: number, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomMuteUserAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.muteRoomUser(roomId, userId, duration, commentMsgId, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEModerationApi.muteRoomUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the list of banned users in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {number} [page] Page number for pagination
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveRoomBannedUsers(roomId: string, page?: number, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomKickedUsersAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveRoomBannedUsers(roomId, page, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEModerationApi.retrieveRoomBannedUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the list of muted users in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {number} [page] Page number for pagination
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveRoomMutedUsers(roomId: string, page?: number, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomMutedUsersAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveRoomMutedUsers(roomId, page, xOauthToken, xCookieHeader, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEModerationApi.retrieveRoomMutedUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle comments on/off in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {boolean} enabled Whether comments should be enabled (true) or disabled (false)
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleRoomComments(roomId: string, enabled: boolean, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomCommentsToggleAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleRoomComments(roomId, enabled, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEModerationApi.toggleRoomComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unkick a user from a livestream room (allow them back).  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} tiktokUserId The numeric user ID of the person to unkick
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unbanRoomUser(roomId: string, tiktokUserId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomUnkickUserAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unbanRoomUser(roomId, tiktokUserId, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEModerationApi.unbanRoomUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unmute a user in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} userId The user ID to unmute
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unmuteRoomUser(roomId: string, userId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomUnmuteUserAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unmuteRoomUser(roomId, userId, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVEModerationApi.unmuteRoomUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokLIVEModerationApi - factory interface
 */
export const TikTokLIVEModerationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokLIVEModerationApiFp(configuration)
    return {
        /**
         * Add a sensitive word to a TikTok LIVE room\'s filter list.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} word The sensitive word to add
         * @param {string} secAnchorId The sec_anchor_id of the room owner
         * @param {string} roomId The room ID of the livestream
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSensitiveWord(word: string, secAnchorId: string, roomId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomAddSensitiveWordAPIResponse> {
            return localVarFp.addSensitiveWord(word, secAnchorId, roomId, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a sensitive word from a TikTok LIVE room\'s filter list.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} wordId The ID of the sensitive word to delete
         * @param {string} secAnchorId The sec_anchor_id of the room owner
         * @param {string} roomId The room ID of the livestream
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSensitiveWord(wordId: string, secAnchorId: string, roomId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomDelSensitiveWordAPIResponse> {
            return localVarFp.deleteSensitiveWord(wordId, secAnchorId, roomId, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the list of sensitive words for a TikTok LIVE room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} secAnchorId The sec_anchor_id of the room owner
         * @param {string} roomId The room ID of the livestream
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSensitiveWords(secAnchorId: string, roomId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomGetSensitiveWordsAPIResponse> {
            return localVarFp.getSensitiveWords(secAnchorId, roomId, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
        /**
         * Kick a user from a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} tiktokUserId The numeric user ID for the individual to kick
         * @param {string} [commentMsgId] Optional comment message ID that triggered the kick
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kickRoomUser(roomId: string, tiktokUserId: string, commentMsgId?: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomKickUserAPIResponse> {
            return localVarFp.kickRoomUser(roomId, tiktokUserId, commentMsgId, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
        /**
         * Mute a user in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} userId The user ID to mute
         * @param {MuteDuration} [duration] Mute duration in seconds (-1 &#x3D; permanent, 5, 30, 60, 300)
         * @param {number} [commentMsgId] Optional comment message ID that triggered the mute
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        muteRoomUser(roomId: string, userId: string, duration?: MuteDuration, commentMsgId?: number, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomMuteUserAPIResponse> {
            return localVarFp.muteRoomUser(roomId, userId, duration, commentMsgId, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the list of banned users in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {number} [page] Page number for pagination
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomBannedUsers(roomId: string, page?: number, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomKickedUsersAPIResponse> {
            return localVarFp.retrieveRoomBannedUsers(roomId, page, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the list of muted users in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {number} [page] Page number for pagination
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {RouteImageSource} [xImageSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomMutedUsers(roomId: string, page?: number, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<RoomMutedUsersAPIResponse> {
            return localVarFp.retrieveRoomMutedUsers(roomId, page, xOauthToken, xCookieHeader, xImageSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle comments on/off in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {boolean} enabled Whether comments should be enabled (true) or disabled (false)
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleRoomComments(roomId: string, enabled: boolean, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomCommentsToggleAPIResponse> {
            return localVarFp.toggleRoomComments(roomId, enabled, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
        /**
         * Unkick a user from a livestream room (allow them back).  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} tiktokUserId The numeric user ID of the person to unkick
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unbanRoomUser(roomId: string, tiktokUserId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomUnkickUserAPIResponse> {
            return localVarFp.unbanRoomUser(roomId, tiktokUserId, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
        /**
         * Unmute a user in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID of the livestream
         * @param {string} userId The user ID to unmute
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmuteRoomUser(roomId: string, userId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoomUnmuteUserAPIResponse> {
            return localVarFp.unmuteRoomUser(roomId, userId, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokLIVEModerationApi - object-oriented interface
 */
export class TikTokLIVEModerationApi extends BaseAPI {
    /**
     * Add a sensitive word to a TikTok LIVE room\'s filter list.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} word The sensitive word to add
     * @param {string} secAnchorId The sec_anchor_id of the room owner
     * @param {string} roomId The room ID of the livestream
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addSensitiveWord(word: string, secAnchorId: string, roomId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEModerationApiFp(this.configuration).addSensitiveWord(word, secAnchorId, roomId, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a sensitive word from a TikTok LIVE room\'s filter list.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} wordId The ID of the sensitive word to delete
     * @param {string} secAnchorId The sec_anchor_id of the room owner
     * @param {string} roomId The room ID of the livestream
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSensitiveWord(wordId: string, secAnchorId: string, roomId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEModerationApiFp(this.configuration).deleteSensitiveWord(wordId, secAnchorId, roomId, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the list of sensitive words for a TikTok LIVE room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} secAnchorId The sec_anchor_id of the room owner
     * @param {string} roomId The room ID of the livestream
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSensitiveWords(secAnchorId: string, roomId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEModerationApiFp(this.configuration).getSensitiveWords(secAnchorId, roomId, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Kick a user from a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} roomId The room ID of the livestream
     * @param {string} tiktokUserId The numeric user ID for the individual to kick
     * @param {string} [commentMsgId] Optional comment message ID that triggered the kick
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public kickRoomUser(roomId: string, tiktokUserId: string, commentMsgId?: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEModerationApiFp(this.configuration).kickRoomUser(roomId, tiktokUserId, commentMsgId, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mute a user in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} roomId The room ID of the livestream
     * @param {string} userId The user ID to mute
     * @param {MuteDuration} [duration] Mute duration in seconds (-1 &#x3D; permanent, 5, 30, 60, 300)
     * @param {number} [commentMsgId] Optional comment message ID that triggered the mute
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public muteRoomUser(roomId: string, userId: string, duration?: MuteDuration, commentMsgId?: number, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEModerationApiFp(this.configuration).muteRoomUser(roomId, userId, duration, commentMsgId, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the list of banned users in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} roomId The room ID of the livestream
     * @param {number} [page] Page number for pagination
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveRoomBannedUsers(roomId: string, page?: number, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEModerationApiFp(this.configuration).retrieveRoomBannedUsers(roomId, page, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the list of muted users in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} roomId The room ID of the livestream
     * @param {number} [page] Page number for pagination
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {RouteImageSource} [xImageSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveRoomMutedUsers(roomId: string, page?: number, xOauthToken?: string, xCookieHeader?: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokLIVEModerationApiFp(this.configuration).retrieveRoomMutedUsers(roomId, page, xOauthToken, xCookieHeader, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle comments on/off in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} roomId The room ID of the livestream
     * @param {boolean} enabled Whether comments should be enabled (true) or disabled (false)
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public toggleRoomComments(roomId: string, enabled: boolean, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEModerationApiFp(this.configuration).toggleRoomComments(roomId, enabled, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unkick a user from a livestream room (allow them back).  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} roomId The room ID of the livestream
     * @param {string} tiktokUserId The numeric user ID of the person to unkick
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unbanRoomUser(roomId: string, tiktokUserId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEModerationApiFp(this.configuration).unbanRoomUser(roomId, tiktokUserId, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unmute a user in a livestream room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} roomId The room ID of the livestream
     * @param {string} userId The user ID to unmute
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unmuteRoomUser(roomId: string, userId: string, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVEModerationApiFp(this.configuration).unmuteRoomUser(roomId, userId, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TikTokLIVERankingsApi - axios parameter creator
 */
export const TikTokLIVERankingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the list of dates that have leaderboard data for a given rank type and region.  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {AvailableWebcastRankName} rankName 
         * @param {string} region The region to query (or \&quot;WW\&quot; for worldwide).
         * @param {RankingLeagueName} [league] League level filter (e.g. \&quot;D5\&quot;, \&quot;A1\&quot;). Required for RANKING_LEAGUE, must not be provided for other rank types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDates: async (rankName: AvailableWebcastRankName, region: string, league?: RankingLeagueName, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rankName' is not null or undefined
            assertParamExists('getAvailableDates', 'rankName', rankName)
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getAvailableDates', 'region', region)
            const localVarPath = `/webcast/rankings/catalog/leaderboards/{region}/{rank_name}/dates`
                .replace('{rank_name}', encodeURIComponent(String(rankName)))
                .replace('{region}', encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (league !== undefined) {
                localVarQueryParameter['league'] = league;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the available ranking types and league tiers for each tracked region, based on each leaderboard\'s most recent day of data in the ranking service (boards with no data for several days age out of the catalog).  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableRankings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/webcast/rankings/catalog/leaderboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the most recent leaderboard snapshot for a given rank type, region, and date.  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {AvailableWebcastRankName} rankName 
         * @param {string} region The region to query (or \&quot;WW\&quot; for worldwide).
         * @param {string} [date] The UTC date to retrieve the snapshot for (e.g. \&quot;2026-03-09\&quot;). Omitted &#x3D; the board\&#39;s most recent snapshot (matching what the catalog advertises).
         * @param {RankingLeagueName} [league] Optional league level filter (e.g. \&quot;D5\&quot;, \&quot;A1\&quot;). Only applicable to RANKING_LEAGUE.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderboard: async (rankName: AvailableWebcastRankName, region: string, date?: string, league?: RankingLeagueName, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rankName' is not null or undefined
            assertParamExists('getLeaderboard', 'rankName', rankName)
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getLeaderboard', 'region', region)
            const localVarPath = `/webcast/rankings/catalog/leaderboards/{region}/{rank_name}`
                .replace('{rank_name}', encodeURIComponent(String(rankName)))
                .replace('{region}', encodeURIComponent(String(region)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            if (league !== undefined) {
                localVarQueryParameter['league'] = league;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a creator\'s daily standing on a given board over a UTC date range, oldest first.  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {AvailableWebcastRankName} rankName 
         * @param {string} region The leaderboard region (e.g. \&quot;US\&quot;).
         * @param {string} anchorId TikTok numeric user id of the creator.
         * @param {string} from Start of the UTC date range, inclusive (e.g. \&quot;2026-03-01\&quot;).
         * @param {string} to End of the UTC date range, inclusive (e.g. \&quot;2026-03-31\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserHistory: async (rankName: AvailableWebcastRankName, region: string, anchorId: string, from: string, to: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rankName' is not null or undefined
            assertParamExists('getUserHistory', 'rankName', rankName)
            // verify required parameter 'region' is not null or undefined
            assertParamExists('getUserHistory', 'region', region)
            // verify required parameter 'anchorId' is not null or undefined
            assertParamExists('getUserHistory', 'anchorId', anchorId)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getUserHistory', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getUserHistory', 'to', to)
            const localVarPath = `/webcast/rankings/catalog/leaderboards/{region}/{rank_name}/anchors/{anchor_id}/history`
                .replace('{rank_name}', encodeURIComponent(String(rankName)))
                .replace('{region}', encodeURIComponent(String(region)))
                .replace('{anchor_id}', encodeURIComponent(String(anchorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Discovery: The leaderboards a creator appears on within a UTC date range, returned as a map of region to rank_types.  Rate limited to 30 requests/min. Does NOT count towards normal API limits.
         * @param {string} anchorId TikTok numeric user id of the creator.
         * @param {string} from Start of the UTC date range, inclusive (e.g. \&quot;2026-03-01\&quot;).
         * @param {string} to End of the UTC date range, inclusive (e.g. \&quot;2026-03-31\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLeaderboardsOverTimespan: async (anchorId: string, from: string, to: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anchorId' is not null or undefined
            assertParamExists('getUserLeaderboardsOverTimespan', 'anchorId', anchorId)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getUserLeaderboardsOverTimespan', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getUserLeaderboardsOverTimespan', 'to', to)
            const localVarPath = `/webcast/rankings/catalog/anchors/{anchor_id}/rank_names`
                .replace('{anchor_id}', encodeURIComponent(String(anchorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for users in the rankings data by username or nickname prefix.  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {string} query The username or nickname substring to search for (minimum 3 characters).
         * @param {number} [limit] Maximum number of results to return (default 1, max 10).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser: async (query: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchUser', 'query', query)
            const localVarPath = `/webcast/rankings/catalog/anchors/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokLIVERankingsApi - functional programming interface
 */
export const TikTokLIVERankingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokLIVERankingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the list of dates that have leaderboard data for a given rank type and region.  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {AvailableWebcastRankName} rankName 
         * @param {string} region The region to query (or \&quot;WW\&quot; for worldwide).
         * @param {RankingLeagueName} [league] League level filter (e.g. \&quot;D5\&quot;, \&quot;A1\&quot;). Required for RANKING_LEAGUE, must not be provided for other rank types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableDates(rankName: AvailableWebcastRankName, region: string, league?: RankingLeagueName, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableDatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableDates(rankName, region, league, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVERankingsApi.getAvailableDates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the available ranking types and league tiers for each tracked region, based on each leaderboard\'s most recent day of data in the ranking service (boards with no data for several days age out of the catalog).  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableRankings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableRankingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableRankings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVERankingsApi.getAvailableRankings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the most recent leaderboard snapshot for a given rank type, region, and date.  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {AvailableWebcastRankName} rankName 
         * @param {string} region The region to query (or \&quot;WW\&quot; for worldwide).
         * @param {string} [date] The UTC date to retrieve the snapshot for (e.g. \&quot;2026-03-09\&quot;). Omitted &#x3D; the board\&#39;s most recent snapshot (matching what the catalog advertises).
         * @param {RankingLeagueName} [league] Optional league level filter (e.g. \&quot;D5\&quot;, \&quot;A1\&quot;). Only applicable to RANKING_LEAGUE.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeaderboard(rankName: AvailableWebcastRankName, region: string, date?: string, league?: RankingLeagueName, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaderboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeaderboard(rankName, region, date, league, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVERankingsApi.getLeaderboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a creator\'s daily standing on a given board over a UTC date range, oldest first.  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {AvailableWebcastRankName} rankName 
         * @param {string} region The leaderboard region (e.g. \&quot;US\&quot;).
         * @param {string} anchorId TikTok numeric user id of the creator.
         * @param {string} from Start of the UTC date range, inclusive (e.g. \&quot;2026-03-01\&quot;).
         * @param {string} to End of the UTC date range, inclusive (e.g. \&quot;2026-03-31\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserHistory(rankName: AvailableWebcastRankName, region: string, anchorId: string, from: string, to: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserHistory(rankName, region, anchorId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVERankingsApi.getUserHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Discovery: The leaderboards a creator appears on within a UTC date range, returned as a map of region to rank_types.  Rate limited to 30 requests/min. Does NOT count towards normal API limits.
         * @param {string} anchorId TikTok numeric user id of the creator.
         * @param {string} from Start of the UTC date range, inclusive (e.g. \&quot;2026-03-01\&quot;).
         * @param {string} to End of the UTC date range, inclusive (e.g. \&quot;2026-03-31\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserLeaderboardsOverTimespan(anchorId: string, from: string, to: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLeaderboardsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserLeaderboardsOverTimespan(anchorId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVERankingsApi.getUserLeaderboardsOverTimespan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for users in the rankings data by username or nickname prefix.  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {string} query The username or nickname substring to search for (minimum 3 characters).
         * @param {number} [limit] Maximum number of results to return (default 1, max 10).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUser(query: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUser(query, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVERankingsApi.searchUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokLIVERankingsApi - factory interface
 */
export const TikTokLIVERankingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokLIVERankingsApiFp(configuration)
    return {
        /**
         * Retrieve the list of dates that have leaderboard data for a given rank type and region.  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {AvailableWebcastRankName} rankName 
         * @param {string} region The region to query (or \&quot;WW\&quot; for worldwide).
         * @param {RankingLeagueName} [league] League level filter (e.g. \&quot;D5\&quot;, \&quot;A1\&quot;). Required for RANKING_LEAGUE, must not be provided for other rank types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDates(rankName: AvailableWebcastRankName, region: string, league?: RankingLeagueName, options?: RawAxiosRequestConfig): AxiosPromise<AvailableDatesResponse> {
            return localVarFp.getAvailableDates(rankName, region, league, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the available ranking types and league tiers for each tracked region, based on each leaderboard\'s most recent day of data in the ranking service (boards with no data for several days age out of the catalog).  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableRankings(options?: RawAxiosRequestConfig): AxiosPromise<AvailableRankingsResponse> {
            return localVarFp.getAvailableRankings(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the most recent leaderboard snapshot for a given rank type, region, and date.  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {AvailableWebcastRankName} rankName 
         * @param {string} region The region to query (or \&quot;WW\&quot; for worldwide).
         * @param {string} [date] The UTC date to retrieve the snapshot for (e.g. \&quot;2026-03-09\&quot;). Omitted &#x3D; the board\&#39;s most recent snapshot (matching what the catalog advertises).
         * @param {RankingLeagueName} [league] Optional league level filter (e.g. \&quot;D5\&quot;, \&quot;A1\&quot;). Only applicable to RANKING_LEAGUE.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderboard(rankName: AvailableWebcastRankName, region: string, date?: string, league?: RankingLeagueName, options?: RawAxiosRequestConfig): AxiosPromise<LeaderboardResponse> {
            return localVarFp.getLeaderboard(rankName, region, date, league, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a creator\'s daily standing on a given board over a UTC date range, oldest first.  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {AvailableWebcastRankName} rankName 
         * @param {string} region The leaderboard region (e.g. \&quot;US\&quot;).
         * @param {string} anchorId TikTok numeric user id of the creator.
         * @param {string} from Start of the UTC date range, inclusive (e.g. \&quot;2026-03-01\&quot;).
         * @param {string} to End of the UTC date range, inclusive (e.g. \&quot;2026-03-31\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserHistory(rankName: AvailableWebcastRankName, region: string, anchorId: string, from: string, to: string, options?: RawAxiosRequestConfig): AxiosPromise<UserHistoryResponse> {
            return localVarFp.getUserHistory(rankName, region, anchorId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Discovery: The leaderboards a creator appears on within a UTC date range, returned as a map of region to rank_types.  Rate limited to 30 requests/min. Does NOT count towards normal API limits.
         * @param {string} anchorId TikTok numeric user id of the creator.
         * @param {string} from Start of the UTC date range, inclusive (e.g. \&quot;2026-03-01\&quot;).
         * @param {string} to End of the UTC date range, inclusive (e.g. \&quot;2026-03-31\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLeaderboardsOverTimespan(anchorId: string, from: string, to: string, options?: RawAxiosRequestConfig): AxiosPromise<UserLeaderboardsResponse> {
            return localVarFp.getUserLeaderboardsOverTimespan(anchorId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for users in the rankings data by username or nickname prefix.  Requests to catalogue endpoints do NOT count towards normal API limits.
         * @param {string} query The username or nickname substring to search for (minimum 3 characters).
         * @param {number} [limit] Maximum number of results to return (default 1, max 10).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser(query: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<SearchUserResponse> {
            return localVarFp.searchUser(query, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokLIVERankingsApi - object-oriented interface
 */
export class TikTokLIVERankingsApi extends BaseAPI {
    /**
     * Retrieve the list of dates that have leaderboard data for a given rank type and region.  Requests to catalogue endpoints do NOT count towards normal API limits.
     * @param {AvailableWebcastRankName} rankName 
     * @param {string} region The region to query (or \&quot;WW\&quot; for worldwide).
     * @param {RankingLeagueName} [league] League level filter (e.g. \&quot;D5\&quot;, \&quot;A1\&quot;). Required for RANKING_LEAGUE, must not be provided for other rank types.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAvailableDates(rankName: AvailableWebcastRankName, region: string, league?: RankingLeagueName, options?: RawAxiosRequestConfig) {
        return TikTokLIVERankingsApiFp(this.configuration).getAvailableDates(rankName, region, league, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the available ranking types and league tiers for each tracked region, based on each leaderboard\'s most recent day of data in the ranking service (boards with no data for several days age out of the catalog).  Requests to catalogue endpoints do NOT count towards normal API limits.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAvailableRankings(options?: RawAxiosRequestConfig) {
        return TikTokLIVERankingsApiFp(this.configuration).getAvailableRankings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the most recent leaderboard snapshot for a given rank type, region, and date.  Requests to catalogue endpoints do NOT count towards normal API limits.
     * @param {AvailableWebcastRankName} rankName 
     * @param {string} region The region to query (or \&quot;WW\&quot; for worldwide).
     * @param {string} [date] The UTC date to retrieve the snapshot for (e.g. \&quot;2026-03-09\&quot;). Omitted &#x3D; the board\&#39;s most recent snapshot (matching what the catalog advertises).
     * @param {RankingLeagueName} [league] Optional league level filter (e.g. \&quot;D5\&quot;, \&quot;A1\&quot;). Only applicable to RANKING_LEAGUE.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLeaderboard(rankName: AvailableWebcastRankName, region: string, date?: string, league?: RankingLeagueName, options?: RawAxiosRequestConfig) {
        return TikTokLIVERankingsApiFp(this.configuration).getLeaderboard(rankName, region, date, league, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a creator\'s daily standing on a given board over a UTC date range, oldest first.  Requests to catalogue endpoints do NOT count towards normal API limits.
     * @param {AvailableWebcastRankName} rankName 
     * @param {string} region The leaderboard region (e.g. \&quot;US\&quot;).
     * @param {string} anchorId TikTok numeric user id of the creator.
     * @param {string} from Start of the UTC date range, inclusive (e.g. \&quot;2026-03-01\&quot;).
     * @param {string} to End of the UTC date range, inclusive (e.g. \&quot;2026-03-31\&quot;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserHistory(rankName: AvailableWebcastRankName, region: string, anchorId: string, from: string, to: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVERankingsApiFp(this.configuration).getUserHistory(rankName, region, anchorId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Discovery: The leaderboards a creator appears on within a UTC date range, returned as a map of region to rank_types.  Rate limited to 30 requests/min. Does NOT count towards normal API limits.
     * @param {string} anchorId TikTok numeric user id of the creator.
     * @param {string} from Start of the UTC date range, inclusive (e.g. \&quot;2026-03-01\&quot;).
     * @param {string} to End of the UTC date range, inclusive (e.g. \&quot;2026-03-31\&quot;).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserLeaderboardsOverTimespan(anchorId: string, from: string, to: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVERankingsApiFp(this.configuration).getUserLeaderboardsOverTimespan(anchorId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for users in the rankings data by username or nickname prefix.  Requests to catalogue endpoints do NOT count towards normal API limits.
     * @param {string} query The username or nickname substring to search for (minimum 3 characters).
     * @param {number} [limit] Maximum number of results to return (default 1, max 10).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUser(query: string, limit?: number, options?: RawAxiosRequestConfig) {
        return TikTokLIVERankingsApiFp(this.configuration).searchUser(query, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TikTokLIVERoomsApi - axios parameter creator
 */
export const TikTokLIVERoomsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch the WebSocket URL & first payload for a TikTok LIVE Room given a Room ID.  **Authentication (Optional):** Anonymous access is supported. For authenticated requests, provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID to fetch the Webcast URL for.
         * @param {string} [client] The client library identifier. Used for metrics.
         * @param {string} [uniqueId] The unique ID of the TikTok user. Send this instead of a Room ID, if you\&#39;re an Enterprise user. Pass \&quot;0\&quot; to room_id.
         * @param {string} [cursor] Starting cursor for the webcast connection, if any
         * @param {string} [userAgent] Override the user agent used for signing and fetching
         * @param {boolean} [clientEnter] Whether the client enters a room after connecting, or if it\&#39;s done by query parameters
         * @param {PooledProxyRegion} [country] Country code to make the request from.
         * @param {WebcastFetchPlatform} [platform] Platform to connect with
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {string} [sessionId] Use x-oauth-token or x-cookie-header instead
         * @param {string} [ttTargetIdc] Use x-oauth-token or x-cookie-header instead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchWebcastURL: async (roomId: string, client?: string, uniqueId?: string, cursor?: string, userAgent?: string, clientEnter?: boolean, country?: PooledProxyRegion, platform?: WebcastFetchPlatform, xOauthToken?: string, xCookieHeader?: string, sessionId?: string, ttTargetIdc?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('fetchWebcastURL', 'roomId', roomId)
            const localVarPath = `/webcast/rooms/{room_id}/connect`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication jwt_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-jwt-key", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (uniqueId !== undefined) {
                localVarQueryParameter['unique_id'] = uniqueId;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (userAgent !== undefined) {
                localVarQueryParameter['user_agent'] = userAgent;
            }

            if (clientEnter !== undefined) {
                localVarQueryParameter['client_enter'] = clientEnter;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (ttTargetIdc !== undefined) {
                localVarQueryParameter['tt_target_idc'] = ttTargetIdc;
            }

            localVarHeaderParameter['Accept'] = 'application/protobuf,application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve room-specific TikTok LIVE gift data.  Returns the ordered gift list for a specific room, along with room-specific overrides (sponsor info, gallery status, panel visibility). Use this alongside the /webcast/gift_info endpoint which provides the full gift catalog.
         * @param {string} roomId The room ID of the TikTok LIVE session
         * @param {WebcastLanguage} [webcastLanguage] Webcast language for locale-based fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomGifts: async (roomId: string, webcastLanguage?: WebcastLanguage, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('retrieveRoomGifts', 'roomId', roomId)
            const localVarPath = `/webcast/rooms/{room_id}/gifts`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            if (webcastLanguage !== undefined) {
                localVarQueryParameter['webcast_language'] = webcastLanguage;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a chat to a TikTok LIVE room.  Either `targetRoomId` or `targetUniqueId` must be provided to identify the room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId Room ID
         * @param {SendRoomChatRequest} sendRoomChatRequest The payload configuration for sending a chat
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendRoomChat: async (roomId: string, sendRoomChatRequest: SendRoomChatRequest, xOauthToken?: string, xCookieHeader?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('sendRoomChat', 'roomId', roomId)
            // verify required parameter 'sendRoomChatRequest' is not null or undefined
            assertParamExists('sendRoomChat', 'sendRoomChatRequest', sendRoomChatRequest)
            const localVarPath = `/webcast/rooms/{room_id}/chat`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (xOauthToken != null) {
                localVarHeaderParameter['x-oauth-token'] = String(xOauthToken);
            }
            if (xCookieHeader != null) {
                localVarHeaderParameter['x-cookie-header'] = String(xCookieHeader);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendRoomChatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokLIVERoomsApi - functional programming interface
 */
export const TikTokLIVERoomsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokLIVERoomsApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch the WebSocket URL & first payload for a TikTok LIVE Room given a Room ID.  **Authentication (Optional):** Anonymous access is supported. For authenticated requests, provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID to fetch the Webcast URL for.
         * @param {string} [client] The client library identifier. Used for metrics.
         * @param {string} [uniqueId] The unique ID of the TikTok user. Send this instead of a Room ID, if you\&#39;re an Enterprise user. Pass \&quot;0\&quot; to room_id.
         * @param {string} [cursor] Starting cursor for the webcast connection, if any
         * @param {string} [userAgent] Override the user agent used for signing and fetching
         * @param {boolean} [clientEnter] Whether the client enters a room after connecting, or if it\&#39;s done by query parameters
         * @param {PooledProxyRegion} [country] Country code to make the request from.
         * @param {WebcastFetchPlatform} [platform] Platform to connect with
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {string} [sessionId] Use x-oauth-token or x-cookie-header instead
         * @param {string} [ttTargetIdc] Use x-oauth-token or x-cookie-header instead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchWebcastURL(roomId: string, client?: string, uniqueId?: string, cursor?: string, userAgent?: string, clientEnter?: boolean, country?: PooledProxyRegion, platform?: WebcastFetchPlatform, xOauthToken?: string, xCookieHeader?: string, sessionId?: string, ttTargetIdc?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchWebcastURL(roomId, client, uniqueId, cursor, userAgent, clientEnter, country, platform, xOauthToken, xCookieHeader, sessionId, ttTargetIdc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVERoomsApi.fetchWebcastURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve room-specific TikTok LIVE gift data.  Returns the ordered gift list for a specific room, along with room-specific overrides (sponsor info, gallery status, panel visibility). Use this alongside the /webcast/gift_info endpoint which provides the full gift catalog.
         * @param {string} roomId The room ID of the TikTok LIVE session
         * @param {WebcastLanguage} [webcastLanguage] Webcast language for locale-based fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveRoomGifts(roomId: string, webcastLanguage?: WebcastLanguage, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomGiftsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveRoomGifts(roomId, webcastLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVERoomsApi.retrieveRoomGifts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a chat to a TikTok LIVE room.  Either `targetRoomId` or `targetUniqueId` must be provided to identify the room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId Room ID
         * @param {SendRoomChatRequest} sendRoomChatRequest The payload configuration for sending a chat
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendRoomChat(roomId: string, sendRoomChatRequest: SendRoomChatRequest, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebcastRoomChatRouteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendRoomChat(roomId, sendRoomChatRequest, xOauthToken, xCookieHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokLIVERoomsApi.sendRoomChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokLIVERoomsApi - factory interface
 */
export const TikTokLIVERoomsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokLIVERoomsApiFp(configuration)
    return {
        /**
         * Fetch the WebSocket URL & first payload for a TikTok LIVE Room given a Room ID.  **Authentication (Optional):** Anonymous access is supported. For authenticated requests, provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId The room ID to fetch the Webcast URL for.
         * @param {string} [client] The client library identifier. Used for metrics.
         * @param {string} [uniqueId] The unique ID of the TikTok user. Send this instead of a Room ID, if you\&#39;re an Enterprise user. Pass \&quot;0\&quot; to room_id.
         * @param {string} [cursor] Starting cursor for the webcast connection, if any
         * @param {string} [userAgent] Override the user agent used for signing and fetching
         * @param {boolean} [clientEnter] Whether the client enters a room after connecting, or if it\&#39;s done by query parameters
         * @param {PooledProxyRegion} [country] Country code to make the request from.
         * @param {WebcastFetchPlatform} [platform] Platform to connect with
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {string} [sessionId] Use x-oauth-token or x-cookie-header instead
         * @param {string} [ttTargetIdc] Use x-oauth-token or x-cookie-header instead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchWebcastURL(roomId: string, client?: string, uniqueId?: string, cursor?: string, userAgent?: string, clientEnter?: boolean, country?: PooledProxyRegion, platform?: WebcastFetchPlatform, xOauthToken?: string, xCookieHeader?: string, sessionId?: string, ttTargetIdc?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.fetchWebcastURL(roomId, client, uniqueId, cursor, userAgent, clientEnter, country, platform, xOauthToken, xCookieHeader, sessionId, ttTargetIdc, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve room-specific TikTok LIVE gift data.  Returns the ordered gift list for a specific room, along with room-specific overrides (sponsor info, gallery status, panel visibility). Use this alongside the /webcast/gift_info endpoint which provides the full gift catalog.
         * @param {string} roomId The room ID of the TikTok LIVE session
         * @param {WebcastLanguage} [webcastLanguage] Webcast language for locale-based fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveRoomGifts(roomId: string, webcastLanguage?: WebcastLanguage, options?: RawAxiosRequestConfig): AxiosPromise<RoomGiftsResponse> {
            return localVarFp.retrieveRoomGifts(roomId, webcastLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a chat to a TikTok LIVE room.  Either `targetRoomId` or `targetUniqueId` must be provided to identify the room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
         * @param {string} roomId Room ID
         * @param {SendRoomChatRequest} sendRoomChatRequest The payload configuration for sending a chat
         * @param {string} [xOauthToken] OAuth access token for session resolution
         * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendRoomChat(roomId: string, sendRoomChatRequest: SendRoomChatRequest, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig): AxiosPromise<WebcastRoomChatRouteResponse> {
            return localVarFp.sendRoomChat(roomId, sendRoomChatRequest, xOauthToken, xCookieHeader, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokLIVERoomsApi - object-oriented interface
 */
export class TikTokLIVERoomsApi extends BaseAPI {
    /**
     * Fetch the WebSocket URL & first payload for a TikTok LIVE Room given a Room ID.  **Authentication (Optional):** Anonymous access is supported. For authenticated requests, provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} roomId The room ID to fetch the Webcast URL for.
     * @param {string} [client] The client library identifier. Used for metrics.
     * @param {string} [uniqueId] The unique ID of the TikTok user. Send this instead of a Room ID, if you\&#39;re an Enterprise user. Pass \&quot;0\&quot; to room_id.
     * @param {string} [cursor] Starting cursor for the webcast connection, if any
     * @param {string} [userAgent] Override the user agent used for signing and fetching
     * @param {boolean} [clientEnter] Whether the client enters a room after connecting, or if it\&#39;s done by query parameters
     * @param {PooledProxyRegion} [country] Country code to make the request from.
     * @param {WebcastFetchPlatform} [platform] Platform to connect with
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {string} [sessionId] Use x-oauth-token or x-cookie-header instead
     * @param {string} [ttTargetIdc] Use x-oauth-token or x-cookie-header instead
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fetchWebcastURL(roomId: string, client?: string, uniqueId?: string, cursor?: string, userAgent?: string, clientEnter?: boolean, country?: PooledProxyRegion, platform?: WebcastFetchPlatform, xOauthToken?: string, xCookieHeader?: string, sessionId?: string, ttTargetIdc?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVERoomsApiFp(this.configuration).fetchWebcastURL(roomId, client, uniqueId, cursor, userAgent, clientEnter, country, platform, xOauthToken, xCookieHeader, sessionId, ttTargetIdc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve room-specific TikTok LIVE gift data.  Returns the ordered gift list for a specific room, along with room-specific overrides (sponsor info, gallery status, panel visibility). Use this alongside the /webcast/gift_info endpoint which provides the full gift catalog.
     * @param {string} roomId The room ID of the TikTok LIVE session
     * @param {WebcastLanguage} [webcastLanguage] Webcast language for locale-based fields
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveRoomGifts(roomId: string, webcastLanguage?: WebcastLanguage, options?: RawAxiosRequestConfig) {
        return TikTokLIVERoomsApiFp(this.configuration).retrieveRoomGifts(roomId, webcastLanguage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a chat to a TikTok LIVE room.  Either `targetRoomId` or `targetUniqueId` must be provided to identify the room.  **Authentication:** Provide exactly one of the following headers: - `x-oauth-token`: An OAuth access token. The sessionId and ttTargetIdc are resolved from the stored OAuth session. [Read More](https://www.eulerstream.com/docs/oauth) - `x-cookie-header`: A cookie header string containing `sessionid` and `tt-target-idc` cookies from TikTok.
     * @param {string} roomId Room ID
     * @param {SendRoomChatRequest} sendRoomChatRequest The payload configuration for sending a chat
     * @param {string} [xOauthToken] OAuth access token for session resolution
     * @param {string} [xCookieHeader] Cookie header containing sessionid and tt-target-idc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendRoomChat(roomId: string, sendRoomChatRequest: SendRoomChatRequest, xOauthToken?: string, xCookieHeader?: string, options?: RawAxiosRequestConfig) {
        return TikTokLIVERoomsApiFp(this.configuration).sendRoomChat(roomId, sendRoomChatRequest, xOauthToken, xCookieHeader, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TikTokUsersApi - axios parameter creator
 */
export const TikTokUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve basic public profile info (avatars, nickname, region) for a TikTok user by their unique ID (handle).
         * @param {string} uniqueId The unique ID (handle) of the TikTok user.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTikTokUserBasic: async (uniqueId: string, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uniqueId' is not null or undefined
            assertParamExists('retrieveTikTokUserBasic', 'uniqueId', uniqueId)
            const localVarPath = `/tiktok/users/{unique_id}/basic`
                .replace('{unique_id}', encodeURIComponent(String(uniqueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve profile info (avatars, follow counts, verification) for a TikTok user by their numeric user ID.
         * @param {string} numericUserId The numeric TikTok user ID.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTikTokUserInfo: async (numericUserId: string, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numericUserId' is not null or undefined
            assertParamExists('retrieveTikTokUserInfo', 'numericUserId', numericUserId)
            const localVarPath = `/tiktok/users/{numeric_user_id}`
                .replace('{numeric_user_id}', encodeURIComponent(String(numericUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokUsersApi - functional programming interface
 */
export const TikTokUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve basic public profile info (avatars, nickname, region) for a TikTok user by their unique ID (handle).
         * @param {string} uniqueId The unique ID (handle) of the TikTok user.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveTikTokUserBasic(uniqueId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveTikTokUserBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveTikTokUserBasic(uniqueId, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokUsersApi.retrieveTikTokUserBasic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve profile info (avatars, follow counts, verification) for a TikTok user by their numeric user ID.
         * @param {string} numericUserId The numeric TikTok user ID.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveTikTokUserInfo(numericUserId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveTikTokUserInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveTikTokUserInfo(numericUserId, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokUsersApi.retrieveTikTokUserInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokUsersApi - factory interface
 */
export const TikTokUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokUsersApiFp(configuration)
    return {
        /**
         * Retrieve basic public profile info (avatars, nickname, region) for a TikTok user by their unique ID (handle).
         * @param {string} uniqueId The unique ID (handle) of the TikTok user.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTikTokUserBasic(uniqueId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveTikTokUserBasicResponse> {
            return localVarFp.retrieveTikTokUserBasic(uniqueId, xImageSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve profile info (avatars, follow counts, verification) for a TikTok user by their numeric user ID.
         * @param {string} numericUserId The numeric TikTok user ID.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTikTokUserInfo(numericUserId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveTikTokUserInfoResponse> {
            return localVarFp.retrieveTikTokUserInfo(numericUserId, xImageSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokUsersApi - object-oriented interface
 */
export class TikTokUsersApi extends BaseAPI {
    /**
     * Retrieve basic public profile info (avatars, nickname, region) for a TikTok user by their unique ID (handle).
     * @param {string} uniqueId The unique ID (handle) of the TikTok user.
     * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveTikTokUserBasic(uniqueId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokUsersApiFp(this.configuration).retrieveTikTokUserBasic(uniqueId, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve profile info (avatars, follow counts, verification) for a TikTok user by their numeric user ID.
     * @param {string} numericUserId The numeric TikTok user ID.
     * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveTikTokUserInfo(numericUserId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokUsersApiFp(this.configuration).retrieveTikTokUserInfo(numericUserId, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TikTokVideosApi - axios parameter creator
 */
export const TikTokVideosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve basic public info (thumbnail, description, hashtags, music, author) for a TikTok video by its numeric video ID.
         * @param {string} videoId The numeric TikTok video ID.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTikTokVideoBasic: async (videoId: string, xImageSource?: RouteImageSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoId' is not null or undefined
            assertParamExists('retrieveTikTokVideoBasic', 'videoId', videoId)
            const localVarPath = `/tiktok/videos/{video_id}/basic`
                .replace('{video_id}', encodeURIComponent(String(videoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            if (xImageSource != null) {
                localVarHeaderParameter['x-image-source'] = typeof xImageSource === 'string'
                    ? xImageSource
                    : JSON.stringify(xImageSource, replaceWithSerializableTypeIfNeeded);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokVideosApi - functional programming interface
 */
export const TikTokVideosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokVideosApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve basic public info (thumbnail, description, hashtags, music, author) for a TikTok video by its numeric video ID.
         * @param {string} videoId The numeric TikTok video ID.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveTikTokVideoBasic(videoId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveTikTokVideoBasicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveTikTokVideoBasic(videoId, xImageSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokVideosApi.retrieveTikTokVideoBasic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokVideosApi - factory interface
 */
export const TikTokVideosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokVideosApiFp(configuration)
    return {
        /**
         * Retrieve basic public info (thumbnail, description, hashtags, music, author) for a TikTok video by its numeric video ID.
         * @param {string} videoId The numeric TikTok video ID.
         * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTikTokVideoBasic(videoId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveTikTokVideoBasicResponse> {
            return localVarFp.retrieveTikTokVideoBasic(videoId, xImageSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokVideosApi - object-oriented interface
 */
export class TikTokVideosApi extends BaseAPI {
    /**
     * Retrieve basic public info (thumbnail, description, hashtags, music, author) for a TikTok video by its numeric video ID.
     * @param {string} videoId The numeric TikTok video ID.
     * @param {RouteImageSource} [xImageSource] Where returned image URLs are served from (ORIGIN, CDN, CDN_CNAME).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveTikTokVideoBasic(videoId: string, xImageSource?: RouteImageSource, options?: RawAxiosRequestConfig) {
        return TikTokVideosApiFp(this.configuration).retrieveTikTokVideoBasic(videoId, xImageSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TikTokWebSocketAPIApi - axios parameter creator
 */
export const TikTokWebSocketAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the currently connected WebSocket clients for your account.
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebSockets: async (accountId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getWebSockets', 'accountId', accountId)
            const localVarPath = `/webcast/websockets/{account_id}`
                .replace('{account_id}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the currently connected WebSocket clients for your account.
         * @param {number} accountId 
         * @param {string} websocketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebSocketState: async (accountId: number, websocketId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('retrieveWebSocketState', 'accountId', accountId)
            // verify required parameter 'websocketId' is not null or undefined
            assertParamExists('retrieveWebSocketState', 'websocketId', websocketId)
            const localVarPath = `/webcast/websockets/{account_id}/{websocket_id}`
                .replace('{account_id}', encodeURIComponent(String(accountId)))
                .replace('{websocket_id}', encodeURIComponent(String(websocketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key_query required
            await setApiKeyToObject(localVarQueryParameter, "apiKey", configuration)

            // authentication api_key_header required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TikTokWebSocketAPIApi - functional programming interface
 */
export const TikTokWebSocketAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TikTokWebSocketAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the currently connected WebSocket clients for your account.
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebSockets(accountId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveWebSocketsRouteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebSockets(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokWebSocketAPIApi.getWebSockets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the currently connected WebSocket clients for your account.
         * @param {number} accountId 
         * @param {string} websocketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveWebSocketState(accountId: number, websocketId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveWebSocketRouteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveWebSocketState(accountId, websocketId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TikTokWebSocketAPIApi.retrieveWebSocketState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TikTokWebSocketAPIApi - factory interface
 */
export const TikTokWebSocketAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TikTokWebSocketAPIApiFp(configuration)
    return {
        /**
         * Retrieve the currently connected WebSocket clients for your account.
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebSockets(accountId: number, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveWebSocketsRouteResponse> {
            return localVarFp.getWebSockets(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the currently connected WebSocket clients for your account.
         * @param {number} accountId 
         * @param {string} websocketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveWebSocketState(accountId: number, websocketId: string, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveWebSocketRouteResponse> {
            return localVarFp.retrieveWebSocketState(accountId, websocketId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TikTokWebSocketAPIApi - object-oriented interface
 */
export class TikTokWebSocketAPIApi extends BaseAPI {
    /**
     * Retrieve the currently connected WebSocket clients for your account.
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWebSockets(accountId: number, options?: RawAxiosRequestConfig) {
        return TikTokWebSocketAPIApiFp(this.configuration).getWebSockets(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the currently connected WebSocket clients for your account.
     * @param {number} accountId 
     * @param {string} websocketId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveWebSocketState(accountId: number, websocketId: string, options?: RawAxiosRequestConfig) {
        return TikTokWebSocketAPIApiFp(this.configuration).retrieveWebSocketState(accountId, websocketId, options).then((request) => request(this.axios, this.basePath));
    }
}



